import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: any;
};

export type AclAccess = ApplicationRecord & {
  __typename?: 'ACLAccess';
  aclTemplate?: Maybe<AclTemplateOptions>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  orgId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum AclTemplateOptions {
  Admin = 'ADMIN',
  JobManager = 'JOB_MANAGER',
  Personal = 'PERSONAL',
  ProPlus = 'PRO_PLUS'
}

export type Annotation = {
  __typename?: 'Annotation';
  /**
   * snappedHeight + 5 inches to account for sash (only for windows with 'W-'
   * name).For other annotation types, this equals to snapped_height. (Unit: inch)
   */
  adjustedHeight: Scalars['Float'];
  /**
   * snappedWidth + 5 inches to account for sash (only for windows with 'W-'
   * name).For other annotation types, this equals to snapped_width. (Unit: inch)
   */
  adjustedWidth: Scalars['Float'];
  /** Database id */
  annotationId: Scalars['ID'];
  /**
   * Actual area of the annotation, as opposed to width x height.For reclangular
   * annotations, this should equal original_width x original_height. (Unit: sqin)
   */
  area: Scalars['Float'];
  /** e.g. Door -> Door Package */
  directFace: Face;
  includeInMeasurements?: Maybe<Scalars['Boolean']>;
  /** e.g. Door -> Siding (via door package) */
  indirectFaces?: Maybe<Array<Face>>;
  labels?: Maybe<Array<Label>>;
  name?: Maybe<Scalars['String']>;
  /** origianl height on 3D model. (Unit: inch) */
  originalHeight: Scalars['Float'];
  /** origianl width on 3D model. (Unit: inch) */
  originalWidth: Scalars['Float'];
  partialAnnotations?: Maybe<Array<PartialAnnotation>>;
  productId: Scalars['Int'];
  /**
   * Windows: snapped height to other windows with a similar dimension;Doors:
   * snapped height to the closest standard door size.If no annotations with
   * similar sizes are found, this equals to original_height (Unit: inch)
   */
  snappedHeight: Scalars['Float'];
  /**
   * Windows: snapped width to other windows with a similar dimension;Doors:
   * snapped width to the closest standard door size.If no annotations with similar
   * sizes are found, this equals to original_width (Unit: inch)
   */
  snappedWidth: Scalars['Float'];
  /** Unique id assigned randomely to all annotations in the model.Sort index Can be found in skp as well */
  sortIndex: Scalars['Int'];
};

export type ApplicationRecord = {
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ApplicationRecordUuid = {
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type AppliedDiscount = ApplicationRecord & {
  __typename?: 'AppliedDiscount';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  details: Array<Scalars['String']>;
  expiration: Scalars['String'];
  /** Determines if the discount can still be used */
  expired: Scalars['Boolean'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** Human readable created at */
  redeemedOn: Scalars['String'];
  /** Remaining number of jobs this discount can be used for. Null means there is no limit. */
  remainingJobsCount?: Maybe<Scalars['Int']>;
  /** Determines if the partner subsidises the discount */
  subsidy: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type Area = {
  __typename?: 'Area';
  /** Combinded area of all facades in order. */
  facades: AreaBy;
  /** Combinded area of all openings in order. */
  openings: AreaBy;
  /** Combinded area of all facades in order. */
  total: AreaBy;
  /** Combinded area of all trim facades in order. */
  trim: AreaBy;
  /** Combinded area of all unknown facades in order. */
  unknown?: Maybe<AreaBy>;
};

export type AreaBy = {
  __typename?: 'AreaBy';
  /** Area of given type that is not siding. */
  other: Scalars['Int'];
  /** Area of given type that is siding. */
  siding: Scalars['Int'];
};

export type AuthenticationInfo = {
  __typename?: 'AuthenticationInfo';
  ssoEnabled: Scalars['Boolean'];
  ssoSpSigninUrl?: Maybe<Scalars['String']>;
  ssoStrictModeEnabled: Scalars['Boolean'];
};

export type AuthenticationResponse = {
  __typename?: 'AuthenticationResponse';
  jwt: Jwt;
  user: User;
};

export type BasePrice = ApplicationRecord & {
  __typename?: 'BasePrice';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  goodType: Scalars['String'];
  id: Scalars['Int'];
  partnerSubsidy: Scalars['Int'];
  planId: Scalars['Int'];
  /** Price in cents */
  price: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type BillableWallet = {
  __typename?: 'BillableWallet';
  allowedGoodTypes: Array<Scalars['String']>;
  org: OrgBasicInfo;
  preferred: Scalars['Boolean'];
  shared: Scalars['Boolean'];
  walletId: Scalars['Int'];
};

/**
 * All URLs here are signed S3 URLs for downloading a logo's image with different dimensions or format.
 * Image dimensions are in pixels. Image format is PNG.
 */
export type Brand = ApplicationRecord & {
  __typename?: 'Brand';
  clientBrandingLogoUrl?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  /**
   * Dimensions: 200x35
   * <br />
   * Format: png
   */
  logoNonretinaUrl?: Maybe<Scalars['String']>;
  /**
   * Dimensions: 400x70
   * <br />
   * Format: png
   */
  logoRetinaUrl?: Maybe<Scalars['String']>;
  /**
   * Dimensions: 115x20
   * <br />
   * Format: png
   */
  logoThumbUrl?: Maybe<Scalars['String']>;
  /**
   * This field generates a URL which can be used to upload a brand's logo. Only png files are supported.
   * The link expires 10 minutes after being created.
   */
  logoUploadUrl?: Maybe<Scalars['String']>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Format: png
   */
  logoUrl?: Maybe<Scalars['String']>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Format: png
   */
  placesLogoUrl?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
  tertiaryColor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum CameraIndices {
  FrontLeft = 'FRONT_LEFT',
  Front = 'FRONT',
  FrontRight = 'FRONT_RIGHT',
  BackRight = 'BACK_RIGHT',
  Back = 'BACK',
  BackLeft = 'BACK_LEFT',
  Roof = 'ROOF'
}

export type CameraInput = {
  position?: Maybe<CameraVectorInput>;
  rotation?: Maybe<CameraVectorInput>;
  aspect?: Maybe<Scalars['Float']>;
  fov?: Maybe<Scalars['Float']>;
};

export type CameraVectorInput = {
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};

export type CaptureRequest = ApplicationRecord & {
  __typename?: 'CaptureRequest';
  capturingUser?: Maybe<UserBasicInfo>;
  capturingUserEmail: Scalars['String'];
  capturingUserName: Scalars['String'];
  capturingUserPhone?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  displayRequestingOrg?: Maybe<OrgBasicInfo>;
  id: Scalars['Int'];
  identifier: Scalars['String'];
  jobId?: Maybe<Scalars['Int']>;
  requestingUser?: Maybe<UserBasicInfo>;
  signupType: CaptureRequestSignupTypes;
  state?: Maybe<CaptureRequestStates>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Arguments for job attributes when creating a capture request */
export type CaptureRequestJobArgs = {
  /**
   * This is any arbitrary string that clients want to use to identify jobs. Clients in this case means the actual
   * software clients that are uploading the job. For example: mobile applications, website, and any software that 3rd
   * parties build to interact with our system. This is typically used to help with the uploading process. Our uploading
   * process is asyncronous and does not return a Job ID when you upload. Including a client_identifier in your upload
   * and checking the client identifier of new jobs that enter your account is the only way to match up what you
   * uploaded with the resulting job. The given value must be globally unique.
   */
  clientIdentifier?: Maybe<Scalars['String']>;
  /** True if the contractor has checked the box to remind them to contact the customer. Default is false. */
  customerContact?: Maybe<Scalars['Boolean']>;
  /** True if the contractor has checked the box to only contact the customer by email. Default is false. */
  customerContactOnlyByEmail?: Maybe<Scalars['Boolean']>;
  /** The email address of the customer. Usually the homeowner. */
  customerEmail?: Maybe<Scalars['String']>;
  /** The name of the customer. Usually the homeowner. */
  customerName?: Maybe<Scalars['String']>;
  /** The phone number of the customer. Usually the homeowner. */
  customerPhone?: Maybe<Scalars['String']>;
  /** Refer to "available_deliverables" in the "Org" object. */
  deliverableId?: Maybe<Scalars['Int']>;
  /**
   * An identifier generated/entered by the customer. This can be anything you want. It can be used to
   * reference an ID in the customer application's database. This field can only be updated by the job's
   * creator or admins of the job's org.
   */
  externalIdentifier?: Maybe<Scalars['String']>;
  /** The city of this job's address. */
  locationCity?: Maybe<Scalars['String']>;
  /** The country of the job's address. */
  locationCountry?: Maybe<Scalars['String']>;
  /** The latitude of the job's address. */
  locationLat?: Maybe<Scalars['String']>;
  /** First line of this job's address. */
  locationLine1: Scalars['String'];
  /** Second line of this job's address. */
  locationLine2?: Maybe<Scalars['String']>;
  /** The longitude of the job's address. */
  locationLon?: Maybe<Scalars['String']>;
  /** The postal code of the job's address. */
  locationPostalCode?: Maybe<Scalars['String']>;
  /** The state/region of this job's address. */
  locationRegion?: Maybe<Scalars['String']>;
  /** A name for this job. */
  name?: Maybe<Scalars['String']>;
  /** Deprecated. This will always set to false. */
  shared?: Maybe<Scalars['Boolean']>;
  /**
   * When set to true, all emails (including capture request emails) related to this job will be suppressed. Default is
   * false.
   */
  suppressEmail?: Maybe<Scalars['Boolean']>;
  /**
   * This optional parameter causes a job to be a "test" job and to skip our processing pipeline.
   * "COMPLETE" auto completes your job with example results. "FAILED" automatically fails the job.
   * This parameter should not be used on real jobs.
   */
  testState?: Maybe<JobTestStates>;
  /** Set the wallet_id to use for this job. Refer to "billableWallets" in the "Org" object. */
  walletId?: Maybe<Scalars['Int']>;
};

/**
 * Paginated results for a given type. Total pages or count is not provided. Instead, an hasNextPage boolean is
 * provided.
 */
export type CaptureRequestPaginatedResults = {
  __typename?: 'CaptureRequestPaginatedResults';
  pagination: PaginationWithoutCount;
  results: Array<Maybe<CaptureRequest>>;
};

export enum CaptureRequestSignupTypes {
  Homeowner = 'HOMEOWNER',
  Pro = 'PRO'
}

export enum CaptureRequestStates {
  Complete = 'COMPLETE',
  Connected = 'CONNECTED',
  New = 'NEW'
}

export type CaptureSession = {
  __typename?: 'CaptureSession';
  token: Scalars['String'];
};

/** Autogenerated return type of ChecklistCreate */
export type ChecklistCreatePayload = {
  __typename?: 'ChecklistCreatePayload';
  checklist?: Maybe<InspectionChecklist>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ChecklistUpdate */
export type ChecklistUpdatePayload = {
  __typename?: 'ChecklistUpdatePayload';
  checklist?: Maybe<InspectionChecklist>;
  /** Validation Errors */
  errors: Array<Error>;
};

export enum Complexities {
  Average = 'AVERAGE',
  Complex = 'COMPLEX',
  Simple = 'SIMPLE'
}

export type CornerData = {
  __typename?: 'CornerData';
  /** Combinded length of inside corners. */
  insideLength: Scalars['Float'];
  /** Count of inside corners. */
  insideNumber: Scalars['Int'];
  /** Combinded length of outside corners. */
  outsideLength: Scalars['Float'];
  /** Count of outside corners. */
  outsideNumber: Scalars['Int'];
};

export type CorniceData = {
  __typename?: 'CorniceData';
  /** Individual group data */
  strips: Array<RoofFeatureData>;
  /** Cumulative feature data */
  totals: RoofFeatureData;
};

export type Deliverable = ApplicationRecord & {
  __typename?: 'Deliverable';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type DeliverableChangeRequest = ApplicationRecord & {
  __typename?: 'DeliverableChangeRequest';
  /** Time of this change happened at. */
  changedAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Error message if this change request failed. */
  error?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** Deliverable that this request will change to. */
  newDeliverable?: Maybe<Deliverable>;
  /** Deliverable that this request will change from. */
  oldDeliverable?: Maybe<Deliverable>;
  state?: Maybe<DeliverableChangeRequestStates>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The user that created this request. */
  user?: Maybe<UserBasicInfo>;
};

export enum DeliverableChangeRequestStates {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  FirstAttempt = 'FIRST_ATTEMPT',
  SecondAttempt = 'SECOND_ATTEMPT',
  WaitingForJobToFinish = 'WAITING_FOR_JOB_TO_FINISH',
  WaitingForNewDeliverable = 'WAITING_FOR_NEW_DELIVERABLE'
}

export enum DeliverableDeliverySpeeds {
  Rush = 'RUSH',
  Standard = 'STANDARD'
}

/** Autogenerated return type of DiscountCreate */
export type DiscountCreatePayload = {
  __typename?: 'DiscountCreatePayload';
  discount?: Maybe<EstimationDiscount>;
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of DiscountDelete */
export type DiscountDeletePayload = {
  __typename?: 'DiscountDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of DiscountUpdate */
export type DiscountUpdatePayload = {
  __typename?: 'DiscountUpdatePayload';
  discount?: Maybe<EstimationDiscount>;
  /** Validation Errors */
  errors: Array<Error>;
};

/**
 * All of the Branches at this distributor that org is able to order from.  A
 * branch usually represents a warehouse or region for a product distributor. All
 * of the data here comes from the Distributor's API.
 */
export type DistributionBranch = {
  __typename?: 'DistributionBranch';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  defaultJobAccount?: Maybe<DistributionJobAccount>;
  distributor: ProductCatalogDistributor;
  /** The value we need to send to the distributor when using this branch in an API call like order submission. */
  externalIdentifier: Scalars['ID'];
  id: Scalars['ID'];
  jobAccounts: Array<DistributionJobAccount>;
  /** The name of this Branch. */
  name: Scalars['String'];
  /** The org this branch belongs to. */
  orgId: Scalars['Int'];
};

/** The connection type for DistributionBranch. */
export type DistributionBranchConnection = {
  __typename?: 'DistributionBranchConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DistributionBranchEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DistributionBranch>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DistributionBranchEdge = {
  __typename?: 'DistributionBranchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DistributionBranch>;
};

/** Contains information about which delivery types are available for a distributor */
export type DistributionDelivery = ApplicationRecordUuid & {
  __typename?: 'DistributionDelivery';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** A value from distribution_delivery_types_enum representing the generic delivery type */
  deliveryType: DistributionDeliveryTypeEnum;
  id: Scalars['ID'];
  /** The label for clients to display to users when showing this delivery type for this distributor */
  label: Scalars['String'];
  /** Records should be returned ordered by this column by default */
  sortOrder: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Contains information about which delivery methods are available for a distributor */
export type DistributionDeliveryMethod = ApplicationRecordUuid & {
  __typename?: 'DistributionDeliveryMethod';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** A value from distribution_delivery_methods_enum representing the generic delivery method */
  deliveryMethod: DistributionDeliveryMethodEnum;
  id: Scalars['ID'];
  /** The label for clients to display to users when showing this delivery method for this distributor */
  label: Scalars['String'];
  /** Records should be returned ordered by this column by default */
  sortOrder: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum DistributionDeliveryMethodEnum {
  BranchPickUp = 'BRANCH_PICK_UP',
  DeliverToAddress = 'DELIVER_TO_ADDRESS',
  OnHold = 'ON_HOLD'
}

/** Contains information about which delivery times are available for a distributor */
export type DistributionDeliveryTime = ApplicationRecordUuid & {
  __typename?: 'DistributionDeliveryTime';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** A value from distribution_delivery_times_enum representing the generic delivery time */
  deliveryTime: DistributionDeliveryTimeEnum;
  id: Scalars['ID'];
  /** The label for clients to display to users when showing this delivery time for this distributor */
  label: Scalars['String'];
  /** Records should be returned ordered by this column by default */
  sortOrder: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum DistributionDeliveryTimeEnum {
  Afternoon = 'AFTERNOON',
  Anytime = 'ANYTIME',
  Morning = 'MORNING',
  SpecialRequest = 'SPECIAL_REQUEST'
}

export enum DistributionDeliveryTypeEnum {
  GroundDrop = 'GROUND_DROP',
  RoofEdge = 'ROOF_EDGE',
  RoofLoad = 'ROOF_LOAD'
}

export type DistributionJobAccount = {
  __typename?: 'DistributionJobAccount';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressLine3?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  orgId: Scalars['Int'];
};

/** OAuth tokens that give us access to an Org's account on a 3rd party Distributor's API. */
export type DistributionOauthToken = ApplicationRecordUuid & {
  __typename?: 'DistributionOauthToken';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  distributor: ProductCatalogDistributor;
  /** The distributor that this oauth token allows us to talk to. */
  distributorId: Scalars['ID'];
  id: Scalars['ID'];
  /** The Org this oauth token belongs to. This token gives HOVER access to a distributor's system on behalf of the org. */
  orgId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for DistributionOauthToken. */
export type DistributionOauthTokenConnection = {
  __typename?: 'DistributionOauthTokenConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DistributionOauthTokenEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DistributionOauthToken>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DistributionOauthTokenEdge = {
  __typename?: 'DistributionOauthTokenEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DistributionOauthToken>;
};

/** This table keeps track of orders placed with Distributors. And the status of those order. */
export type DistributionOrder = ApplicationRecordUuid & {
  __typename?: 'DistributionOrder';
  accountId?: Maybe<Scalars['String']>;
  branch?: Maybe<DistributionBranch>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliveryDate?: Maybe<Scalars['ISO8601Date']>;
  deliveryMethod?: Maybe<DistributionDeliveryMethodEnum>;
  deliveryTime?: Maybe<DistributionDeliveryTimeEnum>;
  deliveryType?: Maybe<DistributionDeliveryTypeEnum>;
  /** The selected branch to send this order to. */
  distributionBranchId?: Maybe<Scalars['ID']>;
  /** The selected job account to use when placing this order */
  distributionJobAccountId?: Maybe<Scalars['ID']>;
  distributor: ProductCatalogDistributor;
  /** The identifier for this order in the distributor's system */
  externalIdentifier?: Maybe<Scalars['String']>;
  /**
   * If an order fails, a string describing the failure will be saved here. This
   * may be an error message directly from the Distributor.
   */
  failureReason?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** An idempotence key to check that requests to product catalog to create an order are only executed once. */
  idempotenceKey?: Maybe<Scalars['String']>;
  jobAccount?: Maybe<DistributionJobAccount>;
  /** The job account number that is sent to the distributor with this order */
  jobAccountNumber?: Maybe<Scalars['String']>;
  lineItems: Array<DistributionOrderLineItem>;
  /** Additional info to be added to order. These notes will be passed on to the Distributor. */
  notes?: Maybe<Scalars['String']>;
  orderCheck?: Maybe<DistributionOrderCheck>;
  /** The user specified identifier for this order */
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  /** City of the shipping address passed to distributor */
  shippingAddressCity?: Maybe<Scalars['String']>;
  /** Country of the shipping address passed to distributor */
  shippingAddressCountry?: Maybe<Scalars['String']>;
  /** First name of the shipping address passed to distributor */
  shippingAddressFirstName?: Maybe<Scalars['String']>;
  /** Last name of the shipping address passed to distributor */
  shippingAddressLastName?: Maybe<Scalars['String']>;
  /** Line 1 of the shipping address passed to distributor */
  shippingAddressLine1?: Maybe<Scalars['String']>;
  /** Line 2 of the shipping address passed to distributor */
  shippingAddressLine2?: Maybe<Scalars['String']>;
  /** Phone number of the shipping address passed to distributor */
  shippingAddressPhoneNumber?: Maybe<Scalars['String']>;
  /** Postal code of the shipping address passed to distributor */
  shippingAddressPostalCode?: Maybe<Scalars['String']>;
  /** State of the shipping address passed to distributor */
  shippingAddressState?: Maybe<Scalars['String']>;
  /** The state of this order */
  state: DistributionOrderStateEnum;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * A URL to this order in the Distributor's system. This url is used for linking
   * end users to their orders on the Distributor's website.
   */
  url?: Maybe<Scalars['String']>;
  /** The User that created this DistributionOrder. */
  user: User;
};

export type DistributionOrderCheck = {
  __typename?: 'DistributionOrderCheck';
  /** Validation Errors */
  errors: Array<Error>;
  lineItems: Array<DistributionOrderCheckLineItem>;
};

export type DistributionOrderCheckLineItem = {
  __typename?: 'DistributionOrderCheckLineItem';
  /** Validation Errors */
  errors: Array<Error>;
  id: Scalars['ID'];
  /** @deprecated use productName */
  name: Scalars['String'];
  productName: Scalars['String'];
};

/** The connection type for DistributionOrder. */
export type DistributionOrderConnection = {
  __typename?: 'DistributionOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DistributionOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DistributionOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating a Distribution Order */
export type DistributionOrderCreateInput = {
  accountId?: Maybe<Scalars['String']>;
  deliveryDate?: Maybe<Scalars['ISO8601Date']>;
  deliveryMethod?: Maybe<DistributionDeliveryMethodEnum>;
  deliveryTime?: Maybe<DistributionDeliveryTimeEnum>;
  deliveryType?: Maybe<DistributionDeliveryTypeEnum>;
  /** The selected branch to send this order to. */
  distributionBranchId?: Maybe<Scalars['ID']>;
  /** The selected job account to use when placing this order */
  distributionJobAccountId?: Maybe<Scalars['ID']>;
  /** The distributor to place the order with */
  distributorId: Scalars['ID'];
  /** A unique key to ensure requests to create the same order are only executed once. */
  idempotenceKey?: Maybe<Scalars['String']>;
  jobAccountNumber?: Maybe<Scalars['String']>;
  /** Attributes for the Order Line Items to be included in this order */
  lineItemsAttributes: Array<DistributionOrderLineItemInput>;
  /** The description to be saved to Distribution::Order and to be sent to Distributors when placing orders. */
  notes?: Maybe<Scalars['String']>;
  /** The purchase order number sent to the distributor */
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  /** City of the shipping address passed to distributor */
  shippingAddressCity?: Maybe<Scalars['String']>;
  /** Country of the shipping address passed to distributor */
  shippingAddressCountry?: Maybe<Scalars['String']>;
  /** First name of the shipping address passed to distributor */
  shippingAddressFirstName?: Maybe<Scalars['String']>;
  /** Last name of the shipping address passed to distributor */
  shippingAddressLastName?: Maybe<Scalars['String']>;
  /** Line 1 of the shipping address passed to distributor */
  shippingAddressLine1?: Maybe<Scalars['String']>;
  /** Line 2 of the shipping address passed to distributor */
  shippingAddressLine2?: Maybe<Scalars['String']>;
  /** Phone number of the shipping address passed to distributor */
  shippingAddressPhoneNumber?: Maybe<Scalars['String']>;
  /** Postal code of the shipping address passed to distributor */
  shippingAddressPostalCode?: Maybe<Scalars['String']>;
  /** State of the shipping address passed to distributor */
  shippingAddressState?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type DistributionOrderEdge = {
  __typename?: 'DistributionOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<DistributionOrder>;
};

/** Order List Item */
export type DistributionOrderLineItem = {
  __typename?: 'DistributionOrderLineItem';
  id: Scalars['ID'];
  productId?: Maybe<Scalars['ID']>;
  productName?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Float']>;
  /** The quantity units as given by the client. */
  quantityUnits?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  userSetCustomSku: Scalars['Boolean'];
  userSetCustomVariationName: Scalars['Boolean'];
  variationId?: Maybe<Scalars['ID']>;
  variationName?: Maybe<Scalars['String']>;
};

/** Arguments for building a Distribution Order Line Item. */
export type DistributionOrderLineItemInput = {
  productId?: Maybe<Scalars['ID']>;
  productName?: Maybe<Scalars['String']>;
  quantity: Scalars['Float'];
  quantityUnits?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  userSetCustomSku?: Maybe<Scalars['Boolean']>;
  userSetCustomVariationName?: Maybe<Scalars['Boolean']>;
  variationId?: Maybe<Scalars['ID']>;
  variationName?: Maybe<Scalars['String']>;
};

export enum DistributionOrderStateEnum {
  CheckFailed = 'check_failed',
  CheckSuccess = 'check_success',
  Checking = 'checking',
  Created = 'created',
  Failed = 'failed',
  Queued = 'queued',
  Submitted = 'submitted'
}

/** Arguments for querying for a Variation or Product */
export type DistributionVariationAttributesInput = {
  /**
   * A client side identifier that will be returned with this variation's data.
   * Useful for matching up results with client side data.
   */
  clientIdentifier?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  quantityUnits?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  userSetCustomSku?: Maybe<Scalars['Boolean']>;
  variationId?: Maybe<Scalars['ID']>;
  variationName?: Maybe<Scalars['String']>;
};

export type DomainClaim = ApplicationRecord & {
  __typename?: 'DomainClaim';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  domain: Scalars['String'];
  id: Scalars['Int'];
  status: DomainClaimStatus;
  /** The string to be added the domain's DNS TXT record to verify this domain claim. */
  textRecordValue: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum DomainClaimStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Unprocessable = 'UNPROCESSABLE',
  Verified = 'VERIFIED',
  Verifying = 'VERIFYING'
}

export type Downspout = {
  __typename?: 'Downspout';
  length: Scalars['Float'];
  origin: Vector3;
};

export type Drainage = {
  __typename?: 'Drainage';
  gutters: Array<Gutter>;
};

export type EhiFeatureAccess = ApplicationRecord & {
  __typename?: 'EHIFeatureAccess';
  /** The id of the user or org with this feature */
  accessorId?: Maybe<Scalars['Int']>;
  /** An enum representing either user or org */
  accessorType?: Maybe<FeatureAccessAccessor>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Boolean to control access to this feature */
  enabled: Scalars['Boolean'];
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  /** An enum specifying the feature this record gives access to */
  identifier?: Maybe<EhiFeatureAccessIdentifier>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum EhiFeatureAccessIdentifier {
  Estimation = 'ESTIMATION',
  IncludeInactiveTemplates = 'INCLUDE_INACTIVE_TEMPLATES'
}

export type ElevationBySide = {
  __typename?: 'ElevationBySide';
  /** List of facades and their areas. */
  areaPerLabel: Array<FacadeArea>;
  /** Sum of areas for all facades on this side. */
  total: Scalars['Int'];
};

export type Elevations = {
  __typename?: 'Elevations';
  /** Elevations for structure's facades. */
  sides: Sides;
};

/** Errors about an attribute of an invalid record */
export type Error = {
  __typename?: 'Error';
  attribute: Scalars['String'];
  errors: Array<Scalars['String']>;
};

/** Estimate */
export type Estimate = ApplicationRecord & {
  __typename?: 'Estimate';
  /** whether or not the estimate is active within an estimate group */
  active: Scalars['Boolean'];
  basePrice?: Maybe<Scalars['Float']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** total discount in dollars applied to the estimate */
  discount?: Maybe<Scalars['Float']>;
  discounts?: Maybe<Array<EstimationDiscount>>;
  estimateGroup?: Maybe<EstimationEstimateGroup>;
  fullMeasurements?: Maybe<Scalars['Boolean']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  /** The job to which the estimate relates. */
  jobId?: Maybe<Scalars['Int']>;
  lineItems?: Maybe<Array<LineItem>>;
  /** The name of the template used when the estimate was created */
  name?: Maybe<Scalars['String']>;
  /** The org to which the estimate relates. */
  orgId?: Maybe<Scalars['Int']>;
  salesOpportunity?: Maybe<SalesOpportunity>;
  template?: Maybe<Template>;
  totalPrice?: Maybe<Scalars['Float']>;
  tradeType?: Maybe<TradeTypeEnum>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  userId?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of EstimateGroupCreate */
export type EstimateGroupCreatePayload = {
  __typename?: 'EstimateGroupCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  estimateGroup?: Maybe<EstimationEstimateGroup>;
};

/** EstimateGroupUserAnswer */
export type EstimateGroupUserAnswer = ApplicationRecordUuid & {
  __typename?: 'EstimateGroupUserAnswer';
  /** The name of the category from this answer's input */
  categoryName?: Maybe<Scalars['String']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  estimationConfigInput?: Maybe<EstimationConfigInput>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  inputCategory: EstimationConfigInputCategory;
  /** The type of user_value */
  inputType?: Maybe<EstimationConfigInputInputTypeEnum>;
  /** The units user_value is in, from the unit_formula_measurement_units enum */
  measurementUnits?: Maybe<EstimationConfigInputMeasurementUnitEnum>;
  /** The question shown to the user when this answer was entered */
  question?: Maybe<Scalars['String']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The value entered by the user */
  userValue?: Maybe<Scalars['String']>;
};

/** Arguments for updating an Estimate */
export type EstimateUpdate = {
  /** whether or not the estimate is active within an estimate group */
  active?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated return type of EstimateUpdate */
export type EstimateUpdatePayload = {
  __typename?: 'EstimateUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  estimate?: Maybe<Estimate>;
};

/** Estimation Configuration Input */
export type EstimationConfigInput = ApplicationRecord & {
  __typename?: 'EstimationConfigInput';
  /** The argument to pass into the equation when evaluating */
  argument?: Maybe<Scalars['String']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  inputCategory?: Maybe<EstimationConfigInputCategory>;
  inputConditions?: Maybe<Array<EstimationConfigInputCondition>>;
  inputOptions?: Maybe<Array<EstimationConfigInputOption>>;
  /** Type to validate when a value is provided by the client */
  inputType: EstimationConfigInputInputTypeEnum;
  /** so users know the measurement units when providing an input value */
  measurementUnits?: Maybe<EstimationConfigInputMeasurementUnitEnum>;
  /** The name of the estimation_input. */
  name?: Maybe<Scalars['String']>;
  /** The question to ask the client when the input needs a value */
  question?: Maybe<Scalars['String']>;
  /** The default value for the input to show the user. */
  questionDefaultValue?: Maybe<Scalars['String']>;
  /** The order in which to display the input. */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


/** Estimation Configuration Input */
export type EstimationConfigInputInputOptionsArgs = {
  orgId?: Maybe<Scalars['ID']>;
};

/** Estimation Configuration Input Category */
export type EstimationConfigInputCategory = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigInputCategory';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  name: Scalars['String'];
  sortOrder: Scalars['Int'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for EstimationConfigInputCategory. */
export type EstimationConfigInputCategoryConnection = {
  __typename?: 'EstimationConfigInputCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstimationConfigInputCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EstimationConfigInputCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EstimationConfigInputCategoryEdge = {
  __typename?: 'EstimationConfigInputCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EstimationConfigInputCategory>;
};

/** Estimation Configuration Input Condition */
export type EstimationConfigInputCondition = ApplicationRecordUuid & {
  __typename?: 'EstimationConfigInputCondition';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  /** the parent input that the condition depends on */
  parentInputId: Scalars['ID'];
  /** if the parent input has this value, then show the sales question */
  parentValue: Scalars['String'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum EstimationConfigInputInputTypeEnum {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  Select = 'SELECT',
  String = 'STRING'
}

export enum EstimationConfigInputMeasurementUnitEnum {
  Each = 'EACH',
  FormulaUnits = 'FORMULA_UNITS',
  Hours = 'HOURS',
  LinearFeet = 'LINEAR_FEET',
  LinearInches = 'LINEAR_INCHES',
  Pieces = 'PIECES',
  SellingUnits = 'SELLING_UNITS',
  Squares = 'SQUARES',
  SquareFeet = 'SQUARE_FEET'
}

/** Estimation Configuration Input Option */
export type EstimationConfigInputOption = ApplicationRecord & {
  __typename?: 'EstimationConfigInputOption';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  /** label shown to the user */
  label: Scalars['String'];
  sortOrder?: Maybe<Scalars['Int']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** value passed to the estimator for calculation */
  value: Scalars['String'];
};

/** Estimation Configuration Line Item */
export type EstimationConfigLineItem = ApplicationRecord & {
  __typename?: 'EstimationConfigLineItem';
  active: Scalars['Boolean'];
  /** Allow selecting variation for this line item during estimation flow */
  allowVariationSelection: Scalars['Boolean'];
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  /** margin as a percentage */
  margin?: Maybe<Scalars['Float']>;
  /** the name of the line_item */
  name: Scalars['String'];
  /** the org to which this line item belongs */
  orgId: Scalars['Int'];
  product?: Maybe<ProductCatalogProduct>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: Maybe<Scalars['ID']>;
  quantityUnits: QuantityUnitsEnum;
  /** sales tax as a percentage */
  salesTax?: Maybe<Scalars['Float']>;
  type?: Maybe<LineItemTypeEnum>;
  /** cost per unit in dollars */
  unitCost: Scalars['Float'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  vendor?: Maybe<Vendor>;
};

/** The connection type for EstimationConfigLineItem. */
export type EstimationConfigLineItemConnection = {
  __typename?: 'EstimationConfigLineItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstimationConfigLineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EstimationConfigLineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EstimationConfigLineItemEdge = {
  __typename?: 'EstimationConfigLineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EstimationConfigLineItem>;
};

/** Estimation Configuration Required Input */
export type EstimationConfigRequiredInput = ApplicationRecord & {
  __typename?: 'EstimationConfigRequiredInput';
  /** The argument to pass into the equation when evaluating */
  argument?: Maybe<Scalars['String']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  inputCategory?: Maybe<EstimationConfigInputCategory>;
  inputConditions?: Maybe<Array<EstimationConfigInputCondition>>;
  inputOptions?: Maybe<Array<EstimationConfigInputOption>>;
  /** Type to validate when a value is provided by the client */
  inputType: EstimationConfigInputInputTypeEnum;
  /** so users know the measurement units when providing an input value */
  measurementUnits?: Maybe<EstimationConfigInputMeasurementUnitEnum>;
  /** The name of the estimation_input. */
  name?: Maybe<Scalars['String']>;
  /** The question to ask the client when the input needs a value */
  question?: Maybe<Scalars['String']>;
  /** The default value for the input to show the user. */
  questionDefaultValue?: Maybe<Scalars['String']>;
  /** The order in which to display the input. */
  sortOrder?: Maybe<Scalars['Int']>;
  tradeTypes?: Maybe<Array<TradeTypeEnum>>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


/** Estimation Configuration Required Input */
export type EstimationConfigRequiredInputInputOptionsArgs = {
  orgId?: Maybe<Scalars['ID']>;
};

/** The connection type for EstimationConfigRequiredInput. */
export type EstimationConfigRequiredInputConnection = {
  __typename?: 'EstimationConfigRequiredInputConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstimationConfigRequiredInputEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EstimationConfigRequiredInput>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EstimationConfigRequiredInputEdge = {
  __typename?: 'EstimationConfigRequiredInputEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EstimationConfigRequiredInput>;
};

/** Discount */
export type EstimationDiscount = ApplicationRecord & {
  __typename?: 'EstimationDiscount';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  discountType: EstimationDiscountDiscountTypeEnum;
  estimationEstimateId: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['String'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  value: Scalars['Float'];
};

/** Arguments for creating a Discount for an Estimate */
export type EstimationDiscountCreate = {
  discountType: EstimationDiscountDiscountTypeEnum;
  estimationEstimateId: Scalars['ID'];
  name: Scalars['String'];
  value: Scalars['Float'];
};

export enum EstimationDiscountDiscountTypeEnum {
  Dollars = 'DOLLARS',
  Percentage = 'PERCENTAGE'
}

/** Arguments for updating a Discount for an Estimate */
export type EstimationDiscountUpdate = {
  discountType: EstimationDiscountDiscountTypeEnum;
  name: Scalars['String'];
  value: Scalars['Float'];
};

/** Arguments for creating an EstimationConfigLineItem */
export type EstimationEstimateConfigLineItemCreateInput = {
  /** Allow selecting variation for this line item during estimation flow */
  allowVariationSelection?: Maybe<Scalars['Boolean']>;
  /** margin as a percentage */
  margin?: Maybe<Scalars['Float']>;
  /** the name of the line_item */
  name: Scalars['String'];
  /** the org to which this line item belongs */
  orgId: Scalars['ID'];
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: Maybe<Scalars['ID']>;
  quantityUnits: QuantityUnitsEnum;
  /** sales tax as a percentage */
  salesTax?: Maybe<Scalars['Float']>;
  type: LineItemTypeEnum;
  /** cost per unit in dollars */
  unitCost?: Maybe<Scalars['Float']>;
  /** The id of the EstimationConfig::Vendor this item will be ordered through */
  vendorId?: Maybe<Scalars['Int']>;
};

/** Estimate Group */
export type EstimationEstimateGroup = ApplicationRecordUuid & {
  __typename?: 'EstimationEstimateGroup';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  estimates: Array<Estimate>;
  failureReason?: Maybe<Scalars['String']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  jobId?: Maybe<Scalars['ID']>;
  laborTotalCost?: Maybe<Scalars['Float']>;
  materialSubtotalPretaxCost?: Maybe<Scalars['Float']>;
  materialSubtotalTax?: Maybe<Scalars['Float']>;
  materialTotalCost?: Maybe<Scalars['Float']>;
  orgId: Scalars['ID'];
  otherTotalCost?: Maybe<Scalars['Float']>;
  profitAmount?: Maybe<Scalars['Float']>;
  profitMargin?: Maybe<Scalars['Float']>;
  salesOpportunity: SalesOpportunity;
  state: EstimationEstimateGroupStateEnum;
  totalCost?: Maybe<Scalars['Float']>;
  totalDiscount?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Float']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  userAnswers: Array<EstimateGroupUserAnswer>;
};


/** Estimate Group */
export type EstimationEstimateGroupEstimatesArgs = {
  active?: Maybe<Scalars['Boolean']>;
};

/** The connection type for EstimationEstimateGroup. */
export type EstimationEstimateGroupConnection = {
  __typename?: 'EstimationEstimateGroupConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EstimationEstimateGroupEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EstimationEstimateGroup>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating an Estimate Group */
export type EstimationEstimateGroupCreate = {
  jobId: Scalars['ID'];
  /** The org to which the estimate group relates. */
  orgId: Scalars['ID'];
};

/** Arguments for specifying custom line items when creating estimates */
export type EstimationEstimateGroupCreateCustomLineItem = {
  name: Scalars['String'];
  price: Scalars['Float'];
  tradeType?: Maybe<TradeTypeEnum>;
  type?: Maybe<LineItemTypeEnum>;
};

/** Arguments for specifying formula input values */
export type EstimationEstimateGroupCreateInput = {
  id: Scalars['ID'];
  value: Scalars['String'];
};

/** Arguments for specifying which trade types use full measurements */
export type EstimationEstimateGroupCreateTradeTypeAttributeInput = {
  /** if the trade type uses full measurements */
  fullMeasurements: Scalars['Boolean'];
  /** a trade type */
  tradeType: TradeTypeEnum;
};

/** An edge in a connection. */
export type EstimationEstimateGroupEdge = {
  __typename?: 'EstimationEstimateGroupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<EstimationEstimateGroup>;
};

export enum EstimationEstimateGroupStateEnum {
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Queued = 'QUEUED'
}

/** Arguments for updating a Line Item for an Estimate */
export type EstimationLineItemUpdateInput = {
  /** Foreign key to product_catalog_variation */
  productCatalogVariationId: Scalars['ID'];
  productCatalogVariationName: Scalars['String'];
};

export type EsxAddressInput = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postal?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

/** Org settings for expedited deliverables. */
export type ExpeditedDeliverablesSettings = {
  __typename?: 'ExpeditedDeliverablesSettings';
  defaultDeliverySpeed: DeliverableDeliverySpeeds;
  deliverable: Deliverable;
  deliverySpeeds: Array<DeliverableDeliverySpeeds>;
};

export type FacadeArea = {
  __typename?: 'FacadeArea';
  /** Area of facade. */
  area: Scalars['Int'];
  /** Label for facade. */
  label: Scalars['String'];
};

export type FacadeData = {
  __typename?: 'FacadeData';
  /** Area of facade. */
  area: Scalars['Int'];
  /** Facade by facade breakdown of waste data. */
  areaWithWasteFactorCalculation: WastePercentages;
  /** Facade's corner data. */
  corners?: Maybe<CornerData>;
  /** Facade label. */
  facade: Scalars['String'];
  /** Boolean indicating whether or not a facade is labeled on the screenshot. */
  labeledOnScreenshot: Scalars['Boolean'];
  /** Facade's opening data. */
  openings?: Maybe<OpeningsData>;
  /** Facade's roofline data. */
  roofline?: Maybe<RooflineData>;
  /** Shutters on facade. */
  shutters: Scalars['Int'];
  /** Facade's trim data. */
  trim?: Maybe<TrimData>;
  /** Vents on facade. */
  vents: Scalars['Int'];
};

export type Facades = {
  __typename?: 'Facades';
  /** Facade data for brick facades */
  brick?: Maybe<Array<FacadeData>>;
  /** Facade data for metal facades */
  metal?: Maybe<Array<FacadeData>>;
  /** Facade data for siding facades */
  siding?: Maybe<Array<FacadeData>>;
  /** Facade data for stone facades */
  stone?: Maybe<Array<FacadeData>>;
  /** Facade data for stucco facades */
  stucco?: Maybe<Array<FacadeData>>;
  /** Facade data for tudor facades */
  tudor?: Maybe<Array<FacadeData>>;
  /** Facade data for unknown facades */
  unknown?: Maybe<Array<FacadeData>>;
  /** Facade data for wrap facades */
  wrap?: Maybe<Array<FacadeData>>;
};

export type Face = {
  __typename?: 'Face';
  /** (Unit: sqin) */
  area: Scalars['Float'];
  /** Area minus the total area of opening direct annotations. (Unit: sqin) */
  areaMinusAnnotations: Scalars['Float'];
  /** e.g. Door Package -> Door */
  directAnnotations?: Maybe<Array<Annotation>>;
  /**
   * roof or wall edges; when on siding wall,this could be an 'extended' edge
   * (edges that are not part of the wall's loop but on adjacent trims')
   */
  eaves: Array<MEdge>;
  /** All edges that part of any of the face's loops */
  edges: Array<MEdge>;
  /** Database id */
  facadeId: Scalars['ID'];
  /** roof edges */
  flashings: Array<MEdge>;
  /** roof edges */
  hips: Array<MEdge>;
  includeInPerMaterialMeasurements?: Maybe<Scalars['Boolean']>;
  includeInTotalMeasurements?: Maybe<Scalars['Boolean']>;
  /** e.g. Siding -> Door (via door package) */
  indirectAnnotations?: Maybe<Array<Annotation>>;
  /**
   * wall edges; when on siding wall, this could be an 'extended' edge,which is not
   * part of the wall's loop but of an adjacent trim
   */
  insideCorners: Array<MEdge>;
  labels?: Maybe<Array<Label>>;
  /** wall edges */
  levelBases: Array<MEdge>;
  name?: Maybe<Scalars['String']>;
  /** wall edges */
  openingBottoms: Array<MEdge>;
  /** wall edges */
  openingSides: Array<MEdge>;
  /** wall edges */
  openingTops: Array<MEdge>;
  /**
   * wall edges; when on siding wall, this could be an 'extended' edge,which is not
   * part of the wall's loop but of an adjacent trim
   */
  outsideCorners: Array<MEdge>;
  /** wall edges */
  perimeters: Array<MEdge>;
  productId?: Maybe<Scalars['ID']>;
  /**
   * roof or wall edges; when on siding wall,this could be an 'extended' edge
   * (edges that are not part of the wall's loop but on adjacent trims')
   */
  rakes: Array<MEdge>;
  /** roof edges */
  ridges: Array<MEdge>;
  /** wall edges */
  slopedBases: Array<MEdge>;
  /** Unique id assigned randomely to all facades in the model.Sort index Can be found in skp as well */
  sortIndex: Scalars['Int'];
  /** roof edges */
  stepFlashings: Array<MEdge>;
  /** The hex value of the color of the texture applied to a face */
  textureColor?: Maybe<Scalars['String']>;
  /** roof edges */
  transitionLines: Array<MEdge>;
  /** roof edges */
  valleys: Array<MEdge>;
  windowTexture?: Maybe<WindowTexture>;
};

export type FeatureAccess = ApplicationRecord & {
  __typename?: 'FeatureAccess';
  accessorId?: Maybe<Scalars['Int']>;
  accessorType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  enabled: Scalars['Boolean'];
  id: Scalars['Int'];
  identifier?: Maybe<FeatureAccessIdentifier>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum FeatureAccessAccessor {
  Org = 'ORG',
  User = 'USER'
}

export enum FeatureAccessIdentifier {
  AnalyticsOrg = 'ANALYTICS_ORG',
  AnalyticsPartner = 'ANALYTICS_PARTNER',
  CompleteWithPaymentEmailWithPdfReceipt = 'COMPLETE_WITH_PAYMENT_EMAIL_WITH_PDF_RECEIPT',
  DesignViewMeasurementsTool = 'DESIGN_VIEW_MEASUREMENTS_TOOL',
  EhiProjectManagementProduct = 'EHI_PROJECT_MANAGEMENT_PRODUCT',
  EmailSendReceipt = 'EMAIL_SEND_RECEIPT',
  EmailShowReceiptAggregateDiscountsAndBasePriceSubsidy = 'EMAIL_SHOW_RECEIPT_AGGREGATE_DISCOUNTS_AND_BASE_PRICE_SUBSIDY',
  EmailShowReceiptBasePriceSubsidy = 'EMAIL_SHOW_RECEIPT_BASE_PRICE_SUBSIDY',
  ExpediteCompleteJobsAutomatically = 'EXPEDITE_COMPLETE_JOBS_AUTOMATICALLY',
  ExpediteRoofOnlyJobsAutomatically = 'EXPEDITE_ROOF_ONLY_JOBS_AUTOMATICALLY',
  ExportAdvancedJob = 'EXPORT_ADVANCED_JOB',
  ExportEsx = 'EXPORT_ESX',
  GalleryAndScreenshotMode = 'GALLERY_AND_SCREENSHOT_MODE',
  GuttersAndDownspouts = 'GUTTERS_AND_DOWNSPOUTS',
  HoverNow = 'HOVER_NOW',
  Integrations = 'INTEGRATIONS',
  LeadAutoAssign = 'LEAD_AUTO_ASSIGN',
  LeadHomeownerCapture = 'LEAD_HOMEOWNER_CAPTURE',
  LoanCallToAction = 'LOAN_CALL_TO_ACTION',
  MaterialOrdering = 'MATERIAL_ORDERING',
  MaterialOrderingBeacon = 'MATERIAL_ORDERING_BEACON',
  MeasurementsCoBrand = 'MEASUREMENTS_CO_BRAND',
  MeasurementsFilesAccess = 'MEASUREMENTS_FILES_ACCESS',
  OnDemandExpeditedDeliverables = 'ON_DEMAND_EXPEDITED_DELIVERABLES',
  OrgJobsDailyZipExport = 'ORG_JOBS_DAILY_ZIP_EXPORT',
  Prospect = 'PROSPECT',
  SalesEstimation = 'SALES_ESTIMATION',
  SingleSignOn = 'SINGLE_SIGN_ON',
  TeamManagementAdvanced = 'TEAM_MANAGEMENT_ADVANCED',
  TeamManagementBasic = 'TEAM_MANAGEMENT_BASIC',
  UpgradeToPro = 'UPGRADE_TO_PRO'
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  identifier: Scalars['String'];
};

export type File = {
  __typename?: 'File';
  byteSize: Scalars['Int'];
  checksum: Scalars['String'];
  contentType: Scalars['String'];
  filename: Scalars['String'];
  /**
   * A stable, non-expiring URL for the file. This is a HOVER API endpoint that
   * redirects to the actual file location. Requires authenticated.
   */
  redirectUrl: Scalars['String'];
  /**
   * A temporary, direct URL for the file. This URL includes authorization
   * information that expires. It will need to be used quickly.
   * @deprecated Use redirectUrl instead.
   */
  url: Scalars['String'];
};

export enum FileStorageScopes {
  DesignStudio = 'DESIGN_STUDIO',
  ProgressiveUploads = 'PROGRESSIVE_UPLOADS'
}

export type FileStorageToken = {
  __typename?: 'FileStorageToken';
  token: Scalars['String'];
};

/** Autogenerated return type of GenerateRemoteJWT */
export type GenerateRemoteJwtPayload = {
  __typename?: 'GenerateRemoteJWTPayload';
  jwt?: Maybe<Scalars['String']>;
};

export type Gutter = {
  __typename?: 'Gutter';
  downspouts: Array<Downspout>;
  elevationGroup: Scalars['Int'];
  length: Scalars['Float'];
  maxDistanceFromGround: Scalars['Float'];
  parentFacadeId: Scalars['Int'];
  pointA: Vector3;
  pointB: Vector3;
};

export type GutterData = {
  __typename?: 'GutterData';
  /** Individual group data */
  byGroup: Array<RoofFeatureData>;
  /** Returns true if there are any features longer than 20ft. */
  featuresAbove20Ft?: Maybe<Scalars['Boolean']>;
  /** Cumulative feature data */
  totals: RoofFeatureData;
};



export type IndividualWindowData = {
  __typename?: 'IndividualWindowData';
  /** Window area adjusted to account for sash/openings trim. */
  area: Scalars['Int'];
  /** Label of face with window on it. */
  face: Scalars['String'];
  /** Rounded height of window in inches. */
  height?: Maybe<Scalars['Int']>;
  /** Window label. */
  label: Scalars['String'];
  /** Rounded sum of width and height in inches. */
  unitedInches: Scalars['Int'];
  /** Rounded width of window in inches. */
  width?: Maybe<Scalars['Int']>;
};

/** Checklist questions for orgs to record property info */
export type InspectionChecklist = ApplicationRecordUuid & {
  __typename?: 'InspectionChecklist';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  /** the job for this checklist */
  jobId: Scalars['Int'];
  /** the user ID of the last user to update the checklist */
  lastSavedByUserId?: Maybe<Scalars['Int']>;
  /** the org that owns this checklist */
  orgId: Scalars['Int'];
  questions: Array<InspectionChecklistQuestion>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Questions to be answered with InspectionChecklists */
export type InspectionChecklistQuestion = ApplicationRecordUuid & {
  __typename?: 'InspectionChecklistQuestion';
  /** The answer provided by the user */
  answerValue?: Maybe<Scalars['String']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Which estimationConfigInput this question maps to in the Estimator */
  estimationConfigInputId?: Maybe<Scalars['Int']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  /** The text of the question to be answered by the user */
  questionText: Scalars['String'];
  /** The type of question */
  questionType?: Maybe<InspectionConfigChecklistQuestionTypeEnum>;
  sortOrder?: Maybe<Scalars['Int']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Arguments for creating InspectionChecklistQuestions from ChecklistTemplateQuestions */
export type InspectionChecklistQuestionCreateInput = {
  answerValue?: Maybe<Scalars['String']>;
  templateQuestionId: Scalars['ID'];
};

/** Arguments for updating an inspection checklist question */
export type InspectionChecklistQuestionUpdateInput = {
  /** The answer provided by the user */
  answerValue: Scalars['String'];
  id: Scalars['ID'];
};

export enum InspectionConfigChecklistQuestionTypeEnum {
  Boolean = 'BOOLEAN',
  Number = 'NUMBER',
  String = 'STRING'
}

/** InspectionConfig template for Checklists */
export type InspectionConfigChecklistTemplate = ApplicationRecordUuid & {
  __typename?: 'InspectionConfigChecklistTemplate';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  /** name of the template */
  name: Scalars['String'];
  /** the org to which this template belongs */
  orgId?: Maybe<Scalars['Int']>;
  questions: Array<InspectionConfigChecklistTemplateQuestion>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for InspectionConfigChecklistTemplate. */
export type InspectionConfigChecklistTemplateConnection = {
  __typename?: 'InspectionConfigChecklistTemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<InspectionConfigChecklistTemplateEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<InspectionConfigChecklistTemplate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type InspectionConfigChecklistTemplateEdge = {
  __typename?: 'InspectionConfigChecklistTemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<InspectionConfigChecklistTemplate>;
};

/** InspectionConfig questions for ChecklistTemplates */
export type InspectionConfigChecklistTemplateQuestion = ApplicationRecordUuid & {
  __typename?: 'InspectionConfigChecklistTemplateQuestion';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  estimationConfigInputId?: Maybe<Scalars['Int']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  questionText: Scalars['String'];
  questionType?: Maybe<InspectionConfigChecklistQuestionTypeEnum>;
  sortOrder?: Maybe<Scalars['Int']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type Jwt = {
  __typename?: 'JWT';
  accessToken: Scalars['String'];
  expiresIn: Scalars['Int'];
  refreshToken: Scalars['String'];
};

export type Job = ApplicationRecord & {
  __typename?: 'Job';
  approved?: Maybe<Scalars['Boolean']>;
  approvedAt?: Maybe<Scalars['ISO8601DateTime']>;
  approvingUser?: Maybe<UserBasicInfo>;
  archived: Scalars['Boolean'];
  /**
   * Returns an array of deliverables that the current_user can request an upgrade for this job using the
   * createDeliverableChangeRequest mutation.
   */
  availableDeliverableUpgrades: Array<Deliverable>;
  /**
   * Return the best front-view image that we could find for this job. If there isn't any front-view image for this job,
   * it will return one of job's images (if there is any).
   */
  bestFrontImage?: Maybe<JobImage>;
  captureRequest?: Maybe<CaptureRequest>;
  capturedBy?: Maybe<UserBasicInfo>;
  /** @deprecated This is contained in capturedBy */
  capturedUserId?: Maybe<Scalars['Int']>;
  clientIdentifier?: Maybe<Scalars['String']>;
  /** Returns a boolean indicating if the job is a complete expedited job. */
  completeExpedited: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  createdBy?: Maybe<UserBasicInfo>;
  /** Contain information of this job related to the current_user. */
  currentUserContext: JobCurrentUserContext;
  deliverable?: Maybe<Deliverable>;
  /** Return all deliverable change requests for this job. */
  deliverableChangeRequests: Array<DeliverableChangeRequest>;
  estimatedHoursToCompletion?: Maybe<Scalars['Float']>;
  example?: Maybe<Scalars['Boolean']>;
  externalIdentifier?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** Return all the images for this job */
  images: Array<JobImage>;
  is3dAvailable?: Maybe<Scalars['Boolean']>;
  /**
   * Contains job labels that represents various job status and states. This acts as a translation of internal states
   * and properties of a job into labels that FE can consume easier.
   */
  labels: Array<JobLabels>;
  locationCity?: Maybe<Scalars['String']>;
  locationCountry?: Maybe<Scalars['String']>;
  locationLat?: Maybe<Scalars['String']>;
  locationLine1?: Maybe<Scalars['String']>;
  locationLine2?: Maybe<Scalars['String']>;
  locationLon?: Maybe<Scalars['String']>;
  locationPostalCode?: Maybe<Scalars['String']>;
  locationRegion?: Maybe<Scalars['String']>;
  measurements?: Maybe<JobMeasurements>;
  /** Reason of modeling failure. Will be null unless state field is FAILED. */
  modelFailureReason?: Maybe<Scalars['String']>;
  /** Returns the modeling status for the job. */
  modelingStatus?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /**
   * Returns job notes that are visible to current user ordered by job created_at timestamp. If current
   * user is a pro, current user can see their own notes plus all the homeowner notes on this job.
   */
  notes: NotePaginatedResults;
  /**
   *     A jwt that can be sent in the x-order-data-jwt header when requesting
   * measurement data. This will not be available for example jobs or clone jobs.
   */
  orderDataJwt?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['Int']>;
  /** Returns the org that will pay for this job. */
  paymentOrg?: Maybe<OrgBasicInfo>;
  /** HOVER Now details */
  roofEstimate?: Maybe<RoofEstimate>;
  roofEstimateAccessLevel: RoofEstimateAccessLevels;
  state?: Maybe<JobModelStates>;
  threeDFiles?: Maybe<JobThreeDFiles>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated This is contained in createdBy */
  userId?: Maybe<Scalars['Int']>;
};


export type JobNotesArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

export type JobBasePrice = ApplicationRecord & {
  __typename?: 'JobBasePrice';
  complexity: Complexities;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliverable: Deliverable;
  /** The number of facets or polygons that a job requires to model */
  facetRange: Scalars['String'];
  goodType: Scalars['String'];
  id: Scalars['Int'];
  partnerSubsidy: Scalars['Int'];
  planId: Scalars['Int'];
  /** Price in cents */
  price: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type JobCurrentUserContext = {
  __typename?: 'JobCurrentUserContext';
  /** Return true if current_user is assigned to this job. */
  assignedToMe: Scalars['Boolean'];
  /** Return true if the current_user can approve this job. */
  canApprove: Scalars['Boolean'];
  /** Return true if the current_user can archive this job. */
  canArchive: Scalars['Boolean'];
  /** Return true if the current_user can choose delivery speed for this job. */
  canChooseDeliverySpeed: Scalars['Boolean'];
  /** Return true if a pending capture request is sent by the current_user. */
  captureRequestSentByMe: Scalars['Boolean'];
  /** Return true if a pending capture request is sent to the current_user. */
  captureRequestSentToMe: Scalars['Boolean'];
  /** Return true if current_user created this job. */
  createdByMe: Scalars['Boolean'];
};

/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation and we attempt to correct them when we
 * process the images. You may use the rotated_image_url, rotated_image_small_size_url, rotated_image_medium_size_url,
 * or rotated_image_low_quality_url to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as 1 (lowest image quality and highest compression) to 100 (best quality but
 * least effective compression).
 *
 * The with_signed_url argument has been deprecated. It is always treated as false.
 */
export type JobImage = {
  __typename?: 'JobImage';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Represents the position of the image being taken in respective of the building. Values other than the ones listed
   * below can be ignored.
   *
   * - FRONT: 0
   * - FRONT_RIGHT: 1
   * - RIGHT: 2
   * - BACK_RIGHT: 3
   * - BACK: 4
   * - BACK_LEFT: 5
   * - LEFT: 6
   * - FRONT_LEFT: 7
   */
  cubeFace?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Quality: 50
   */
  imageLowQualityUrl?: Maybe<Scalars['String']>;
  /**
   * Dimensions: 800x800
   * <br />
   * Quality: 60
   */
  imageMediumUrl?: Maybe<Scalars['String']>;
  /**
   * Dimensions: 200x200
   * <br />
   * Quality: 60
   */
  imageSmallUrl?: Maybe<Scalars['String']>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Quality: as originally uploaded
   */
  imageUrl?: Maybe<Scalars['String']>;
  imageVersion: Scalars['Int'];
  /** Represents the kind of image. STANDARD for EHI (3D and measurements); DAMAGE/UNDERWRITING for insurance. */
  kind?: Maybe<JobImageKinds>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Quality: 50
   */
  rotatedImageLowQualityUrl?: Maybe<Scalars['String']>;
  /**
   * Dimensions: 800x800
   * <br />
   * Quality: 60
   */
  rotatedImageMediumUrl?: Maybe<Scalars['String']>;
  /**
   * Dimensions: 200x200
   * <br />
   * Quality: 60
   */
  rotatedImageSmallUrl?: Maybe<Scalars['String']>;
  /**
   * Dimensions: as originally uploaded
   * <br />
   * Quality: as originally uploaded
   */
  rotatedImageUrl?: Maybe<Scalars['String']>;
  rotatedImageVersion: Scalars['Int'];
  /** Represents whether this is an exterior or interior image. */
  viewpoint: JobImageViewpoints;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation and we attempt to correct them when we
 * process the images. You may use the rotated_image_url, rotated_image_small_size_url, rotated_image_medium_size_url,
 * or rotated_image_low_quality_url to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as 1 (lowest image quality and highest compression) to 100 (best quality but
 * least effective compression).
 *
 * The with_signed_url argument has been deprecated. It is always treated as false.
 */
export type JobImageImageLowQualityUrlArgs = {
  withSignedUrl?: Maybe<Scalars['Boolean']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation and we attempt to correct them when we
 * process the images. You may use the rotated_image_url, rotated_image_small_size_url, rotated_image_medium_size_url,
 * or rotated_image_low_quality_url to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as 1 (lowest image quality and highest compression) to 100 (best quality but
 * least effective compression).
 *
 * The with_signed_url argument has been deprecated. It is always treated as false.
 */
export type JobImageImageMediumUrlArgs = {
  withSignedUrl?: Maybe<Scalars['Boolean']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation and we attempt to correct them when we
 * process the images. You may use the rotated_image_url, rotated_image_small_size_url, rotated_image_medium_size_url,
 * or rotated_image_low_quality_url to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as 1 (lowest image quality and highest compression) to 100 (best quality but
 * least effective compression).
 *
 * The with_signed_url argument has been deprecated. It is always treated as false.
 */
export type JobImageImageSmallUrlArgs = {
  withSignedUrl?: Maybe<Scalars['Boolean']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation and we attempt to correct them when we
 * process the images. You may use the rotated_image_url, rotated_image_small_size_url, rotated_image_medium_size_url,
 * or rotated_image_low_quality_url to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as 1 (lowest image quality and highest compression) to 100 (best quality but
 * least effective compression).
 *
 * The with_signed_url argument has been deprecated. It is always treated as false.
 */
export type JobImageImageUrlArgs = {
  withSignedUrl?: Maybe<Scalars['Boolean']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation and we attempt to correct them when we
 * process the images. You may use the rotated_image_url, rotated_image_small_size_url, rotated_image_medium_size_url,
 * or rotated_image_low_quality_url to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as 1 (lowest image quality and highest compression) to 100 (best quality but
 * least effective compression).
 *
 * The with_signed_url argument has been deprecated. It is always treated as false.
 */
export type JobImageRotatedImageLowQualityUrlArgs = {
  withSignedUrl?: Maybe<Scalars['Boolean']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation and we attempt to correct them when we
 * process the images. You may use the rotated_image_url, rotated_image_small_size_url, rotated_image_medium_size_url,
 * or rotated_image_low_quality_url to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as 1 (lowest image quality and highest compression) to 100 (best quality but
 * least effective compression).
 *
 * The with_signed_url argument has been deprecated. It is always treated as false.
 */
export type JobImageRotatedImageMediumUrlArgs = {
  withSignedUrl?: Maybe<Scalars['Boolean']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation and we attempt to correct them when we
 * process the images. You may use the rotated_image_url, rotated_image_small_size_url, rotated_image_medium_size_url,
 * or rotated_image_low_quality_url to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as 1 (lowest image quality and highest compression) to 100 (best quality but
 * least effective compression).
 *
 * The with_signed_url argument has been deprecated. It is always treated as false.
 */
export type JobImageRotatedImageSmallUrlArgs = {
  withSignedUrl?: Maybe<Scalars['Boolean']>;
};


/**
 * URLs for downloading a job's image with different dimensions or quality.
 *
 * Sometimes the uploaded images might not be in the correct orientation and we attempt to correct them when we
 * process the images. You may use the rotated_image_url, rotated_image_small_size_url, rotated_image_medium_size_url,
 * or rotated_image_low_quality_url to get these images that we attempted to fix.
 *
 * Image dimensions are in pixels.
 *
 * Image quality for JPEG is defined as 1 (lowest image quality and highest compression) to 100 (best quality but
 * least effective compression).
 *
 * The with_signed_url argument has been deprecated. It is always treated as false.
 */
export type JobImageRotatedImageUrlArgs = {
  withSignedUrl?: Maybe<Scalars['Boolean']>;
};

export enum JobImageKinds {
  Damage = 'DAMAGE',
  Standard = 'STANDARD',
  Underwriting = 'UNDERWRITING'
}

export enum JobImageViewpoints {
  Exterior = 'EXTERIOR',
  Interior = 'INTERIOR'
}

export enum JobLabels {
  /** When job requires approval, and current_user is not an Org admin. */
  AwaitingApproval = 'AWAITING_APPROVAL',
  /** When job state is CANCELLED. */
  Cancelled = 'CANCELLED',
  /** When job state is COMPLETE. */
  Done = 'DONE',
  /**
   * When the difference between now and job's completedAt exceeds the number of days of historical job access the
   * plan of the current user's org includes.
   */
  LimitedAccess = 'LIMITED_ACCESS',
  /**
   * When job state is FAILED, and job is uploaded manually by HOVER
   * support.
   */
  ManualUploadFailed = 'MANUAL_UPLOAD_FAILED',
  /** When job requires approval, and current_user is an Org admin. */
  NeedsApproval = 'NEEDS_APPROVAL',
  /** When job state is PAYING, and job payment failed. */
  PaymentFailed = 'PAYMENT_FAILED',
  /**
   * When job state is not in one of the states:
   * COMPLETE,
   * FAILED,
   * CANCELLED.
   */
  Processing = 'PROCESSING',
  /** When job state is FAILED, and job is uploaded by user. */
  UserUploadFailed = 'USER_UPLOAD_FAILED'
}

/**
 * For HOVER Now (roof_estimate), all urls will return null.
 *
 * TLA/TLA+ only support pdfUrl, summarizedJsonUrl and sketchJsonUrl. All other urls for TLA/TLA+ will return null.
 */
export type JobMeasurements = {
  __typename?: 'JobMeasurements';
  /** Full version of the measurements JSON file. */
  fullJsonUrl?: Maybe<Scalars['String']>;
  /**
   * A signed URL to download the measurements JSON file. The URL will expire in 10
   * minutes from the time of the request.
   */
  jsonUrl?: Maybe<Scalars['String']>;
  /**
   * A signed URL to download the measurements PDF file. The URL will expire in 10
   * minutes from the time of the request.
   */
  pdfUrl?: Maybe<Scalars['String']>;
  /** Sketch version of the measurements JSON file. Only TLA/TLA+ are supported. Returns nil for other deliverables. */
  sketchJsonUrl?: Maybe<Scalars['String']>;
  /** Summarized version of the measurements JSON file. */
  summarizedJsonUrl?: Maybe<Scalars['String']>;
  version: Scalars['Int'];
};

export enum JobModelStates {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Paying = 'PAYING',
  Processing = 'PROCESSING',
  ProcessingUpload = 'PROCESSING_UPLOAD',
  ProcessingUploadForImprovements = 'PROCESSING_UPLOAD_FOR_IMPROVEMENTS',
  RequestingCorrections = 'REQUESTING_CORRECTIONS',
  RequestingImprovements = 'REQUESTING_IMPROVEMENTS',
  Retrieving = 'RETRIEVING',
  Submitting = 'SUBMITTING',
  Uploading = 'UPLOADING',
  WaitingApproval = 'WAITING_APPROVAL',
  Waitlisted = 'WAITLISTED',
  Working = 'WORKING'
}

/** Paginated results for a given type */
export type JobPaginatedResults = {
  __typename?: 'JobPaginatedResults';
  pagination: Pagination;
  results: Array<Maybe<Job>>;
};

export enum JobSearchFilters {
  NeedsApproval = 'NEEDS_APPROVAL'
}

/**
 * All URLs here are pre-signed S3 URLs for downloading a job's 3D files. The URLs will expire in
 * 10 minutes from the time of the request.
 *
 * The URLs will return null if the 3D files are not available yet.
 *
 * JobThreeDFiles will return null if:
 *
 * <ul>
 *   <li>the job has not been paid for</li>
 *   <li>the current_user's access to the job has been expired (refer to daysOfHistoricalJobAccess under Plan)</li>
 * </ul>
 */
export type JobSharedThreeDFiles = {
  __typename?: 'JobSharedThreeDFiles';
  /** An auth token used to include with firestore requests and queries versions */
  authToken?: Maybe<Scalars['String']>;
  /** A signed URL to download the 3D geometry data of this job in JSON format */
  geometryUrl?: Maybe<Scalars['String']>;
  /** A signed URL to download the 3D metadata of this job in JSON format */
  metadataUrl?: Maybe<Scalars['String']>;
};

export enum JobTestStates {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  No = 'NO'
}

/**
 * All URLs here are pre-signed S3 URLs for downloading a job's 3D files. The URLs will expire in
 * 10 minutes from the time of the request.
 *
 * The URLs will return null if the 3D files are not available yet.
 *
 * JobThreeDFiles will return null if:
 *
 * <ul>
 *   <li>the job has not been paid for</li>
 *   <li>the current_user's access to the job has been expired (refer to daysOfHistoricalJobAccess under Plan)</li>
 * </ul>
 */
export type JobThreeDFiles = {
  __typename?: 'JobThreeDFiles';
  /** A signed URL to download the 3D geometry data of this job in JSON format */
  geometryUrl?: Maybe<Scalars['String']>;
  /** A signed URL to download the 3D metadata of this job in JSON format */
  metadataUrl?: Maybe<Scalars['String']>;
};

/** Arguments for updating a job */
export type JobUpdateArgs = {
  /**
   * An identifier generated/entered by the customer. This can be anything you want. It can be used to
   * reference an ID in the customer application's database. This field can only be updated by the job's
   * creator or admins of the job's org.
   */
  externalIdentifier?: Maybe<Scalars['String']>;
  /** The city of this job's address. */
  locationCity?: Maybe<Scalars['String']>;
  /** The country of the job's address. */
  locationCountry?: Maybe<Scalars['String']>;
  /** The latitude of the job's address. */
  locationLat?: Maybe<Scalars['String']>;
  /** First line of this job's address. */
  locationLine1?: Maybe<Scalars['String']>;
  /** Second line of this job's address. */
  locationLine2?: Maybe<Scalars['String']>;
  /** The longitude of the job's address. */
  locationLon?: Maybe<Scalars['String']>;
  /** The postal code of the job's address. */
  locationPostalCode?: Maybe<Scalars['String']>;
  /** The state/region of this job's address. */
  locationRegion?: Maybe<Scalars['String']>;
  /** A name for this job. */
  name?: Maybe<Scalars['String']>;
};

export enum JobsViewableBy {
  All = 'ALL',
  Me = 'ME',
  Team = 'TEAM'
}

export type Label = {
  __typename?: 'Label';
  id: Scalars['ID'];
  name: Scalars['String'];
};

/** LineItem */
export type LineItem = ApplicationRecord & {
  __typename?: 'LineItem';
  allowVariationSelection: Scalars['Boolean'];
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  custom: Scalars['Boolean'];
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  isAuto?: Maybe<Scalars['Boolean']>;
  /** A margin specific to the line item (as a whole percent, e.g., `8.0'  = 8%) */
  margin?: Maybe<Scalars['Float']>;
  measurement?: Maybe<Scalars['Float']>;
  measurementUnits?: Maybe<MeasurementUnit>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  /** The product assigned to this line item */
  product?: Maybe<ProductCatalogProduct>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: Maybe<Scalars['ID']>;
  /** Foreign key to product_catalog_variation */
  productCatalogVariationId?: Maybe<Scalars['ID']>;
  quantity?: Maybe<Scalars['Float']>;
  /** The measurement of unit being ordered (can be any value in the `line_item_quantity_units' enum) */
  quantityUnits?: Maybe<QuantityUnit>;
  results: Scalars['String'];
  /** A sales tax specific to the line item (as a whole percent, e.g., `10.0'  = 10%) */
  salesTax?: Maybe<Scalars['Float']>;
  /** The variation assigned to this line item */
  selectedVariation?: Maybe<ProductCatalogVariation>;
  /** The category of goods being ordered in this line item (can be any value in the `estimation_line_item_type' enum) */
  type?: Maybe<LineItemTypeEnum>;
  /** The per-unit cost of a line item (multiplied by the `quantity' */
  unitCost?: Maybe<Scalars['Float']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  values?: Maybe<Scalars['String']>;
  wasteFactor?: Maybe<Scalars['Float']>;
};

/** Autogenerated return type of LineItemCreate */
export type LineItemCreatePayload = {
  __typename?: 'LineItemCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  lineItem?: Maybe<EstimationConfigLineItem>;
};

export enum LineItemTypeEnum {
  Labor = 'LABOR',
  Material = 'MATERIAL',
  Other = 'OTHER'
}

/** Autogenerated return type of LineItemUpdate */
export type LineItemUpdatePayload = {
  __typename?: 'LineItemUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  lineItem?: Maybe<LineItem>;
};

/** Production List Item */
export type ListItem = ApplicationRecord & {
  __typename?: 'ListItem';
  /** The quantity that was calculated for the list item, which will be rounded to the next integer for material items. */
  calculatedQuantity?: Maybe<Scalars['Float']>;
  /** The name of the color of this product. For example 'Light Blue' */
  color?: Maybe<Scalars['String']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated Replaced By productCatalogProductId */
  externalProductId?: Maybe<Scalars['ID']>;
  /** The corresponding variation id from the product catalog service */
  externalVariationId?: Maybe<Scalars['ID']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  isManualMeasurement?: Maybe<Scalars['Boolean']>;
  /** The optional id of the estimation_line_item this list item refers to */
  lineItemId?: Maybe<Scalars['Int']>;
  /** The float amount for this list item */
  measurement?: Maybe<Scalars['Float']>;
  /** The label for units that the measurement describes */
  measurementUnits?: Maybe<Scalars['String']>;
  /** The name label of this list item */
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  pretaxCost: Scalars['Float'];
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: Maybe<Scalars['ID']>;
  productionList: ProductionList;
  /** The integer quantity of the list item */
  quantity: Scalars['Float'];
  quantityUnits?: Maybe<QuantityUnitsEnum>;
  /** The SKU for this product in the provider's catalog. This will be used for automatic ordering */
  sku?: Maybe<Scalars['String']>;
  /** @deprecated replaced by userSetCustomSku */
  skuChangedByUser?: Maybe<Scalars['Boolean']>;
  /** Controls the sort order of ListItems on the ProductionList */
  sortOrder?: Maybe<Scalars['Int']>;
  /** The tax % between 0 and 1 that will be applied to this item */
  taxPercent: Scalars['Float'];
  /** The calculated total COST, including sales tax, for this item */
  totalCost: Scalars['Float'];
  totalPrice?: Maybe<Scalars['Float']>;
  tradeType: TradeTypeEnum;
  /** The LineItemType of this ListItem */
  type: LineItemTypeEnum;
  /** The unit cost of the list item */
  unitCost: Scalars['Float'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  userSetCustomColor: Scalars['Boolean'];
  /**
   * The sku can be automatically populated from a matching product in the product
   * catalog. It can also be manually overridden by the user. This boolean keeps
   * track of if the user changed the sku themselves vs sticking with the sku we
   * get from the product catalog.
   */
  userSetCustomSku: Scalars['Boolean'];
  /**
   * Whether the user overrode the unit cost of the item. If true, will never
   * automatically update item's unit_cost from Product Catalog
   */
  userSetCustomUnitCost: Scalars['Boolean'];
  vendor?: Maybe<Vendor>;
  /** The waste factor of the measurement between 0 and 1 */
  wasteFactor?: Maybe<Scalars['Float']>;
};

/** Arguments for creating a List Item */
export type ListItemCreate = {
  /** The name of the color of this product. For example 'Light Blue' */
  color?: Maybe<Scalars['String']>;
  externalProductId?: Maybe<Scalars['ID']>;
  /** The corresponding variation id from the product catalog service */
  externalVariationId?: Maybe<Scalars['ID']>;
  /** The float amount for this list item */
  measurement?: Maybe<Scalars['Float']>;
  /** The label for units that the measurement describes */
  measurementUnits?: Maybe<Scalars['String']>;
  /** The name label of this list item */
  name: Scalars['String'];
  notes?: Maybe<Scalars['String']>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: Maybe<Scalars['ID']>;
  /** The integer quantity of the list item */
  quantity?: Maybe<Scalars['Float']>;
  quantityUnits?: Maybe<QuantityUnitsEnum>;
  /** The SKU for this product in the provider's catalog. This will be used for automatic ordering */
  sku?: Maybe<Scalars['String']>;
  skuChangedByUser?: Maybe<Scalars['Boolean']>;
  tradeType?: Maybe<TradeTypeEnum>;
  /** The LineItemType of this ListItem */
  type?: Maybe<LineItemTypeEnum>;
  /** The unit cost of the list item */
  unitCost?: Maybe<Scalars['Float']>;
  userSetCustomColor?: Maybe<Scalars['Boolean']>;
  /**
   * The sku can be automatically populated from a matching product in the product
   * catalog. It can also be manually overridden by the user. This boolean keeps
   * track of if the user changed the sku themselves vs sticking with the sku we
   * get from the product catalog.
   */
  userSetCustomSku?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the user overrode the unit cost of the item. If true, will never
   * automatically update item's unit_cost from Product Catalog
   */
  userSetCustomUnitCost?: Maybe<Scalars['Boolean']>;
  /** the vendor that this item will be fulfilled through */
  vendorId?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of ListItemCreate */
export type ListItemCreatePayload = {
  __typename?: 'ListItemCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  listItem?: Maybe<ListItem>;
};

/** Arguments for updating a List Item */
export type ListItemUpdate = {
  /** The name of the color of this product. For example 'Light Blue' */
  color?: Maybe<Scalars['String']>;
  /** The corresponding variation id from the product catalog service */
  externalVariationId?: Maybe<Scalars['ID']>;
  /** The float amount for this list item */
  measurement?: Maybe<Scalars['Float']>;
  /** The label for units that the measurement describes */
  measurementUnits?: Maybe<Scalars['String']>;
  /** The name label of this list item */
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['String']>;
  /** The integer quantity of the list item */
  quantity?: Maybe<Scalars['Float']>;
  /** The SKU for this product in the provider's catalog. This will be used for automatic ordering */
  sku?: Maybe<Scalars['String']>;
  skuChangedByUser?: Maybe<Scalars['Boolean']>;
  tradeType?: Maybe<TradeTypeEnum>;
  /** The LineItemType of this ListItem */
  type?: Maybe<LineItemTypeEnum>;
  /** The unit cost of the list item */
  unitCost?: Maybe<Scalars['Float']>;
  userSetCustomColor?: Maybe<Scalars['Boolean']>;
  /**
   * The sku can be automatically populated from a matching product in the product
   * catalog. It can also be manually overridden by the user. This boolean keeps
   * track of if the user changed the sku themselves vs sticking with the sku we
   * get from the product catalog.
   */
  userSetCustomSku?: Maybe<Scalars['Boolean']>;
  /**
   * Whether the user overrode the unit cost of the item. If true, will never
   * automatically update item's unit_cost from Product Catalog
   */
  userSetCustomUnitCost?: Maybe<Scalars['Boolean']>;
  /** the vendor that this item will be fulfilled through */
  vendorId?: Maybe<Scalars['Int']>;
};

/** Autogenerated return type of ListItemUpdate */
export type ListItemUpdatePayload = {
  __typename?: 'ListItemUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  listItem?: Maybe<ListItem>;
};

export type MEdge = {
  __typename?: 'MEdge';
  /** This id does not persist but is guaranteed to beconsistent as long as the geometry doesn't change. */
  id: Scalars['ID'];
  /** (Unit: inch) */
  length: Scalars['Float'];
  vertices: Array<Vertex>;
};

export type MeasurementFootprint = {
  __typename?: 'MeasurementFootprint';
  area: Scalars['Float'];
  perimeter: Scalars['Float'];
};

export enum MeasurementUnit {
  LinearFeet = 'LINEAR_FEET',
  Squares = 'SQUARES',
  SquareFeet = 'SQUARE_FEET'
}

export type Measurements = {
  __typename?: 'Measurements';
  summary: Summary;
};

export type MeasurementsCornice = {
  __typename?: 'MeasurementsCornice';
  end: Vector3;
  kind: MeasurementsCorniceKind;
  length: Scalars['Float'];
  start: Vector3;
};

export enum MeasurementsCorniceKind {
  /** The cornice returns towards the center of the rake */
  Return = 'RETURN',
  /** The cornice spans across the entire rake */
  Strip = 'STRIP'
}

export type MeasurementsSoffit = {
  __typename?: 'MeasurementsSoffit';
  area: Scalars['Float'];
  depthRange: MeasurementsSoffitDepthRange;
  kind: MeasurementsSoffitKind;
  length: Scalars['Float'];
};

export enum MeasurementsSoffitDepthRange {
  Depth_0To_1Inches = 'DEPTH_0_TO_1_INCHES',
  Depth_12To_18Inches = 'DEPTH_12_TO_18_INCHES',
  Depth_18To_24Inches = 'DEPTH_18_TO_24_INCHES',
  Depth_1To_6Inches = 'DEPTH_1_TO_6_INCHES',
  Depth_24To_48Inches = 'DEPTH_24_TO_48_INCHES',
  Depth_48ToInfInches = 'DEPTH_48_TO_INF_INCHES',
  Depth_6To_12Inches = 'DEPTH_6_TO_12_INCHES'
}

export enum MeasurementsSoffitKind {
  /** Horizontal soffit */
  Eave = 'EAVE',
  /** Sloped soffit */
  Rake = 'RAKE'
}

export enum MobileApplicationOs {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type MobileDevice = ApplicationRecord & {
  __typename?: 'MobileDevice';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  /**
   * The token from registering device with ios - Apple Push Notification(APN) or android - Firebase Cloud Messaging(FCM).
   * It's an app-specific device token.
   */
  token?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** UUID of the mobile device. */
  uuid?: Maybe<Scalars['String']>;
};

/** Arguments for registering a mobile device for push notifications */
export type MobileDeviceArgs = {
  /**
   * The token from registering device with ios - Apple Push Notification(APN) or android - Firebase Cloud Messaging(FCM).
   * It's an app-specific device token.
   */
  token: Scalars['String'];
  /** UUID of the mobile device. */
  uuid?: Maybe<Scalars['String']>;
};

export type Model = {
  __typename?: 'Model';
  cornices: Array<MeasurementsCornice>;
  drainage: Drainage;
  faces: Array<Face>;
  footprint?: Maybe<MeasurementFootprint>;
  orderId: Scalars['Int'];
  soffits: Array<MeasurementsSoffit>;
  totalLivingArea?: Maybe<Scalars['Float']>;
  version: Scalars['String'];
};

export type ModelScreenshot = {
  __typename?: 'ModelScreenshot';
  id: Scalars['String'];
  placeholderUrl: Scalars['String'];
  jobId: Scalars['Int'];
  userId: Scalars['Int'];
  rendering: Rendering;
  createdAt: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  createSignedUrlForScreenshot?: Maybe<SignedUrl>;
  createModelScreenshot?: Maybe<ModelScreenshot>;
  deleteModelScreenshot?: Maybe<Scalars['Boolean']>;
  /** Deletes an oauth token. Removing the connection between an org and distributor. */
  distributionOauthTokenDelete?: Maybe<OauthTokenDeletePayload>;
  /** Set up an order with given distributor and trigger order checking asynchronously */
  distributionOrderSetup?: Maybe<OrderSetupPayload>;
  /** Submit a DistributionOrder to associated distributor for fulfillment */
  distributionOrderSubmit?: Maybe<OrderSubmitPayload>;
  /** Adds a product to an Org's catalog */
  productCatalogConfigOrgProductCreate?: Maybe<OrgProductCreatePayload>;
  /** Change an organization's product catalog related settings */
  productCatalogOrgSettingsUpdate?: Maybe<OrgSettingsUpdatePayload>;
  addDiscountFromCode: AppliedDiscount;
  /** Approve a job with the given ID. Only an Org Admin can approve jobs. */
  approveJob: Job;
  /**
   * Archive a job with the given ID. Example jobs cannot be archived. Only jobs in the following
   * JobModelStates can be archived: UPLOADING, PROCESSING_UPLOAD, WAITING_APPROVAL, PAYING, COMPLETE, FAILED, CANCELLED
   */
  archiveJob: Job;
  authenticate: AuthenticationResponse;
  authenticateWithCookie: AuthenticationResponse;
  /**
   * Authenticate using a previously issued user signin token. Each user signin
   * token is only valid to be used once and will be deleted after successful authentication.
   */
  authenticateWithUserSigninToken: AuthenticationResponse;
  createCaptureRequest: CaptureRequest;
  /**
   * Create a capture session token for the current_user so that the FE client may forward this token to the service
   * that handles our photo captures.
   */
  createCaptureSessionToken: CaptureSession;
  /**
   * Create a deliverable change request for a job. Upgrade only. A job can only have 1 pending (not complete or failed)
   * deliverable change request at a time.
   */
  createDeliverableChangeRequest: DeliverableChangeRequest;
  /**
   * Create a domain claim record. An error will return if domain argument is blank, current user cannot manage org, org
   * does not have single sign on feature enabled, or org has 10 number of domain claims.
   */
  createDomainClaim: DomainClaim;
  /**
   *     Creates a storage scope session token for the current_user so that the FE
   * client may forward this token to the service.
   */
  createFileStorageToken: FileStorageToken;
  createHomeowner: AuthenticationResponse;
  /**
   * Create a note for the job with the given ID. Users can only create notes for jobs their
   * org has access to.
   */
  createNote: Note;
  /**
   * This mutation adds a user in an org with the given orgId. It also sends an invitation email to the new user.
   *
   * Requires the current user to have permission to add users in the given org, i.e., org admin.
   *
   * If a user with the given email already exists, it will return an error message.
   *
   * If aclTemplate is given, and the current user does not have permission to manage permissions, it will return an
   * error message.
   */
  createOrgUser: User;
  createProUser: AuthenticationResponse;
  /**
   * Set reference measurements info for the job with the given ID.
   * Users can only create reference measurements for jobs their org has access to.
   */
  createReferenceMeasurements: ReferenceMeasurements;
  /**
   * Create a single sign on configuration for the given org. An error will be returned
   * if one already exists, if the org does not have access to signle sign on, or if the
   * current user is not an org admin.
   */
  createSsoConfig: SsoConfig;
  /**
   * Delete a capture request with the given ID. A capture request can only be
   * deleted by its requesting user. Capture requests in the COMPLETE state
   * cannot be deleted.
   */
  deleteCaptureRequest: CaptureRequest;
  /**
   * Delete a domain claim record. An error will return if current user cannot manage creator org, or if org
   * does not have single sign on feature enabled.
   */
  deleteDomainClaim: DomainClaim;
  /** Delete a note with the given ID. The user must have access to the note's job and org. */
  deleteNote: Note;
  refreshJwt: Jwt;
  /**
   * This mutation registers user's mobile device for push notifications.
   *
   * It will look for existing mobile device records by the UUID, then by token. If there isn't a matching
   * mobile device record, it creates a new mobile device record.
   *
   * If the attempt is successful, the mobile device is ready to receive push notifications.
   *
   * If the attempt is not successful, it will return an error message.
   */
  registerMobileDevice: MobileDevice;
  /**
   * Removes a team member's access to the org given their user_id and org_id.
   * It returns user details on successful removal. This will log the removed user
   * out of the app.
   */
  removeTeamMember: User;
  resetCurrentUserPassword: AuthenticationResponse;
  resetPassword: AuthenticationResponse;
  /**
   * Revokes the access token sent in the X-JWT-AUTH request header. This can be used
   * to sign out a user. Does nothing if the access token is invalid.
   */
  revokeAccessToken: Scalars['Boolean'];
  /** Sends an email invite and an SMS, if a phone number of the capturing user is provided, for capturing property */
  sendCaptureRequestNotification: CaptureRequest;
  /**
   * Sends a reset password email to a user with the given email address if it exists. In the email, a Branch IO link is
   * included with action=reset_password and reset_password_token={some_reset_password_token} for deep linking purposes.
   * The reset_password_token can then be used in the resetPassword mutation. A reset_password_token can only be used
   * for one time. If you are requesting this mutation for more than one time for the same email address, only the
   * latest reset_password_token will be valid.
   *
   * This mutation will always return true.
   */
  sendResetPasswordInstructions: Scalars['Boolean'];
  /** Un-archive a job with the given ID. Only Org Admin can un-archive a job. */
  unarchiveJob: Job;
  /** This mutation allows updating a job. */
  updateJob: Job;
  /**
   * This mutation allows updating the body of a note. Only the owner of the note can perform
   * this action(the user_id on note record needs to match current_user id).
   */
  updateNote: Note;
  /** This mutation allows a user to update an org's name if that user has permission to manage that org, i.e. org admin. */
  updateOrg: Org;
  /** This mutation allows for the update of org preferences. Only admins are able to edit org preferences. */
  updateOrgPreferences: OrgPreferences;
  /**
   * Update a single sign on configuration. An error will be returned if current user cannot manage org,
   * org is not the creator of the SSO config, org SSO feature access is disabled, or one of the required
   * SSO config arguments is missing.
   */
  updateSsoConfig: SsoConfig;
  /**
   * This mutation allows the current user to update a user's firstName, lastName, mobilePhone, officePhone, and/or
   * requireJobApproval.
   *
   * If the id argument is given, it will attempt to update the target user with the given id provided that the
   * current_user is an Org admin of the target user.
   *
   * If the id argument is not given, it will update the current_user.
   *
   * Only Org admin can modify requireJobApproval. If requireJobApproval arg is given and the user does not have
   * permission to modify it, it will return an error message and no update will be performed.
   */
  updateUser: User;
  /** This mutation allows an org admin to update a user's ACL template */
  updateUserAclTemplate: User;
  /** This mutation allows the current user to update its own settings for an Org. */
  updateUserOrgSettings: User;
  updateWallet: Wallet;
  /**
   * This mutation updates the brand record once the logo has
   * been successfully uploaded using the generated logo upload url
   */
  uploadedBrandLogo: Brand;
  /**
   * This mutation updates the user record once the profile picture has
   * been sucessfully uploaded using the generated profile picture upload url
   */
  uploadedProfilePicture: User;
  /**
   * Verify a domain claim record.
   * It does nothing if the domain claim record has been verified or if it's unprocessable.
   * It marks the domain claim record unprocessable if the domain has been claimed.
   * It fails the domain claim record if the requested text value cannot be found on the domain DNS.
   * An error will return if current user cannot manage org or org does not have single sign on feature enabled.
   */
  verifyDomainClaim: DomainClaim;
  /** Create an EstimationConfigLineItem */
  estimationConfigLineItemCreate?: Maybe<LineItemCreatePayload>;
  /** This mutation can be used to create a discount/promotion. */
  estimationDiscountCreate?: Maybe<DiscountCreatePayload>;
  /** This mutation can be used to delete a discount/promotion. */
  estimationDiscountDelete?: Maybe<DiscountDeletePayload>;
  /** This mutation can be used to update a discount/promotion. */
  estimationDiscountUpdate?: Maybe<DiscountUpdatePayload>;
  /** Creates an Estimate Group */
  estimationEstimateGroupCreate?: Maybe<EstimateGroupCreatePayload>;
  /** This mutation can be used to update an estimate. */
  estimationEstimateUpdate?: Maybe<EstimateUpdatePayload>;
  /** This mutation can be used to update a line item. */
  estimationLineItemUpdate?: Maybe<LineItemUpdatePayload>;
  /** Generates a JSON Web Token for the authenticated user for remote services */
  generateRemoteJWT?: Maybe<GenerateRemoteJwtPayload>;
  /** Creates Inspection Checklist */
  inspectionChecklistCreate?: Maybe<ChecklistCreatePayload>;
  /** This mutation is used to update an inspection checklist, including answers to questions */
  inspectionChecklistUpdate?: Maybe<ChecklistUpdatePayload>;
  /** Updates an org proposal settings. */
  projectManagementConfigOrgProposalSettingUpdate?: Maybe<OrgProposalSettingUpdatePayload>;
  /**
   * Creates a proposal template page. Must be an html page type and it will be
   * sorted at the end of the current orgs proposal template.
   */
  projectManagementConfigProposalTemplatePageCreate?: Maybe<ProposalTemplatePageCreatePayload>;
  /** Deletes a proposal template page. */
  projectManagementConfigProposalTemplatePageDelete?: Maybe<ProposalTemplatePageDeletePayload>;
  /** Updates a proposal template page. */
  projectManagementConfigProposalTemplatePageUpdate?: Maybe<ProposalTemplatePageUpdatePayload>;
  /**
   * Updates the sort order of a proposal template's pages to the order of the
   * proposal template page ids provided in the array input.
   */
  projectManagementConfigProposalTemplatesPagesSortOrderUpdate?: Maybe<ProposalTemplatesPagesSortOrderUpdatePayload>;
  projectManagementListItemCreate?: Maybe<ListItemCreatePayload>;
  projectManagementListItemUpdate?: Maybe<ListItemUpdatePayload>;
  /** This mutation is used to set-up an order */
  projectManagementOrderCreate?: Maybe<OrderCreatePayload>;
  /** Create an OrderDocument */
  projectManagementOrderDocumentCreate?: Maybe<OrderDocumentCreatePayload>;
  /** This mutation is used to set-up an order for fulfillment with a distributor */
  projectManagementOrderFulfillmentStart?: Maybe<OrderFulfillmentStartPayload>;
  /** Creates proposal document */
  projectManagementProposalDocumentCreate?: Maybe<ProposalDocumentCreatePayload>;
  /** Creates proposal document preview */
  projectManagementProposalDocumentPreviewCreate?: Maybe<ProposalDocumentPreviewCreatePayload>;
  /** Creates a signature request */
  projectManagementSignatureRequestCreate?: Maybe<SignatureRequestCreatePayload>;
  /** Updates a Sales Opportunity */
  salesOpportunityUpdate?: Maybe<SalesOpportunityUpdatePayload>;
};


export type MutationCreateModelScreenshotArgs = {
  camera: CameraInput;
  aspectRatio: Scalars['Float'];
  jobId: Scalars['Int'];
  uploadKey: Scalars['String'];
};


export type MutationDeleteModelScreenshotArgs = {
  id: Scalars['String'];
  jobId: Scalars['Int'];
};


export type MutationDistributionOauthTokenDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationDistributionOrderSetupArgs = {
  orderAttributes: DistributionOrderCreateInput;
  orgId?: Maybe<Scalars['ID']>;
};


export type MutationDistributionOrderSubmitArgs = {
  distributionOrderId: Scalars['ID'];
};


export type MutationProductCatalogConfigOrgProductCreateArgs = {
  attributes: ProductCatalogConfigOrgProductCreateInput;
};


export type MutationProductCatalogOrgSettingsUpdateArgs = {
  enableAllVariationsByProductIds?: Maybe<Array<Scalars['ID']>>;
  orgId: Scalars['ID'];
  orgVariationsAttributes?: Maybe<Array<ProductCatalogOrgVariationNestedInput>>;
  productFilteringEnabled?: Maybe<Scalars['Boolean']>;
};


export type MutationAddDiscountFromCodeArgs = {
  code: Scalars['String'];
  orgId: Scalars['Int'];
};


export type MutationApproveJobArgs = {
  id: Scalars['Int'];
};


export type MutationArchiveJobArgs = {
  id: Scalars['Int'];
};


export type MutationAuthenticateArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationAuthenticateWithUserSigninTokenArgs = {
  userSigninToken: Scalars['String'];
};


export type MutationCreateCaptureRequestArgs = {
  capturingUserEmail: Scalars['String'];
  capturingUserName: Scalars['String'];
  capturingUserPhone?: Maybe<Scalars['String']>;
  job: CaptureRequestJobArgs;
  signupType?: Maybe<CaptureRequestSignupTypes>;
};


export type MutationCreateDeliverableChangeRequestArgs = {
  jobId: Scalars['Int'];
  newDeliverableId: Scalars['Int'];
};


export type MutationCreateDomainClaimArgs = {
  domain: Scalars['String'];
  orgId: Scalars['Int'];
};


export type MutationCreateFileStorageTokenArgs = {
  storageScope: FileStorageScopes;
};


export type MutationCreateHomeownerArgs = {
  distinctId?: Maybe<Scalars['String']>;
  orgCode?: Maybe<Scalars['String']>;
  user: UserArgs;
};


export type MutationCreateNoteArgs = {
  jobId: Scalars['Int'];
  note: NoteArgs;
};


export type MutationCreateOrgUserArgs = {
  aclTemplate?: Maybe<AclTemplateOptions>;
  orgId: Scalars['Int'];
  user: OrgUserCreateArgs;
};


export type MutationCreateProUserArgs = {
  distinctId?: Maybe<Scalars['String']>;
  org: OrgArgs;
  orgCode?: Maybe<Scalars['String']>;
  parentOrgCode?: Maybe<Scalars['String']>;
  user: UserArgs;
};


export type MutationCreateReferenceMeasurementsArgs = {
  description: Scalars['String'];
  imageId: Scalars['Int'];
  jobId: Scalars['Int'];
  widthInches: Scalars['Float'];
};


export type MutationCreateSsoConfigArgs = {
  orgId: Scalars['Int'];
  ssoConfig: SsoConfigArgs;
};


export type MutationDeleteCaptureRequestArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteDomainClaimArgs = {
  id: Scalars['Int'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['Int'];
};


export type MutationRefreshJwtArgs = {
  refreshToken: Scalars['String'];
};


export type MutationRegisterMobileDeviceArgs = {
  identifier: Scalars['String'];
  mobileDevice: MobileDeviceArgs;
  os: MobileApplicationOs;
};


export type MutationRemoveTeamMemberArgs = {
  orgId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationResetCurrentUserPasswordArgs = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};


export type MutationSendCaptureRequestNotificationArgs = {
  id: Scalars['Int'];
};


export type MutationSendResetPasswordInstructionsArgs = {
  email: Scalars['String'];
};


export type MutationUnarchiveJobArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateJobArgs = {
  id: Scalars['Int'];
  job: JobUpdateArgs;
};


export type MutationUpdateNoteArgs = {
  id: Scalars['Int'];
  note: NoteArgs;
};


export type MutationUpdateOrgArgs = {
  org: OrgArgs;
  orgId: Scalars['Int'];
};


export type MutationUpdateOrgPreferencesArgs = {
  deliverableId?: Maybe<Scalars['Int']>;
  orgId: Scalars['Int'];
};


export type MutationUpdateSsoConfigArgs = {
  ssoConfig: SsoConfigArgs;
  ssoConfigId: Scalars['Int'];
};


export type MutationUpdateUserArgs = {
  id?: Maybe<Scalars['Int']>;
  user: UserUpdateArgs;
};


export type MutationUpdateUserAclTemplateArgs = {
  aclTemplate: AclTemplateOptions;
  orgId: Scalars['Int'];
  userId: Scalars['Int'];
};


export type MutationUpdateUserOrgSettingsArgs = {
  ccAdminOnEmails?: Maybe<Scalars['Boolean']>;
  orgId: Scalars['Int'];
};


export type MutationUpdateWalletArgs = {
  wallet: WalletArgs;
  walletId: Scalars['Int'];
};


export type MutationUploadedBrandLogoArgs = {
  orgId: Scalars['Int'];
};


export type MutationVerifyDomainClaimArgs = {
  id: Scalars['Int'];
};


export type MutationEstimationConfigLineItemCreateArgs = {
  lineItemAttributes: EstimationEstimateConfigLineItemCreateInput;
};


export type MutationEstimationDiscountCreateArgs = {
  discountAttributes: EstimationDiscountCreate;
};


export type MutationEstimationDiscountDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationEstimationDiscountUpdateArgs = {
  discountAttributes: EstimationDiscountUpdate;
  id: Scalars['ID'];
};


export type MutationEstimationEstimateGroupCreateArgs = {
  customLineItems?: Maybe<Array<EstimationEstimateGroupCreateCustomLineItem>>;
  estimateGroupAttributes: EstimationEstimateGroupCreate;
  inputs: Array<EstimationEstimateGroupCreateInput>;
  templateIds?: Maybe<Array<Scalars['ID']>>;
  tradeTypeAttributes?: Maybe<Array<EstimationEstimateGroupCreateTradeTypeAttributeInput>>;
};


export type MutationEstimationEstimateUpdateArgs = {
  estimateAttributes: EstimateUpdate;
  id: Scalars['ID'];
};


export type MutationEstimationLineItemUpdateArgs = {
  id: Scalars['ID'];
  lineItemAttributes: EstimationLineItemUpdateInput;
};


export type MutationGenerateRemoteJwtArgs = {
  remoteService: RemoteService;
};


export type MutationInspectionChecklistCreateArgs = {
  jobId: Scalars['ID'];
  orgId: Scalars['ID'];
  questionsAttributes: Array<InspectionChecklistQuestionCreateInput>;
};


export type MutationInspectionChecklistUpdateArgs = {
  checklistId: Scalars['ID'];
  questionsAttributes?: Maybe<Array<InspectionChecklistQuestionUpdateInput>>;
};


export type MutationProjectManagementConfigOrgProposalSettingUpdateArgs = {
  attributes: ProjectManagementConfigOrgProposalSettingUpdate;
  orgId: Scalars['ID'];
};


export type MutationProjectManagementConfigProposalTemplatePageCreateArgs = {
  orgId: Scalars['ID'];
  proposalTemplatePageAttributes: ProjectManagementConfigProposalTemplatePageCreateInput;
};


export type MutationProjectManagementConfigProposalTemplatePageDeleteArgs = {
  id: Scalars['ID'];
};


export type MutationProjectManagementConfigProposalTemplatePageUpdateArgs = {
  attributes: ProjectManagementConfigProposalTemplatePageCreateInput;
  id: Scalars['ID'];
};


export type MutationProjectManagementConfigProposalTemplatesPagesSortOrderUpdateArgs = {
  orgId: Scalars['ID'];
  proposalTemplatePageIds: Array<Scalars['ID']>;
};


export type MutationProjectManagementListItemCreateArgs = {
  listItemAttributes: ListItemCreate;
  productionListId: Scalars['Int'];
};


export type MutationProjectManagementListItemUpdateArgs = {
  listItemAttributes: ListItemUpdate;
  listItemId: Scalars['Int'];
};


export type MutationProjectManagementOrderCreateArgs = {
  orderAttributes: ProjectManagementOrderCreateInput;
  orgId?: Maybe<Scalars['ID']>;
};


export type MutationProjectManagementOrderDocumentCreateArgs = {
  externalIdentifier?: Maybe<Scalars['String']>;
  listItemIds?: Maybe<Array<Scalars['ID']>>;
  orderDocumentAttributes: OrderDocumentCreate;
};


export type MutationProjectManagementOrderFulfillmentStartArgs = {
  orderId: Scalars['ID'];
};


export type MutationProjectManagementProposalDocumentCreateArgs = {
  proposalDocumentAttributes: ProjectManagementProposalDocumentCreate;
};


export type MutationProjectManagementProposalDocumentPreviewCreateArgs = {
  orgId: Scalars['ID'];
};


export type MutationProjectManagementSignatureRequestCreateArgs = {
  signatureRequestAttributes: ProjectManagementSignatureRequestCreate;
};


export type MutationSalesOpportunityUpdateArgs = {
  id: Scalars['ID'];
  salesOpportunityAttributes: SalesOpportunityUpdate;
};

export type Note = ApplicationRecord & {
  __typename?: 'Note';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Information on whether current_user can update or delete the note */
  currentUserContext: NoteCurrentUserContext;
  id: Scalars['Int'];
  org?: Maybe<OrgBasicInfo>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  user?: Maybe<UserBasicInfo>;
};

/** Arguments for creating a note */
export type NoteArgs = {
  /** The note's text */
  body: Scalars['String'];
};

export type NoteCurrentUserContext = {
  __typename?: 'NoteCurrentUserContext';
  canDeleteNote: Scalars['Boolean'];
  canUpdateNote: Scalars['Boolean'];
};

/**
 * Paginated results for a given type. Total pages or count is not provided. Instead, an hasNextPage boolean is
 * provided.
 */
export type NotePaginatedResults = {
  __typename?: 'NotePaginatedResults';
  pagination: PaginationWithoutCount;
  results: Array<Maybe<Note>>;
};

/** Autogenerated return type of OauthTokenDelete */
export type OauthTokenDeletePayload = {
  __typename?: 'OauthTokenDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
};

export type Openings = {
  __typename?: 'Openings';
  /** Opening data by face. */
  perFace: Array<OpeningsPerFace>;
  /** Count of siding and other openings. */
  quantity: OpeningsCount;
  /** Length of siding and other sides. */
  sidesLength: OpeningsLengths;
  /** Length of siding and other sills. */
  sillsLength: OpeningsLengths;
  /** Length of siding and other tops. */
  topsLength: OpeningsLengths;
  /** Total length of siding and other opening sides. */
  totalPerimeter: OpeningsLengths;
  /** Cumulative window data */
  windows: WindowData;
};

export type OpeningsCount = {
  __typename?: 'OpeningsCount';
  /** Length of siding and other tops. */
  other: Scalars['Int'];
  /** Count of siding and other openings. */
  siding: Scalars['Int'];
};

export type OpeningsData = {
  __typename?: 'OpeningsData';
  /** List of each opinings' labels. */
  labels?: Maybe<Array<Scalars['String']>>;
  /** Count of openings lengths. */
  openingsTotal?: Maybe<Scalars['Int']>;
  /** Total length of opening sides. */
  sides?: Maybe<Scalars['Float']>;
  /** Length of bottom of opening. */
  sills?: Maybe<Scalars['Float']>;
  /** Length of top of opening. */
  tops?: Maybe<Scalars['Float']>;
};

export type OpeningsLengths = {
  __typename?: 'OpeningsLengths';
  /** Length of siding and other tops. */
  other: Scalars['Float'];
  /** Count of siding and other openings. */
  siding: Scalars['Float'];
};

export type OpeningsPerFace = {
  __typename?: 'OpeningsPerFace';
  /** Label of face */
  face: Scalars['String'];
  /** Number of openings on this face. */
  quantity: Scalars['Int'];
  /** Sum of opening sides lengths on this face. */
  sidesLength: Scalars['Float'];
  /** Sum of opening bottoms lengths on this face. */
  sillLength: Scalars['Float'];
  /** Sum of opening top lengths on this face. */
  topLength: Scalars['Float'];
  /** Type of face; siding or other. */
  type: Scalars['String'];
};

/** Autogenerated return type of OrderCreate */
export type OrderCreatePayload = {
  __typename?: 'OrderCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  order?: Maybe<ProjectManagementOrder>;
};

/** Order Document */
export type OrderDocument = ApplicationRecordUuid & {
  __typename?: 'OrderDocument';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  order: ProjectManagementOrder;
  pdf?: Maybe<File>;
  productionList: ProductionList;
  state: Scalars['String'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The User that created this ProjectManagementOrderDocument. */
  user: User;
  /** The ID of the user that created this order document */
  userId: Scalars['Int'];
};

/** Arguments for creating an OrderDocument */
export type OrderDocumentCreate = {
  externalIdentifier?: Maybe<Scalars['String']>;
  footerHtml?: Maybe<Scalars['String']>;
  /**
   * The front-end generates an HTML representation of the document. Then sends
   * that to the backend to be rendered into a PDF. This is the HTML string that
   * the front-end generates.
   */
  inputHtml: Scalars['String'];
  /** The description to be saved to ProjectManagement::Order and to be included in OrderDocument */
  notes?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  productionListId: Scalars['ID'];
  vendorId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of OrderDocumentCreate */
export type OrderDocumentCreatePayload = {
  __typename?: 'OrderDocumentCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  orderDocument?: Maybe<OrderDocument>;
};

/** Autogenerated return type of OrderFulfillmentStart */
export type OrderFulfillmentStartPayload = {
  __typename?: 'OrderFulfillmentStartPayload';
  /** Validation Errors */
  errors?: Maybe<Array<Error>>;
  order?: Maybe<ProjectManagementOrder>;
};

/** Autogenerated return type of OrderSetup */
export type OrderSetupPayload = {
  __typename?: 'OrderSetupPayload';
  /** Validation Errors */
  errors: Array<Error>;
  order?: Maybe<DistributionOrder>;
};

/** Autogenerated return type of OrderSubmit */
export type OrderSubmitPayload = {
  __typename?: 'OrderSubmitPayload';
  /** Validation Errors */
  errors: Array<Error>;
  order?: Maybe<DistributionOrder>;
};

export type Org = ApplicationRecord & OrgNames & {
  __typename?: 'Org';
  ancestralName?: Maybe<Scalars['String']>;
  /** A list of discounts that has been applied to this org. */
  appliedDiscounts?: Maybe<Array<AppliedDiscount>>;
  /**
   * Returns the deliverables available for this org / user. First it checks org settings.
   * If there is no deliverable under settings then it returns partner deliverables, else it returns an empty array.
   * If the org's plan allows instant estimate then the roof estimate deliverable (HOVER Now) is included too.
   * But if jobs require approval for the user than HOVER Now is removed,
   * unless the org setting has auto approve roof estimate.
   */
  availableDeliverables: Array<Deliverable>;
  /** A list of wallets that this org can use for billing. */
  billableWallets: Array<BillableWallet>;
  /** The brand of this org. It includes company logo and RGB color scheme */
  brand?: Maybe<Brand>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Contains information of this org related to the current_user. */
  currentUserContext: OrgCurrentUserContext;
  /** The organization's address city */
  custServCity?: Maybe<Scalars['String']>;
  /** The organization's address country */
  custServCountry?: Maybe<Scalars['String']>;
  /** The organization's address line 1 */
  custServLine1?: Maybe<Scalars['String']>;
  /** The organization's address line 2 */
  custServLine2?: Maybe<Scalars['String']>;
  /** The organization's mailing address name */
  custServName?: Maybe<Scalars['String']>;
  /** The phone number for the organization */
  custServPhone?: Maybe<Scalars['String']>;
  /** The organization's address postal code */
  custServPostalCode?: Maybe<Scalars['String']>;
  /** The organization's address state or region */
  custServRegion?: Maybe<Scalars['String']>;
  customerDisplayName?: Maybe<Scalars['String']>;
  domainClaims?: Maybe<Array<DomainClaim>>;
  featureAccesses?: Maybe<Array<FeatureAccess>>;
  id: Scalars['Int'];
  kind?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** Next billing date for upcoming SaaS payment */
  nextBillingDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Determines if the organization is on waitlist. */
  onWaitlist?: Maybe<Scalars['Boolean']>;
  parentId?: Maybe<Scalars['Int']>;
  partner?: Maybe<Partner>;
  /** The plan this org is on. Only available for org admins */
  plan?: Maybe<Plan>;
  /** Whether a plan is on a yearly or monthly billing cycle */
  planBillingCycle?: Maybe<Scalars['String']>;
  preferences?: Maybe<OrgPreferences>;
  /** The organization's job priority. */
  priority?: Maybe<Scalars['Int']>;
  /** This org's single sign on configuration if it exists */
  ssoConfig?: Maybe<SsoConfig>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** A list of users which have access to this org ordered by user.createdAt in descending order. */
  users: UserBasicInfoPaginatedResults;
  usersCount: Scalars['Int'];
  /** This Org's Wallet */
  wallet?: Maybe<Wallet>;
};


export type OrgAppliedDiscountsArgs = {
  ids?: Maybe<Array<Scalars['Int']>>;
};


export type OrgUsersArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

/** Arguments for creating/updating an org */
export type OrgArgs = {
  custServCity?: Maybe<Scalars['String']>;
  custServCountry?: Maybe<Scalars['String']>;
  custServLine1?: Maybe<Scalars['String']>;
  custServLine2?: Maybe<Scalars['String']>;
  custServName?: Maybe<Scalars['String']>;
  custServPhone?: Maybe<Scalars['String']>;
  custServPostalCode?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type OrgBasePrice = ApplicationRecord & {
  __typename?: 'OrgBasePrice';
  billingCycle: Scalars['String'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  goodType: Scalars['String'];
  id: Scalars['Int'];
  partnerSubsidy: Scalars['Int'];
  planId: Scalars['Int'];
  /** Price in cents */
  price: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type OrgBasicInfo = ApplicationRecord & OrgNames & {
  __typename?: 'OrgBasicInfo';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  customerDisplayName?: Maybe<Scalars['String']>;
  /**
   * Returns the org's expedited deliverable settings for their available deliverables. It returns null if the org
   * does not have on demand expedited deliverables feature access enabled.
   */
  expeditedDeliverablesSettings?: Maybe<Array<ExpeditedDeliverablesSettings>>;
  id: Scalars['Int'];
  name?: Maybe<Scalars['String']>;
  /**
   * Unique code used for putting users in a specific org on signup. Refer
   * to the orgCode argument in createHomeowner/createProUser mutations.
   *
   * This is only used in the context of AffiliateOrgsForPartner. This will always return null otherwise.
   */
  orgCode?: Maybe<OrgCode>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/**
 * Paginated results for a given type. Total pages or count is not provided. Instead, an hasNextPage boolean is
 * provided.
 */
export type OrgBasicInfoPaginatedResults = {
  __typename?: 'OrgBasicInfoPaginatedResults';
  pagination: PaginationWithoutCount;
  results: Array<Maybe<OrgBasicInfo>>;
};

export type OrgCode = {
  __typename?: 'OrgCode';
  code?: Maybe<Scalars['String']>;
};

export type OrgCurrentUserContext = {
  __typename?: 'OrgCurrentUserContext';
  /** Return the aclTemplate the current_user has for this org. */
  aclTemplate?: Maybe<AclTemplateOptions>;
  /** Return true if the user has access to org billing information. */
  canManageBilling: Scalars['Boolean'];
  /** Return true if the user can manage the org. */
  canManageOrg: Scalars['Boolean'];
  /** Return true if the user has access to manage permissions for other users in their orgs */
  canManageUserPermissions: Scalars['Boolean'];
  /** Returns true if the user can manage org and org has single_sign_on enabled */
  canReadSsoConfig: Scalars['Boolean'];
  /**
   * Return true if the user should be cc'ed on all emails within the org.
   *
   * This field will only have effect for Org admin.
   */
  ccAdminOnEmails?: Maybe<Scalars['Boolean']>;
};

export type OrgNames = {
  customerDisplayName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OrgPreferences = ApplicationRecord & {
  __typename?: 'OrgPreferences';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  deliverable?: Maybe<Deliverable>;
  externalIdentifierLabel?: Maybe<Scalars['String']>;
  externalIdentifierRequired?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated return type of OrgProductCreate */
export type OrgProductCreatePayload = {
  __typename?: 'OrgProductCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  orgProduct?: Maybe<ProductCatalogConfigOrgProduct>;
};

/** Autogenerated return type of OrgProposalSettingUpdate */
export type OrgProposalSettingUpdatePayload = {
  __typename?: 'OrgProposalSettingUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  orgProposalSetting?: Maybe<ProjectManagementConfigOrgProposalSetting>;
};

/** OrgSettings */
export type OrgSettings = ApplicationRecord & {
  __typename?: 'OrgSettings';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** the default sales tax for LABOR estimation line items in for this org */
  defaultLaborSalesTax?: Maybe<Scalars['Float']>;
  /** the default margin for EstimationConfig::LineItems in this org */
  defaultMargin?: Maybe<Scalars['Float']>;
  /** the default sales tax for MATERIAL and OTHER estimation line items in for this org */
  defaultSalesTax?: Maybe<Scalars['Float']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  /** The Annual Percentage Rate (APR) used to calculate monthly payments for estimates. */
  monthlyPaymentApr?: Maybe<Scalars['Float']>;
  /** The duration in months for calculating monthly payments for estimates. */
  monthlyPaymentDuration?: Maybe<Scalars['Float']>;
  /** Controls visibility of the toggle which shows/hides the line item details on an estimate */
  showEstimateLineItemDetailsToggle: Scalars['Boolean'];
  /** Whether to show the profit breakdown in the estimate summary */
  showEstimationProfitInSummary: Scalars['Boolean'];
  showInspectionChecklist?: Maybe<Scalars['Boolean']>;
  /** Controls whether the org sees the full ordering flow in Estimation */
  showOrderingFlow?: Maybe<Scalars['Boolean']>;
  /** Controls visibility of prices in Estimation workflow. If false clients should not show line item prices. */
  showPricesInEstimation: Scalars['Boolean'];
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated return type of OrgSettingsUpdate */
export type OrgSettingsUpdatePayload = {
  __typename?: 'OrgSettingsUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  orgSettings?: Maybe<ProductCatalogOrgSettings>;
};

/** Arguments for creating a user under a specific org */
export type OrgUserCreateArgs = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  requireJobApproval?: Maybe<Scalars['Boolean']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

export type Pagination = {
  __typename?: 'Pagination';
  currentPage: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
  /** @deprecated Pagination with count is no longer supported */
  totalPages: Scalars['Int'];
};

export type PaginationWithoutCount = {
  __typename?: 'PaginationWithoutCount';
  currentPage: Scalars['Int'];
  hasNextPage: Scalars['Boolean'];
};

export type PartialAnnotation = {
  __typename?: 'PartialAnnotation';
  annotationId: Scalars['ID'];
  area: Scalars['Float'];
  facadeId: Scalars['ID'];
  /** Database id */
  id?: Maybe<Scalars['ID']>;
};

export type Partner = ApplicationRecord & {
  __typename?: 'Partner';
  allowInsuranceDamageCapture?: Maybe<Scalars['Boolean']>;
  allowInsuranceUnderwritingCapture?: Maybe<Scalars['Boolean']>;
  /** Indicates whether a partner has co-branding enabled for the App */
  appCoBrand: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The deliverables available to this partner */
  deliverables: Array<Deliverable>;
  id: Scalars['Int'];
  /** Unique identifier for a partner. */
  identifier?: Maybe<Scalars['String']>;
  kind?: Maybe<PartnerKind>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum PartnerKind {
  Insurance = 'INSURANCE',
  Standard = 'STANDARD'
}

export enum PartnersWithAffiliateOrgsIdentifiers {
  Beacon = 'BEACON'
}

export type PerFace = {
  __typename?: 'PerFace';
  /** Area of facet */
  area?: Maybe<Scalars['Int']>;
  /** Facet name */
  facet?: Maybe<Scalars['String']>;
  /** Facet's pitch */
  pitch?: Maybe<Scalars['Int']>;
};

export type PitchData = {
  __typename?: 'PitchData';
  /** Area of roof facade in square feet */
  area: Scalars['Int'];
  /** Facade's percentage of total roof area */
  percentage: Scalars['String'];
  /** Inches of vertical rise over 12 inches of horzontal run */
  roofPitch: Scalars['String'];
};

export type Plan = ApplicationRecord & {
  __typename?: 'Plan';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The number of days that the users in the Org under this plan can access the property information of a job since
   * it's completed. The typical values are 365 or 0. If the value is 0, the access is unlimited.
   */
  daysOfHistoricalJobAccess: Scalars['Int'];
  id: Scalars['Int'];
  jobBasePrices: Array<JobBasePrice>;
  name: Scalars['String'];
  orgBasePrices: Array<OrgBasePrice>;
  /** Base price for HOVER Now */
  roofEstimateBasePrice: BasePrice;
  /** @deprecated non_saas plans no longer exists. All plans are SaaS. */
  saas: Scalars['Boolean'];
  tier: Scalars['String'];
  upchargeBasePrices: Array<UpchargeBasePrice>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ProductCatalogColor = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogColor';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  hex: Scalars['String'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for ProductCatalogColor. */
export type ProductCatalogColorConnection = {
  __typename?: 'ProductCatalogColorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogColorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogColor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogColorEdge = {
  __typename?: 'ProductCatalogColorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogColor>;
};

export type ProductCatalogConfigOrgProduct = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogConfigOrgProduct';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  orgId: Scalars['ID'];
  product: ProductCatalogProduct;
  productId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Arguments for creating a ProductCatalogConfigOrgProduct */
export type ProductCatalogConfigOrgProductCreateInput = {
  orgId: Scalars['ID'];
  productId: Scalars['ID'];
};

export type ProductCatalogDistributor = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogDistributor';
  capabilities?: Maybe<ProductCatalogDistributorCapabilities>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  description?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  id: Scalars['ID'];
  /**
   * The programmaticaly accessible name for this Distributor. This is used for
   * code to refer to certain Distributor when the database ID is not known.
   */
  identifier?: Maybe<ProductCatalogDistributorIdentifierEnum>;
  /**
   * The distributor's complete logo. By default this is returned in svg format.
   * Use the format argument to request other common image formats. If arguments
   * for width, height, or both are given the image will be resized to fit within
   * those constraints while maintain original image's aspect ratio.
   */
  logo?: Maybe<File>;
  name: Scalars['String'];
  oauthAuthorizationUrl?: Maybe<Scalars['String']>;
  /**
   * The authenticated user's org's OAuth token for this distributor.If the
   * authenticated user's org has not authorized a connection to this distributor
   * the field will be null.If the request is un-authenticated this will be null.
   * @deprecated Deprecated: This requester dependent field hinders caching. Instead make a separate query to DistributionOauthTokens to get a list of connections between an org and a distributor.
   */
  oauthToken?: Maybe<DistributionOauthToken>;
  /**
   * If this is true then this Distributor has given us access to their product
   * catalog and we've implemented it. With that we can use these products in
   * Design Pro and EHI's estimation feature.
   */
  supportsProductCatalog: Scalars['Boolean'];
  /**
   * If this is true then this Distributor has given us access  to their product
   * ordering API and we've implemented it. With that you can order products from this provider.
   */
  supportsProductOrdering: Scalars['Boolean'];
  /**
   * If this is true then clients should show a dialog presenting any errors
   * resulting from the order check process. That dialog should have a button to
   * cancel the order process. And another to continue with submitting the order,
   * despite any errors. If this setting is false then clients should ignore the
   * order check results and submit the order immediately.
   */
  supportsShowingOrderCheckResults: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * A URL to the Distributor's homepage/landing page. This may be used by the
   * front-end to provide a link to the Distributor's page. That can make it easy
   * for HOVER users to find out about new Distributors.
   */
  url?: Maybe<Scalars['String']>;
  /** The name to use when referring to the distributor's website */
  websiteDisplayName?: Maybe<Scalars['String']>;
};


export type ProductCatalogDistributorLogoArgs = {
  format?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

/** Contains information about what is supported by a distributor */
export type ProductCatalogDistributorCapabilities = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogDistributorCapabilities';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * Whether this distributor supports specifying delivery date when submitting an order
   * @deprecated Replaced with supportsDeliveryDate
   */
  deliveryDate: Scalars['Boolean'];
  /** @deprecated Replaced with supportsDeliveryMethod */
  deliveryMethod: Scalars['Boolean'];
  deliveryMethods: Array<DistributionDeliveryMethod>;
  /**
   * Whether this distributor supports specifying delivery time when submitting an order
   * @deprecated Replaced with supportsDeliveryTime
   */
  deliveryTime: Scalars['Boolean'];
  deliveryTimes: Array<DistributionDeliveryTime>;
  /**
   * Whether this distributor supports specifying delivery type when submitting an order
   * @deprecated Replaced with supportsDeliveryType
   */
  deliveryType: Scalars['Boolean'];
  deliveryTypes: Array<DistributionDelivery>;
  id: Scalars['ID'];
  /** Whether the distributor requires a job account to be specified to place an order */
  requiresOrderJobAccount: Scalars['Boolean'];
  supportsDeliveryDate: Scalars['Boolean'];
  supportsDeliveryMethod: Scalars['Boolean'];
  supportsDeliveryTime: Scalars['Boolean'];
  supportsDeliveryType: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for ProductCatalogDistributor. */
export type ProductCatalogDistributorConnection = {
  __typename?: 'ProductCatalogDistributorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogDistributorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogDistributor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogDistributorEdge = {
  __typename?: 'ProductCatalogDistributorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogDistributor>;
};

export enum ProductCatalogDistributorIdentifierEnum {
  Beacon = 'BEACON',
  Srs = 'SRS'
}

/** The ProductCatalogDistributors attributes for this variation */
export type ProductCatalogDistributorVariationAttributes = {
  __typename?: 'ProductCatalogDistributorVariationAttributes';
  clientIdentifier?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  unitCost?: Maybe<Scalars['Float']>;
};

export type ProductCatalogExternalProductIdentifier = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogExternalProductIdentifier';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  distributor?: Maybe<ProductCatalogDistributor>;
  /** current distributor order for the external product identifier */
  distributorId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  identifier: Scalars['String'];
  product: ProductCatalogProduct;
  productId: Scalars['ID'];
  /** @deprecated Replaced by distributor */
  provider?: Maybe<ProductCatalogProvider>;
  /**
   * The ID of the distributor that sells this product. A distributor is a type of Provider.
   * @deprecated Replaced by distributor
   */
  providerId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for ProductCatalogExternalProductIdentifier. */
export type ProductCatalogExternalProductIdentifierConnection = {
  __typename?: 'ProductCatalogExternalProductIdentifierConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogExternalProductIdentifierEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogExternalProductIdentifier>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogExternalProductIdentifierEdge = {
  __typename?: 'ProductCatalogExternalProductIdentifierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogExternalProductIdentifier>;
};

export type ProductCatalogExternalVariationIdentifier = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogExternalVariationIdentifier';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  displayName?: Maybe<Scalars['String']>;
  distributor?: Maybe<ProductCatalogDistributor>;
  /** current distributor order for the external variation identifier */
  distributorId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  identifier: Scalars['String'];
  /**
   * What kind of ExternalIdentifier is this? Currently this is only 'SKU' and a
   * couple of legacy values that shouldn't be used anymore.
   */
  kind: ProductCatalogExternalVariationIdentifierKindEnum;
  /** @deprecated Replaced by distributor */
  provider?: Maybe<ProductCatalogProvider>;
  /**
   * The ID of the distributor that sells this Variation of this Product. A distributor is a type of Provider.
   * @deprecated Replaced by distributorId
   */
  providerId?: Maybe<Scalars['ID']>;
  /** The distributor's SKU for this product variation */
  sku?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  variation: ProductCatalogVariation;
  variationId: Scalars['ID'];
};

/** The connection type for ProductCatalogExternalVariationIdentifier. */
export type ProductCatalogExternalVariationIdentifierConnection = {
  __typename?: 'ProductCatalogExternalVariationIdentifierConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogExternalVariationIdentifierEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogExternalVariationIdentifier>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogExternalVariationIdentifierEdge = {
  __typename?: 'ProductCatalogExternalVariationIdentifierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogExternalVariationIdentifier>;
};

export enum ProductCatalogExternalVariationIdentifierKindEnum {
  BeaconProductIdAndVariantName = 'BEACON_PRODUCT_ID_AND_VARIANT_NAME',
  DistributorJson = 'DISTRIBUTOR_JSON',
  ManufacturerProductId = 'MANUFACTURER_PRODUCT_ID',
  Sku = 'SKU'
}

export type ProductCatalogGrouping = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogGrouping';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  /** @deprecated Replaced by id */
  legacyId: Scalars['Int'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  variations: Array<ProductCatalogVariation>;
};

/** The connection type for ProductCatalogGrouping. */
export type ProductCatalogGroupingConnection = {
  __typename?: 'ProductCatalogGroupingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogGroupingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogGrouping>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogGroupingEdge = {
  __typename?: 'ProductCatalogGroupingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogGrouping>;
};

export type ProductCatalogOrgSettings = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogOrgSettings';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  orgId: Scalars['ID'];
  orgVariations: Array<ProductCatalogOrgVariation>;
  productFilteringEnabled: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


export type ProductCatalogOrgSettingsOrgVariationsArgs = {
  productId: Scalars['ID'];
};

/** This table is used for variation level product filtering */
export type ProductCatalogOrgVariation = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogOrgVariation';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  orgId: Scalars['ID'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  variation: ProductCatalogVariation;
  variationId: Scalars['ID'];
};

/** Arguments for creating or deleting ProductCatalogOrgVariations */
export type ProductCatalogOrgVariationNestedInput = {
  destroy?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  variationId?: Maybe<Scalars['ID']>;
};

export type ProductCatalogProduct = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogProduct';
  /** Legacy. Whether product is considered 'active' */
  active: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated For backwards compatibility */
  firstVariation?: Maybe<ProductCatalogVariation>;
  groupings?: Maybe<Array<ProductCatalogGrouping>>;
  id: Scalars['ID'];
  /** Whether product is paintable or not */
  isPaintable?: Maybe<Scalars['Boolean']>;
  labelId?: Maybe<Scalars['Int']>;
  legacyId: Scalars['Int'];
  name: Scalars['String'];
  orgVariationsCount?: Maybe<Scalars['Int']>;
  productType?: Maybe<ProductCatalogProductTypeEnum>;
  provider?: Maybe<ProductCatalogProvider>;
  /** The ID of the manufacturer that makes this Product. A manufacturer is a type of Provider. */
  providerId?: Maybe<Scalars['ID']>;
  /** @deprecated For backwards compatibility */
  ungroupedVariations: Array<ProductCatalogVariation>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  variations: Array<ProductCatalogVariation>;
  variationsCount: Scalars['Int'];
};


export type ProductCatalogProductOrgVariationsCountArgs = {
  orgId: Scalars['ID'];
};


export type ProductCatalogProductVariationsArgs = {
  filterByOrgId?: Maybe<Scalars['ID']>;
  renderable?: Maybe<Scalars['Boolean']>;
};

/** The connection type for ProductCatalogProduct. */
export type ProductCatalogProductConnection = {
  __typename?: 'ProductCatalogProductConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogProductEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogProduct>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogProductEdge = {
  __typename?: 'ProductCatalogProductEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogProduct>;
};

export enum ProductCatalogProductTypeEnum {
  Color = 'COLOR',
  Material = 'MATERIAL',
  Opening = 'OPENING'
}

export type ProductCatalogProvider = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogProvider';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  legacyId: Scalars['Int'];
  logo?: Maybe<File>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for ProductCatalogProvider. */
export type ProductCatalogProviderConnection = {
  __typename?: 'ProductCatalogProviderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogProviderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogProvider>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogProviderEdge = {
  __typename?: 'ProductCatalogProviderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogProvider>;
};

export enum ProductCatalogProviderProviderTypeEnum {
  Distributor = 'DISTRIBUTOR',
  Manufacturer = 'MANUFACTURER'
}

export type ProductCatalogTexture = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogTexture';
  aoMap?: Maybe<File>;
  aoMapResized?: Maybe<File>;
  aoMapThumbnail?: Maybe<File>;
  basecolorMap?: Maybe<File>;
  basecolorMapResized?: Maybe<File>;
  basecolorMapThumbnail?: Maybe<File>;
  bumpMap?: Maybe<File>;
  bumpMapResized?: Maybe<File>;
  bumpMapThumbnail?: Maybe<File>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  diffuseMap?: Maybe<File>;
  diffuseMapResized?: Maybe<File>;
  diffuseMapThumbnail?: Maybe<File>;
  hasTransparency?: Maybe<Scalars['Boolean']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  /** @deprecated For backwards compatibility */
  legacyDefault?: Maybe<Scalars['Boolean']>;
  /** @deprecated Replaced by id */
  legacyId?: Maybe<Scalars['Int']>;
  metalMap?: Maybe<File>;
  metalMapResized?: Maybe<File>;
  metalMapThumbnail?: Maybe<File>;
  name: Scalars['String'];
  normalMap?: Maybe<File>;
  normalMapResized?: Maybe<File>;
  normalMapThumbnail?: Maybe<File>;
  pbrMap?: Maybe<File>;
  pbrMapResized?: Maybe<File>;
  pbrMapThumbnail?: Maybe<File>;
  repeatable: Scalars['Boolean'];
  roughMap?: Maybe<File>;
  roughMapResized?: Maybe<File>;
  roughMapThumbnail?: Maybe<File>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  width?: Maybe<Scalars['Float']>;
};

/** The connection type for ProductCatalogTexture. */
export type ProductCatalogTextureConnection = {
  __typename?: 'ProductCatalogTextureConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogTextureEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogTexture>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogTextureEdge = {
  __typename?: 'ProductCatalogTextureEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogTexture>;
};

export type ProductCatalogVariation = ApplicationRecordUuid & {
  __typename?: 'ProductCatalogVariation';
  /**
   * Legacy. Whether variation is considered 'active'
   * @deprecated For backwards compatibility
   */
  active: Scalars['Boolean'];
  color?: Maybe<ProductCatalogColor>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Defaults to SKUs if kind is not specified. */
  externalVariationIdentifiers: Array<ProductCatalogExternalVariationIdentifier>;
  /** @deprecated Use groupingLegacyId instead */
  groupingId?: Maybe<Scalars['Int']>;
  groupingLegacyId?: Maybe<Scalars['Int']>;
  /** @deprecated replaced by texture height */
  height?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  legacyId: Scalars['Int'];
  name: Scalars['String'];
  /** A record adding a variation to an org's filters. */
  orgVariation?: Maybe<ProductCatalogOrgVariation>;
  product: ProductCatalogProduct;
  /**
   * Legacy. Whether product is considered 'renderable'
   * @deprecated For backwards compatibility
   */
  renderable: Scalars['Boolean'];
  texture?: Maybe<ProductCatalogTexture>;
  textureId?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** @deprecated replaced by texture width */
  width?: Maybe<Scalars['Float']>;
};


export type ProductCatalogVariationExternalVariationIdentifiersArgs = {
  kind?: Maybe<ProductCatalogExternalVariationIdentifierKindEnum>;
};


export type ProductCatalogVariationOrgVariationArgs = {
  orgId: Scalars['ID'];
};

/** The connection type for ProductCatalogVariation. */
export type ProductCatalogVariationConnection = {
  __typename?: 'ProductCatalogVariationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProductCatalogVariationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProductCatalogVariation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProductCatalogVariationEdge = {
  __typename?: 'ProductCatalogVariationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProductCatalogVariation>;
};

/** Production List */
export type ProductionList = ApplicationRecord & {
  __typename?: 'ProductionList';
  contractLaborTotal?: Maybe<Scalars['Float']>;
  /** The original contract subtotal of all material list item total costs */
  contractMaterialSubtotal?: Maybe<Scalars['Float']>;
  /** The original contract total of all list item tax amounts */
  contractMaterialTax?: Maybe<Scalars['Float']>;
  /** The original contract sum of material_subtotal and material_tax */
  contractMaterialTotal?: Maybe<Scalars['Float']>;
  contractOtherTotal?: Maybe<Scalars['Float']>;
  contractPreDiscountPrice?: Maybe<Scalars['Float']>;
  contractTotalCost?: Maybe<Scalars['Float']>;
  /** The original contract total price (with discounts subtracted) */
  contractTotalPrice?: Maybe<Scalars['Float']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  /** @deprecated replaced by laborTotalCost */
  laborTotal?: Maybe<Scalars['Float']>;
  /** The total cost, including tax, of all labor list items */
  laborTotalCost?: Maybe<Scalars['Float']>;
  listItems?: Maybe<Array<ListItem>>;
  /** The total pretax cost of all material list items */
  materialPretaxCost?: Maybe<Scalars['Float']>;
  /** The total of all material list item tax amounts */
  materialSalesTax?: Maybe<Scalars['Float']>;
  /** @deprecated replaced by materialPretaxCost */
  materialSubtotal?: Maybe<Scalars['Float']>;
  /** @deprecated replaced by materialSalesTax */
  materialTax?: Maybe<Scalars['Float']>;
  /** @deprecated replaced by materialTotalCost */
  materialTotal?: Maybe<Scalars['Float']>;
  /** The total cost, including tax, of all material list items */
  materialTotalCost?: Maybe<Scalars['Float']>;
  orders: Array<ProjectManagementOrder>;
  /** @deprecated replaced by otherTotalCost */
  otherTotal?: Maybe<Scalars['Float']>;
  /** The total cost, including tax, of all other list items */
  otherTotalCost?: Maybe<Scalars['Float']>;
  profitAmount?: Maybe<Scalars['Float']>;
  profitMargin?: Maybe<Scalars['Float']>;
  salesOpportunity: SalesOpportunity;
  /** The id of the sales opportunity this production list is related to. */
  salesOpportunityId: Scalars['Int'];
  totalCost?: Maybe<Scalars['Float']>;
  /** total discount in dollars applied to the production list */
  totalDiscount: Scalars['Float'];
  totalPrice?: Maybe<Scalars['Float']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  userId?: Maybe<Scalars['Int']>;
};

export type Profile = {
  __typename?: 'Profile';
  user: User;
};

/** Attributes for a list time that come from the vendor */
export type ProjectManagementConfigOrgProposalSetting = {
  __typename?: 'ProjectManagementConfigOrgProposalSetting';
  allowDefaultOverrideIncludeAllEstimateItems: Scalars['Boolean'];
  allowDefaultOverrideIncludeItemCost: Scalars['Boolean'];
  allowDefaultOverrideIncludeItemQuantities: Scalars['Boolean'];
  allowDefaultOverrideIncludeTradePrice: Scalars['Boolean'];
  id: Scalars['ID'];
  includeAllEstimateItemsDefault: Scalars['Boolean'];
  includeItemCostDefault: Scalars['Boolean'];
  includeItemQuantitiesDefault: Scalars['Boolean'];
  includeTradePriceDefault: Scalars['Boolean'];
  orgId: Scalars['Int'];
  proposalsEnabled: Scalars['Boolean'];
  scopeOfWorkDisclaimer?: Maybe<Scalars['String']>;
  scopeOfWorkShowLogo: Scalars['Boolean'];
  scopeOfWorkShowTitle: Scalars['Boolean'];
  scopeOfWorkTitle?: Maybe<Scalars['String']>;
};

/** Arguments for updating a ProjectManagementConfigOrgProposalSetting */
export type ProjectManagementConfigOrgProposalSettingUpdate = {
  /** allow users to edit proposal_documents.include_all_estimate_items setting */
  allowDefaultOverrideIncludeAllEstimateItems?: Maybe<Scalars['Boolean']>;
  /** allow users to edit proposal_documents.include_item_cost setting */
  allowDefaultOverrideIncludeItemCost?: Maybe<Scalars['Boolean']>;
  /** allow users to edit proposal_documents.include_item_quantities setting */
  allowDefaultOverrideIncludeItemQuantities?: Maybe<Scalars['Boolean']>;
  /** allow users to edit proposal_documents.include_trade_price setting */
  allowDefaultOverrideIncludeTradePrice?: Maybe<Scalars['Boolean']>;
  /** default value for proposal_documents.include_all_estimate_items */
  includeAllEstimateItemsDefault?: Maybe<Scalars['Boolean']>;
  /** default value for proposal_documents.include_item_cost */
  includeItemCostDefault?: Maybe<Scalars['Boolean']>;
  /** default value for proposal_documents.include_item_quantities */
  includeItemQuantitiesDefault?: Maybe<Scalars['Boolean']>;
  /** default value for proposal_documents.include_trade_price */
  includeTradePriceDefault?: Maybe<Scalars['Boolean']>;
  /** Whether or not proposals are enabled for the org */
  proposalsEnabled?: Maybe<Scalars['Boolean']>;
  /** Disclaimer to be displayed on the scope of work */
  scopeOfWorkDisclaimer?: Maybe<Scalars['String']>;
  /** Whether or not logos should be shown for the scope of work */
  scopeOfWorkShowLogo?: Maybe<Scalars['Boolean']>;
  /** Whether or not the title should be shown for the scope of work */
  scopeOfWorkShowTitle?: Maybe<Scalars['Boolean']>;
  /** The name of the scope of work */
  scopeOfWorkTitle?: Maybe<Scalars['String']>;
};

export type ProjectManagementConfigProposalTemplate = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementConfigProposalTemplate';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  orgId: Scalars['Int'];
  pages: Array<ProjectManagementConfigProposalTemplatePage>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type ProjectManagementConfigProposalTemplatePage = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementConfigProposalTemplatePage';
  /** The user-customizable HTML content for this page */
  content?: Maybe<Scalars['String']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  pageType: ProjectManagementConfigProposalTemplatePageTypeEnum;
  /** If true, show org logo on rendered ProposalDocument page */
  showOrgLogo?: Maybe<Scalars['Boolean']>;
  /** Whether to show the title on this page */
  showTitle: Scalars['Boolean'];
  sortOrder: Scalars['Int'];
  /** The title of the page */
  title?: Maybe<Scalars['String']>;
  tradeType?: Maybe<TradeTypeEnum>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Arguments for creating a ProjectManagementConfigProposalTemplatePage */
export type ProjectManagementConfigProposalTemplatePageCreateInput = {
  /** The user-customizable HTML content for this page */
  content: Scalars['String'];
  /** If true, show org logo on rendered ProposalDocument page */
  showOrgLogo?: Maybe<Scalars['Boolean']>;
  /** Whether to show the title on this page */
  showTitle?: Maybe<Scalars['Boolean']>;
  /** The title of the page */
  title?: Maybe<Scalars['String']>;
  tradeType: TradeTypeEnum;
};

export enum ProjectManagementConfigProposalTemplatePageTypeEnum {
  Html = 'HTML',
  Image = 'IMAGE',
  ListItems = 'LIST_ITEMS'
}

/** Project Management Order */
export type ProjectManagementOrder = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementOrder';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  distributionBranch?: Maybe<DistributionBranch>;
  /** The selected branch to send this order to. */
  distributionBranchId?: Maybe<Scalars['ID']>;
  distributionJobAccount?: Maybe<DistributionJobAccount>;
  /** The selected job account to use when placing this order */
  distributionJobAccountId?: Maybe<Scalars['ID']>;
  /**
   * If this order has been submitted to a ProductCatalogDistributor for
   * fullfillment the DistributionOrder record keeps track of the order submission
   * and processing status.
   */
  distributionOrder?: Maybe<DistributionOrder>;
  /** The ID of the distribution order in Product Catalog */
  distributionOrderId?: Maybe<Scalars['ID']>;
  /** @deprecated Replaced by purchase order number */
  externalIdentifier?: Maybe<Scalars['String']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  /** Documents related to this order. */
  orderDocuments: Array<OrderDocument>;
  orderListItems: Array<ProjectManagementOrderListItem>;
  /** The org this ProjectManagementOrder belongs to. */
  org: Org;
  /** The ID of the Org this ProjectManagementOrder belongs to. */
  orgId: Scalars['Int'];
  productionList: ProductionList;
  /** User specified identifier for this order */
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  vendor?: Maybe<Vendor>;
};

/** The connection type for ProjectManagementOrder. */
export type ProjectManagementOrderConnection = {
  __typename?: 'ProjectManagementOrderConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectManagementOrderEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectManagementOrder>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating an Order */
export type ProjectManagementOrderCreateInput = {
  /** The delivery date requested by the user */
  deliveryDate?: Maybe<Scalars['ISO8601Date']>;
  /**
   * The delivery method requested by the user. This should be a value from the
   * DistributionDeliveryMethodEnum from product-catalog
   */
  deliveryMethod?: Maybe<Scalars['String']>;
  /** The delivery time requested by the user. This should be a value from the DistributionDeliveryTimeEnum from product-catalog */
  deliveryTime?: Maybe<Scalars['String']>;
  /** The delivery type requested by the user. This should be a value from the DistributionDeliveryTypeEnum from product-catalog */
  deliveryType?: Maybe<Scalars['String']>;
  /** The selected branch to send this order to. */
  distributionBranchId?: Maybe<Scalars['ID']>;
  /** The selected job account to use when placing this order */
  distributionJobAccountId?: Maybe<Scalars['ID']>;
  /**
   * A specific Distributor's id. This optional argument limits the order to the products provided by the \
   *                   specified Distributor. Without this option the order will include all products on the ProductionList.
   */
  distributorId?: Maybe<Scalars['ID']>;
  /** DEPRECATED: replaced by purchase order number */
  externalIdentifier?: Maybe<Scalars['String']>;
  /** The list of ProjectManagement::ListItem ids that should be included in this order */
  listItemIds: Array<Scalars['ID']>;
  /** The description to be saved to ProjectManagement::Order and to be sent to Distributors when placing orders. */
  notes?: Maybe<Scalars['String']>;
  productionListId: Scalars['ID'];
  /** The user specified identifier that will be sent to Distributors when placing orders. */
  purchaseOrderNumber?: Maybe<Scalars['String']>;
  /** City of the shipping address passed to order provider */
  shippingAddressCity?: Maybe<Scalars['String']>;
  /** Country of the shipping address passed to order provider */
  shippingAddressCountry?: Maybe<Scalars['String']>;
  /** First name of the shipping address passed to order provider */
  shippingAddressFirstName?: Maybe<Scalars['String']>;
  /** Last name of the shipping address passed to order provider */
  shippingAddressLastName?: Maybe<Scalars['String']>;
  /** Line 1 of the shipping address passed to order provider */
  shippingAddressLine1?: Maybe<Scalars['String']>;
  /** Line 2 of the shipping address passed to order provider */
  shippingAddressLine2?: Maybe<Scalars['String']>;
  /** Phone number of the shipping address passed to order provider */
  shippingAddressPhoneNumber?: Maybe<Scalars['String']>;
  /** Postal code of the shipping address passed to order provider */
  shippingAddressPostalCode?: Maybe<Scalars['String']>;
  /** State of the shipping address passed to order provider */
  shippingAddressState?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type ProjectManagementOrderEdge = {
  __typename?: 'ProjectManagementOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectManagementOrder>;
};

/** Order List Item */
export type ProjectManagementOrderListItem = {
  __typename?: 'ProjectManagementOrderListItem';
  /** @deprecated Replaced By productCatalogProductId */
  externalProductId?: Maybe<Scalars['ID']>;
  /** The corresponding variation id from the product catalog service */
  externalVariationId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  listItem: ListItem;
  listItemId: Scalars['Int'];
  /** Name of the order list item. */
  name?: Maybe<Scalars['String']>;
  /** Foreign key to product_catalog_product */
  productCatalogProductId?: Maybe<Scalars['ID']>;
  /** The quantity that was calculated for the list item. */
  quantity?: Maybe<Scalars['Float']>;
  /** The SKU for this product in the provider catalog. Can be used for automatic ordering */
  sku?: Maybe<Scalars['String']>;
  userSetCustomColor: Scalars['Boolean'];
  /**
   * The sku can be automatically populated from a matching product in the product
   * catalog. It can also be manually overridden by the user. This boolean keeps
   * track of if the user changed the sku themselves vs sticking with the sku we
   * get from the product catalog.
   */
  userSetCustomSku: Scalars['Boolean'];
  /** The manufacturer's name for the variant, i.e. color */
  variantName?: Maybe<Scalars['String']>;
};

/** Proposal Document */
export type ProjectManagementProposalDocument = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementProposalDocument';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The email address of the customer requesting the document */
  customerEmail?: Maybe<Scalars['String']>;
  /** The full name of the customer requesting the document */
  customerName?: Maybe<Scalars['String']>;
  estimateGroup: EstimationEstimateGroup;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  /** If true, will itemize all selected line items; if false, will only display totals for each line item category */
  includeAllEstimateItems?: Maybe<Scalars['Boolean']>;
  /** Optional job-specific notes added by the customer */
  notes?: Maybe<Scalars['String']>;
  pdf?: Maybe<File>;
  salesOpportunity: SalesOpportunity;
  signatureRequest?: Maybe<ProjectManagementSignatureRequest>;
  state: ProjectManagementProposalDocumentStateEnum;
  /** The price the homeowner will pay for this proposal. */
  totalPrice?: Maybe<Scalars['Float']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The User that created the ProjectManagementProposalDocument. */
  user: User;
  userId: Scalars['Int'];
};

/** The connection type for ProjectManagementProposalDocument. */
export type ProjectManagementProposalDocumentConnection = {
  __typename?: 'ProjectManagementProposalDocumentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectManagementProposalDocumentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectManagementProposalDocument>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Arguments for creating a ProposalDocument */
export type ProjectManagementProposalDocumentCreate = {
  /** The address of the person this proposal document will be sent from. The Org address. */
  contractorAddressCity?: Maybe<Scalars['String']>;
  /** The address of the person this proposal document will be sent from. The Org address. */
  contractorAddressLine1?: Maybe<Scalars['String']>;
  /** The address of the person this proposal document will be sent from. The Org address. */
  contractorAddressLine2?: Maybe<Scalars['String']>;
  /** The address of the person this proposal document will be sent from. The Org address. */
  contractorAddressPostalCode?: Maybe<Scalars['String']>;
  /** The address of the person this proposal document will be sent from. The Org address. */
  contractorAddressState?: Maybe<Scalars['String']>;
  /** A public URL for a logo to be included on the proposal. */
  contractorLogoUrl?: Maybe<Scalars['String']>;
  /** The name of the person sending this document. The contractor. */
  contractorName: Scalars['String'];
  contractorPhoneNumber?: Maybe<Scalars['String']>;
  /** The email of the person sending this document. The contractor. */
  contractorRepresentativeEmail: Scalars['String'];
  /** The name of the person sending this document. The contractor. */
  contractorRepresentativeName: Scalars['String'];
  /** The phone number of the person sending this document. The contractor. */
  contractorRepresentativePhoneNumber?: Maybe<Scalars['String']>;
  /** The website URL of the contractor sending this proposal document. */
  contractorWebsiteUrl?: Maybe<Scalars['String']>;
  /** The address of the person this proposal document will be sent to. The Job address. */
  customerAddressCity?: Maybe<Scalars['String']>;
  /** The address of the person this proposal document will be sent to. The Job address. */
  customerAddressLine1?: Maybe<Scalars['String']>;
  /** The address of the person this proposal document will be sent to. The Job address. */
  customerAddressLine2?: Maybe<Scalars['String']>;
  /** The address of the person this proposal document will be sent to. The Job address. */
  customerAddressPostalCode?: Maybe<Scalars['String']>;
  /** The address of the person this proposal document will be sent to. The Job address. */
  customerAddressState?: Maybe<Scalars['String']>;
  /** The email address of the customer requesting the document */
  customerEmail?: Maybe<Scalars['String']>;
  /** The full name of the customer requesting the document */
  customerName: Scalars['String'];
  customerPhoneNumber?: Maybe<Scalars['String']>;
  estimateGroupId: Scalars['ID'];
  /** If true, will itemize all selected line items; if false, will only display totals for each line item category */
  includeAllEstimateItems?: Maybe<Scalars['Boolean']>;
  includeItemCost?: Maybe<Scalars['Boolean']>;
  includeItemQuantities?: Maybe<Scalars['Boolean']>;
  includeTradePrice?: Maybe<Scalars['Boolean']>;
  /**
   * The name of this document. Will be included in the document header prefixed with 'Proposal
   * '. So a value of 'HOVER Residence' here will produce a header 'Proposal
   * HOVER Residence'.
   */
  name: Scalars['String'];
  /** Optional job-specific notes added by the customer */
  notes?: Maybe<Scalars['String']>;
};

/** An edge in a connection. */
export type ProjectManagementProposalDocumentEdge = {
  __typename?: 'ProjectManagementProposalDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectManagementProposalDocument>;
};

/** Proposal Document Preview */
export type ProjectManagementProposalDocumentPreview = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementProposalDocumentPreview';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  failureReason?: Maybe<Scalars['String']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  /** The org ID associated with the proposal document preview */
  orgId: Scalars['ID'];
  pdf?: Maybe<File>;
  state: ProjectManagementProposalDocumentStateEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum ProjectManagementProposalDocumentStateEnum {
  Complete = 'COMPLETE',
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Queued = 'QUEUED',
  Requested = 'REQUESTED'
}

/** SignatureRequest */
export type ProjectManagementSignatureRequest = ApplicationRecordUuid & {
  __typename?: 'ProjectManagementSignatureRequest';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** This is the unique identifier for the signature request in external systems. */
  externalIdentifier?: Maybe<Scalars['String']>;
  failureReason?: Maybe<Scalars['String']>;
  /**
   * The unique ID for an estimation input condition. An estimation_input_condition
   * is a mapping table between an input and a parent input.
   */
  id: Scalars['ID'];
  proposalDocument: ProjectManagementProposalDocument;
  /** The proposal document for this signature request */
  proposalDocumentId: Scalars['ID'];
  requestType: ProjectManagementSignatureRequestRequestTypeEnum;
  /** Datetime that the signature request was signed */
  signedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Current state of the signature request. */
  state: ProjectManagementSignatureRequestStateEnum;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Arguments for creating a SignatureRequest */
export type ProjectManagementSignatureRequestCreate = {
  /** The proposal document for this signature request */
  proposalDocumentId: Scalars['ID'];
  requestType: ProjectManagementSignatureRequestRequestTypeEnum;
};

/** Embedded Signature Url */
export type ProjectManagementSignatureRequestEmbeddedUrl = {
  __typename?: 'ProjectManagementSignatureRequestEmbeddedUrl';
  expiresAt: Scalars['ISO8601DateTime'];
  signUrl: Scalars['String'];
};

export enum ProjectManagementSignatureRequestRequestTypeEnum {
  Email = 'EMAIL',
  Embed = 'EMBED'
}

export enum ProjectManagementSignatureRequestStateEnum {
  Cancelled = 'CANCELLED',
  Complete = 'COMPLETE',
  Created = 'CREATED',
  Declined = 'DECLINED',
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Requested = 'REQUESTED',
  Signed = 'SIGNED'
}

/** Autogenerated return type of ProposalDocumentCreate */
export type ProposalDocumentCreatePayload = {
  __typename?: 'ProposalDocumentCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  proposalDocument?: Maybe<ProjectManagementProposalDocument>;
};

/** Autogenerated return type of ProposalDocumentPreviewCreate */
export type ProposalDocumentPreviewCreatePayload = {
  __typename?: 'ProposalDocumentPreviewCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  proposalDocumentPreview?: Maybe<ProjectManagementProposalDocumentPreview>;
};

/** Autogenerated return type of ProposalTemplatePageCreate */
export type ProposalTemplatePageCreatePayload = {
  __typename?: 'ProposalTemplatePageCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  proposalTemplatePage?: Maybe<ProjectManagementConfigProposalTemplatePage>;
};

/** Autogenerated return type of ProposalTemplatePageDelete */
export type ProposalTemplatePageDeletePayload = {
  __typename?: 'ProposalTemplatePageDeletePayload';
  /** Validation Errors */
  errors: Array<Error>;
};

/** Autogenerated return type of ProposalTemplatePageUpdate */
export type ProposalTemplatePageUpdatePayload = {
  __typename?: 'ProposalTemplatePageUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  proposalTemplatePage?: Maybe<ProjectManagementConfigProposalTemplatePage>;
};

/** Autogenerated return type of ProposalTemplatesPagesSortOrderUpdate */
export type ProposalTemplatesPagesSortOrderUpdatePayload = {
  __typename?: 'ProposalTemplatesPagesSortOrderUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  proposalTemplate?: Maybe<ProjectManagementConfigProposalTemplate>;
};

export enum QuantityUnit {
  Bags = 'BAGS',
  Boxes = 'BOXES',
  Bundles = 'BUNDLES',
  Cartons = 'CARTONS',
  Each = 'EACH',
  Hours = 'HOURS',
  LinearFeet = 'LINEAR_FEET',
  Pairs = 'PAIRS',
  Pieces = 'PIECES',
  Rolls = 'ROLLS',
  Squares = 'SQUARES',
  SquareFeet = 'SQUARE_FEET',
  Tubes = 'TUBES'
}

export enum QuantityUnitsEnum {
  Bags = 'BAGS',
  Boxes = 'BOXES',
  Bundles = 'BUNDLES',
  Cartons = 'CARTONS',
  Each = 'EACH',
  Hours = 'HOURS',
  LinearFeet = 'LINEAR_FEET',
  Pairs = 'PAIRS',
  Pieces = 'PIECES',
  Rolls = 'ROLLS',
  Squares = 'SQUARES',
  SquareFeet = 'SQUARE_FEET',
  Tubes = 'TUBES'
}

export type Query = {
  __typename?: 'Query';
  revision?: Maybe<Scalars['String']>;
  gltf?: Maybe<Scalars['String']>;
  vrsceneZipUri?: Maybe<Scalars['String']>;
  esxUri?: Maybe<Scalars['String']>;
  obj?: Maybe<Scalars['String']>;
  roofMeasurements?: Maybe<RoofMeasurements>;
  screenshots?: Maybe<Array<Maybe<ModelScreenshot>>>;
  distributionApprovedBranches: Array<DistributionBranch>;
  /** @deprecated use distributionApprovedBranches */
  distributionBranches: DistributionBranchConnection;
  distributionOauthTokens: DistributionOauthTokenConnection;
  distributionOrder?: Maybe<DistributionOrder>;
  distributionOrders?: Maybe<DistributionOrderConnection>;
  productCatalogColors: ProductCatalogColorConnection;
  productCatalogDistributor: ProductCatalogDistributor;
  productCatalogDistributorVariationAttributes: ProductCatalogDistributorVariationAttributes;
  productCatalogDistributorVariationsAttributes: Array<ProductCatalogDistributorVariationAttributes>;
  productCatalogDistributors: ProductCatalogDistributorConnection;
  productCatalogExternalProductIdentifiers: ProductCatalogExternalProductIdentifierConnection;
  productCatalogExternalVariationIdentifiers: ProductCatalogExternalVariationIdentifierConnection;
  productCatalogGroupings: ProductCatalogGroupingConnection;
  productCatalogOrgSettings?: Maybe<ProductCatalogOrgSettings>;
  /** Returns null if the requested product is not found */
  productCatalogProduct?: Maybe<ProductCatalogProduct>;
  /** Returns the top matches for your searchTerm. Up to 50 results. */
  productCatalogProductSearch: Array<ProductCatalogProduct>;
  productCatalogProducts: ProductCatalogProductConnection;
  productCatalogProviders: ProductCatalogProviderConnection;
  productCatalogTexture: ProductCatalogTexture;
  productCatalogTextures: ProductCatalogTextureConnection;
  productCatalogVariationSearch: ProductCatalogVariationConnection;
  productCatalogVariations: ProductCatalogVariationConnection;
  /** Returns all orgs with kind affiliate under the given partner. */
  affiliateOrgsForPartner: OrgBasicInfoPaginatedResults;
  /**
   * Looks up an SSO config, returns ssoSpSigninUrl and SSO config attributes corresponding to the email.
   * If SSO is not enabled, ssoSpSigninUrl will be nil.
   */
  authenticationInfo: AuthenticationInfo;
  /**
   * Returns all deliverables that exist in our database. Each org may have restriction on which deliverables are
   * allowed. Please refer to availableDeliverables under Org object.
   */
  deliverables: Array<Deliverable>;
  /** Returns 3d files for a job share given a valid token and job id */
  jobSharedThreeDFiles: JobSharedThreeDFiles;
  jobs: JobPaginatedResults;
  profile: Profile;
  measurementsForOrder: Model;
  measurementsService?: Maybe<Measurements>;
  roofWasteData?: Maybe<RoofWasteData>;
  ehiFeatureAccesses: Array<EhiFeatureAccess>;
  ehiOrgSettings?: Maybe<OrgSettings>;
  estimationConfigInputCategories: EstimationConfigInputCategoryConnection;
  estimationConfigLineItems: EstimationConfigLineItemConnection;
  estimationConfigRequiredInputs: EstimationConfigRequiredInputConnection;
  estimationConfigTemplates: TemplateConnection;
  estimationEstimate?: Maybe<Estimate>;
  estimationEstimateGroup?: Maybe<EstimationEstimateGroup>;
  estimationEstimateGroups: EstimationEstimateGroupConnection;
  inspectionChecklist?: Maybe<InspectionChecklist>;
  inspectionConfigChecklistTemplates: InspectionConfigChecklistTemplateConnection;
  projectManagementConfigOrgProposalSetting?: Maybe<ProjectManagementConfigOrgProposalSetting>;
  projectManagementConfigProposalTemplate?: Maybe<ProjectManagementConfigProposalTemplate>;
  projectManagementConfigProposalTemplatePage?: Maybe<ProjectManagementConfigProposalTemplatePage>;
  projectManagementOrderDocuments: Array<OrderDocument>;
  projectManagementOrders: ProjectManagementOrderConnection;
  projectManagementProductionList: ProductionList;
  projectManagementProposalDocument?: Maybe<ProjectManagementProposalDocument>;
  projectManagementProposalDocumentPreview?: Maybe<ProjectManagementProposalDocumentPreview>;
  projectManagementProposalDocuments?: Maybe<ProjectManagementProposalDocumentConnection>;
  projectManagementSignatureRequest?: Maybe<ProjectManagementSignatureRequest>;
  projectManagementSignatureRequestEmbeddedUrl?: Maybe<ProjectManagementSignatureRequestEmbeddedUrl>;
  salesOpportunities: Array<SalesOpportunity>;
  vendors: Array<Vendor>;
  wasteFactorRoof: WasteFactorRoof;
};


export type QueryGltfArgs = {
  metadataUri?: Maybe<Scalars['String']>;
  geometryUri?: Maybe<Scalars['String']>;
  highResTextures?: Maybe<Scalars['Boolean']>;
};


export type QueryVrsceneZipUriArgs = {
  gltfFileName?: Maybe<Scalars['String']>;
};


export type QueryEsxUriArgs = {
  metadataUri?: Maybe<Scalars['String']>;
  geometryUri?: Maybe<Scalars['String']>;
  measurementJsonUri?: Maybe<Scalars['String']>;
  esxPutUri?: Maybe<Scalars['String']>;
  projectName?: Maybe<Scalars['String']>;
  claimNumber?: Maybe<Scalars['String']>;
  address?: Maybe<EsxAddressInput>;
  createWallsMethod2?: Maybe<Scalars['Boolean']>;
  createWallsV3?: Maybe<Scalars['Boolean']>;
  useBarrelRoofStructure?: Maybe<Scalars['Boolean']>;
  alignSketchTopLeft?: Maybe<Scalars['Boolean']>;
  newPricingStructure?: Maybe<Scalars['Boolean']>;
  x1Compatibility?: Maybe<Scalars['Boolean']>;
  useConsistentLabels?: Maybe<Scalars['Boolean']>;
  truncateClaimNumber?: Maybe<Scalars['Boolean']>;
  useConsistentLabelsSiding?: Maybe<Scalars['Boolean']>;
  useGableRoofStructure?: Maybe<Scalars['Boolean']>;
};


export type QueryObjArgs = {
  metadataUri?: Maybe<Scalars['String']>;
  geometryUri?: Maybe<Scalars['String']>;
};


export type QueryRoofMeasurementsArgs = {
  metadataUri?: Maybe<Scalars['String']>;
  geometryUri?: Maybe<Scalars['String']>;
};


export type QueryScreenshotsArgs = {
  jobId: Scalars['Int'];
};


export type QueryDistributionApprovedBranchesArgs = {
  accountId?: Maybe<Scalars['String']>;
  distributorId: Scalars['ID'];
  orgId: Scalars['ID'];
};


export type QueryDistributionBranchesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  distributorId: Scalars['ID'];
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
};


export type QueryDistributionOauthTokensArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orgId?: Maybe<Scalars['ID']>;
};


export type QueryDistributionOrderArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryDistributionOrdersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  last?: Maybe<Scalars['Int']>;
  orgId?: Maybe<Scalars['ID']>;
};


export type QueryProductCatalogColorsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryProductCatalogDistributorArgs = {
  id: Scalars['ID'];
};


export type QueryProductCatalogDistributorVariationAttributesArgs = {
  accountId?: Maybe<Scalars['String']>;
  distributionBranchId?: Maybe<Scalars['ID']>;
  distributionJobAccountId?: Maybe<Scalars['ID']>;
  distributorId: Scalars['ID'];
  lineItemAttributes: DistributionVariationAttributesInput;
  orgId?: Maybe<Scalars['ID']>;
};


export type QueryProductCatalogDistributorVariationsAttributesArgs = {
  accountId?: Maybe<Scalars['String']>;
  distributionBranchId?: Maybe<Scalars['ID']>;
  distributionJobAccountId?: Maybe<Scalars['ID']>;
  distributorId: Scalars['ID'];
  lineItemsAttributes: Array<DistributionVariationAttributesInput>;
  orgId: Scalars['ID'];
};


export type QueryProductCatalogDistributorsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryProductCatalogExternalProductIdentifiersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  productIds: Array<Scalars['ID']>;
};


export type QueryProductCatalogExternalVariationIdentifiersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  distributorIds?: Maybe<Array<Scalars['ID']>>;
  first?: Maybe<Scalars['Int']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  kind?: Maybe<ProductCatalogExternalVariationIdentifierKindEnum>;
  last?: Maybe<Scalars['Int']>;
  providerIds?: Maybe<Array<Scalars['ID']>>;
  variationIds?: Maybe<Array<Scalars['ID']>>;
};


export type QueryProductCatalogGroupingsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryProductCatalogOrgSettingsArgs = {
  orgId: Scalars['ID'];
};


export type QueryProductCatalogProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductCatalogProductSearchArgs = {
  distributorId?: Maybe<Scalars['ID']>;
  orgId?: Maybe<Scalars['ID']>;
  providerId?: Maybe<Scalars['ID']>;
  searchTerm: Scalars['String'];
};


export type QueryProductCatalogProductsArgs = {
  activeOnly?: Maybe<Scalars['Boolean']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  distributorIds?: Maybe<Array<Scalars['ID']>>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  manufacturerIds?: Maybe<Array<Scalars['ID']>>;
  productIds?: Maybe<Array<Scalars['ID']>>;
  providerIds?: Maybe<Array<Scalars['ID']>>;
};


export type QueryProductCatalogProvidersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  legacyIds?: Maybe<Array<Scalars['Int']>>;
  providerType?: Maybe<ProductCatalogProviderProviderTypeEnum>;
};


export type QueryProductCatalogTextureArgs = {
  id: Scalars['ID'];
};


export type QueryProductCatalogTexturesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  ids?: Maybe<Array<Scalars['ID']>>;
  last?: Maybe<Scalars['Int']>;
  legacyIds?: Maybe<Array<Scalars['Int']>>;
};


export type QueryProductCatalogVariationSearchArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  labelId: Scalars['Int'];
  last?: Maybe<Scalars['Int']>;
  renderable?: Maybe<Scalars['Boolean']>;
  textureName?: Maybe<Scalars['String']>;
};


export type QueryProductCatalogVariationsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryAffiliateOrgsForPartnerArgs = {
  page?: Maybe<Scalars['Int']>;
  partnerIdentifier: PartnersWithAffiliateOrgsIdentifiers;
  perPage?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
};


export type QueryAuthenticationInfoArgs = {
  email: Scalars['String'];
  redirectPath?: Maybe<Scalars['String']>;
};


export type QueryJobSharedThreeDFilesArgs = {
  jobId: Scalars['Int'];
  shareToken: Scalars['String'];
};


export type QueryJobsArgs = {
  createdAfter?: Maybe<Scalars['ISO8601DateTime']>;
  createdBefore?: Maybe<Scalars['ISO8601DateTime']>;
  filters?: Maybe<Array<JobSearchFilters>>;
  ids?: Maybe<Array<Scalars['Int']>>;
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  search?: Maybe<Scalars['String']>;
  updatedAfter?: Maybe<Scalars['ISO8601DateTime']>;
  viewableBy?: Maybe<JobsViewableBy>;
};


export type QueryRoofWasteDataArgs = {
  hipsLinearFeet: Scalars['Float'];
  rakesLinearFeet: Scalars['Float'];
  roofSquareFeet: Scalars['Float'];
  stepFlashingLinearFeet: Scalars['Float'];
  valleysLinearFeet: Scalars['Float'];
};


export type QueryEstimationConfigInputCategoriesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};


export type QueryEstimationConfigLineItemsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
  withProductsOnly?: Maybe<Scalars['Boolean']>;
};


export type QueryEstimationConfigRequiredInputsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
  templateIds?: Maybe<Array<Scalars['ID']>>;
};


export type QueryEstimationConfigTemplatesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
};


export type QueryEstimationEstimateArgs = {
  id: Scalars['ID'];
};


export type QueryEstimationEstimateGroupArgs = {
  id: Scalars['ID'];
};


export type QueryEstimationEstimateGroupsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  jobId?: Maybe<Scalars['ID']>;
  last?: Maybe<Scalars['Int']>;
  salesOpportunityId?: Maybe<Scalars['ID']>;
};


export type QueryInspectionChecklistArgs = {
  jobId: Scalars['ID'];
  orgId: Scalars['ID'];
};


export type QueryInspectionConfigChecklistTemplatesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
};


export type QueryProjectManagementConfigOrgProposalSettingArgs = {
  orgId: Scalars['ID'];
};


export type QueryProjectManagementConfigProposalTemplateArgs = {
  orgId: Scalars['ID'];
};


export type QueryProjectManagementConfigProposalTemplatePageArgs = {
  id: Scalars['ID'];
};


export type QueryProjectManagementOrderDocumentsArgs = {
  orderDocumentIds?: Maybe<Array<Scalars['ID']>>;
  productionListId: Scalars['ID'];
  vendorId?: Maybe<Scalars['ID']>;
};


export type QueryProjectManagementOrdersArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  orgId: Scalars['ID'];
};


export type QueryProjectManagementProductionListArgs = {
  jobId: Scalars['ID'];
  orgId: Scalars['ID'];
};


export type QueryProjectManagementProposalDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryProjectManagementProposalDocumentPreviewArgs = {
  id: Scalars['ID'];
};


export type QueryProjectManagementProposalDocumentsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  estimateGroupId?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  salesOpportunityId?: Maybe<Scalars['ID']>;
  state?: Maybe<ProjectManagementProposalDocumentStateEnum>;
};


export type QueryProjectManagementSignatureRequestArgs = {
  id: Scalars['ID'];
};


export type QueryProjectManagementSignatureRequestEmbeddedUrlArgs = {
  signatureRequestId: Scalars['ID'];
};


export type QuerySalesOpportunitiesArgs = {
  id?: Maybe<Scalars['ID']>;
  jobId?: Maybe<Scalars['ID']>;
  orgId: Scalars['ID'];
};


export type QueryVendorsArgs = {
  orgId: Scalars['ID'];
};


export type QueryWasteFactorRoofArgs = {
  roofAttributes: WasteFactorRoofInput;
};

export type ReferenceMeasurements = {
  __typename?: 'ReferenceMeasurements';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<JobImage>;
  widthInches?: Maybe<Scalars['Float']>;
};

export enum RemoteService {
  TinyMce = 'TINY_MCE'
}

export type Rendering = {
  __typename?: 'Rendering';
  id: Scalars['String'];
  state: Scalars['String'];
  jobId?: Maybe<Scalars['Int']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  noiseThreshold?: Maybe<Scalars['Float']>;
  position?: Maybe<Scalars['String']>;
  versionUrls?: Maybe<RenderingVersions>;
  errorMessage?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  percentDone?: Maybe<Scalars['Int']>;
};

export enum RenderingState {
  Idle = 'IDLE',
  Queued = 'QUEUED',
  Rendering = 'RENDERING',
  Processing = 'PROCESSING',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type RenderingVersions = {
  __typename?: 'RenderingVersions';
  large?: Maybe<Scalars['String']>;
  medium?: Maybe<Scalars['String']>;
  small?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type RoofData = {
  __typename?: 'RoofData';
  /** Data for cornices */
  cornices?: Maybe<CorniceData>;
  /** Data for downspouts */
  downspouts?: Maybe<GutterData>;
  /** Count and total length of eaves */
  eaves?: Maybe<RoofFeatureData>;
  /** Total and individual facade data */
  facets?: Maybe<RoofFacetData>;
  /** Count and total length of flashing */
  flashing?: Maybe<RoofFeatureData>;
  /** Data for gutters */
  gutters?: Maybe<GutterData>;
  /** Count and total length of hips */
  hips?: Maybe<RoofFeatureData>;
  /** Facade data for wrap facades */
  pitches?: Maybe<Array<PitchData>>;
  /** Count and total length of rakes */
  rakes?: Maybe<RoofFeatureData>;
  /** Count and total length of ridges */
  ridges?: Maybe<RoofFeatureData>;
  /** Data for soffits */
  soffits?: Maybe<SoffitData>;
  /** Count and total length of step flashing */
  stepFlashing?: Maybe<RoofFeatureData>;
  /** Count and total length of valleys */
  valleys?: Maybe<RoofFeatureData>;
};

export type RoofEstimate = {
  __typename?: 'RoofEstimate';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id?: Maybe<Scalars['Int']>;
  /** The pitch of the roof formatted as x/12 */
  predominantPitch?: Maybe<Scalars['String']>;
  /** The total area of the roof measured in roof squares */
  totalRoofSquares?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export enum RoofEstimateAccessLevels {
  Instant = 'INSTANT',
  InstantUnsupported = 'INSTANT_UNSUPPORTED',
  None = 'NONE',
  Refined = 'REFINED',
  RefinedUnsupported = 'REFINED_UNSUPPORTED',
  VerifiedRefined = 'VERIFIED_REFINED'
}

export type RoofFacetData = {
  __typename?: 'RoofFacetData';
  /** Area of roof facets */
  area?: Maybe<Scalars['Int']>;
  /** Count of facets */
  count?: Maybe<Scalars['Int']>;
  /** Count of facets with a square footage greater than 4 */
  countAbove4Sqft?: Maybe<Scalars['Int']>;
  /** List of area and pitch data by face */
  perFace?: Maybe<Array<PerFace>>;
};

export type RoofFeatureData = {
  __typename?: 'RoofFeatureData';
  /** Count of feature */
  count: Scalars['Int'];
  /** Group name */
  group?: Maybe<Scalars['String']>;
  /** Sum of feature lengths */
  length: Scalars['Float'];
};

export type RoofMeasurements = {
  __typename?: 'RoofMeasurements';
  segments?: Maybe<RoofSegments>;
};

export type RoofSegments = {
  __typename?: 'RoofSegments';
  /** Ridges are the things on the top of a roof */
  ridges?: Maybe<SegmentData>;
  eaves?: Maybe<SegmentData>;
  rakes?: Maybe<SegmentData>;
  hips?: Maybe<SegmentData>;
  valleys?: Maybe<SegmentData>;
  flashings?: Maybe<SegmentData>;
  stepFlashings?: Maybe<SegmentData>;
};

export type RoofWasteData = {
  __typename?: 'RoofWasteData';
  recommendedRoofWastePercentage: Scalars['Float'];
  roofWasteFactors: Array<Scalars['Float']>;
};

export type RooflineData = {
  __typename?: 'RooflineData';
  /** Length of horizontal connection between bottom of roof and structure. */
  levelFriezeBoard: Scalars['Float'];
  /** Length of slanted connection between bottom of roof and structure. */
  slopedFriezeBoard: Scalars['Float'];
};

/** Sales Opportunity */
export type SalesOpportunity = ApplicationRecord & {
  __typename?: 'SalesOpportunity';
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  /** The Job this SalesOpportunity is for. */
  job: Job;
  /** The job to which the estimate relates. */
  jobId: Scalars['Int'];
  /** The Org this SalesOpportunity belongs to. */
  org: Org;
  /** The org to which the sales opportunity relates. */
  orgId: Scalars['Int'];
  productionList?: Maybe<ProductionList>;
  soldEstimateGroup?: Maybe<EstimationEstimateGroup>;
  soldEstimateGroupId?: Maybe<Scalars['ID']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Arguments for updating a Sales Opportunity */
export type SalesOpportunityUpdate = {
  soldEstimateGroupId?: Maybe<Scalars['ID']>;
};

/** Autogenerated return type of SalesOpportunityUpdate */
export type SalesOpportunityUpdatePayload = {
  __typename?: 'SalesOpportunityUpdatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  salesOpportunity?: Maybe<SalesOpportunity>;
};

export type SegmentData = {
  __typename?: 'SegmentData';
  data?: Maybe<Array<Maybe<ThreeDLine>>>;
  metadata?: Maybe<ThreeDMetaData>;
};

export type Sides = {
  __typename?: 'Sides';
  /** Elevations for back facing facades. */
  back: ElevationBySide;
  /** Elevations for front facing facades. */
  front: ElevationBySide;
  /** Elevations for left facing facades. */
  left: ElevationBySide;
  /** Elevations for facades not associated with the front, back left or right sides. */
  other: ElevationBySide;
  /** Elevations for right facing facades. */
  right: ElevationBySide;
};

/** Autogenerated return type of SignatureRequestCreate */
export type SignatureRequestCreatePayload = {
  __typename?: 'SignatureRequestCreatePayload';
  /** Validation Errors */
  errors: Array<Error>;
  signatureRequest?: Maybe<ProjectManagementSignatureRequest>;
};

export type SignedUrl = {
  __typename?: 'SignedUrl';
  archiveUrl: Scalars['String'];
  screenshotUrl: Scalars['String'];
  uploadKey: Scalars['String'];
};

export type SoffitData = {
  __typename?: 'SoffitData';
  /** Total soffit area */
  area: Scalars['Float'];
  /** Count of soffits */
  count: Scalars['Int'];
  /** Soffit data by face */
  perFace: Array<SoffitFace>;
};

export type SoffitFace = {
  __typename?: 'SoffitFace';
  /** Soffit's color */
  color: Scalars['String'];
  /** Depth of soffit */
  depth: Scalars['String'];
  /** Number of faces on soffit */
  facesCount: Scalars['Int'];
  /** Soffit's total area */
  totalArea: Scalars['Int'];
  /** Soffit's total length */
  totalLength: Scalars['Float'];
  /** Type of soffit */
  type: Scalars['String'];
};

export type SsoConfig = ApplicationRecord & {
  __typename?: 'SsoConfig';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  /** This can only be seen by admins of the org that created this config. */
  idpCertBase64?: Maybe<Scalars['String']>;
  /** This can only be seen by admins of the org that created this config. */
  idpEntityId?: Maybe<Scalars['String']>;
  /** This can only be seen by admins of the org that created this config. */
  idpSsoTargetUrl?: Maybe<Scalars['String']>;
  ssoEnabled: Scalars['Boolean'];
  strictModeEnabled: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Arguments for creating a single sign on configuration */
export type SsoConfigArgs = {
  /** Public certificate provided by the IdP. Must be Base64 encoded. */
  idpCertBase64: Scalars['String'];
  idpEntityId: Scalars['String'];
  idpSsoTargetUrl: Scalars['String'];
  /** SSO will be enabled for this org if true. Defaults to false */
  ssoEnabled?: Maybe<Scalars['Boolean']>;
  /** Users in this org will be required to log in using SSO if true. Defaults to false. */
  strictModeEnabled?: Maybe<Scalars['Boolean']>;
};

export type Summary = {
  __typename?: 'Summary';
  /** Areas by type */
  area: Area;
  /** Waste data for brick facades */
  brickWaste: WasteData;
  /** Elevation data by side */
  elevations: Elevations;
  /** Data for labeled facades */
  facades: Facades;
  /** Waste data for metal facades */
  metalWaste: WasteData;
  /** Data about roof facades */
  openings: Openings;
  /** Data about roof facades */
  roof: RoofData;
  /** Waste data for siding facades */
  sidingWaste: WasteData;
  /** Waste data for stone facades */
  stoneWaste: WasteData;
  /** Waste data for stucco facades */
  stuccoWaste: WasteData;
  /** Waste data for tudor facades */
  tudorWaste: WasteData;
  /** Waste data for unknown facades */
  unknownWaste: WasteData;
  /** Waste data for wrap facades */
  wrapWaste: WasteData;
};

/** Estimation Config Template */
export type Template = ApplicationRecord & {
  __typename?: 'Template';
  active: Scalars['Boolean'];
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  /** The name of the template. */
  name?: Maybe<Scalars['String']>;
  /** The org to which the template belongs. */
  orgId?: Maybe<Scalars['Int']>;
  /** The order in which to display the templates in the UI. */
  sortOrder?: Maybe<Scalars['Int']>;
  tradeType?: Maybe<TradeTypeEnum>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** The connection type for Template. */
export type TemplateConnection = {
  __typename?: 'TemplateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TemplateEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Template>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TemplateEdge = {
  __typename?: 'TemplateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
  /** The item at the end of the edge. */
  node?: Maybe<Template>;
};

export type ThreeDCoordinate = {
  __typename?: 'ThreeDCoordinate';
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
  z?: Maybe<Scalars['Float']>;
};

export type ThreeDFormats = {
  __typename?: 'ThreeDFormats';
  gltfUri?: Maybe<Scalars['String']>;
  objUri?: Maybe<Scalars['String']>;
};

export type ThreeDLine = {
  __typename?: 'ThreeDLine';
  start?: Maybe<ThreeDCoordinate>;
  end?: Maybe<ThreeDCoordinate>;
};

export type ThreeDMetaData = {
  __typename?: 'ThreeDMetaData';
  count?: Maybe<Scalars['Int']>;
  perimeter?: Maybe<Scalars['Float']>;
  formattedPerimeter?: Maybe<Scalars['String']>;
};

export enum TradeTypeEnum {
  AccentSiding = 'ACCENT_SIDING',
  All = 'ALL',
  Cladding = 'CLADDING',
  Cladding_2 = 'CLADDING_2',
  Decking = 'DECKING',
  Deductibility = 'DEDUCTIBILITY',
  Deductible = 'DEDUCTIBLE',
  Door = 'DOOR',
  Fascia = 'FASCIA',
  Gutters = 'GUTTERS',
  HipAndRidge = 'HIP_AND_RIDGE',
  IceAndWater = 'ICE_AND_WATER',
  Insulation = 'INSULATION',
  Packages = 'PACKAGES',
  Railing = 'RAILING',
  Roof = 'ROOF',
  RoofSystems = 'ROOF_SYSTEMS',
  Shutters = 'SHUTTERS',
  Siding = 'SIDING',
  Skylights = 'SKYLIGHTS',
  Soffit = 'SOFFIT',
  Trim = 'TRIM',
  Underlayment = 'UNDERLAYMENT',
  Upgrades = 'UPGRADES',
  Ventilation = 'VENTILATION',
  Warranties = 'WARRANTIES',
  Windows = 'WINDOWS'
}

export type TrimData = {
  __typename?: 'TrimData';
  /** Length of planes' bottom most side. */
  levelStarter?: Maybe<Scalars['Float']>;
  /** Length of slated connection between top of roof and structure. */
  sloped?: Maybe<Scalars['Float']>;
  /** Length of vertical connection between bottom of roof and structure. */
  vertical?: Maybe<Scalars['Float']>;
};

export type UpchargeBasePrice = ApplicationRecord & {
  __typename?: 'UpchargeBasePrice';
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  goodType: Scalars['String'];
  id: Scalars['Int'];
  partnerSubsidy: Scalars['Int'];
  planId: Scalars['Int'];
  /** Price in cents */
  price: Scalars['Int'];
  upchargeKind: Scalars['String'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type User = ApplicationRecord & UserNames & {
  __typename?: 'User';
  aclAccesses: Array<AclAccess>;
  /** A list of capture requests where this user is the capturing user. */
  captureRequests: CaptureRequestPaginatedResults;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  email: Scalars['String'];
  /** All feature flags that are enabled for this user */
  featureFlags: Array<FeatureFlag>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  /** SHA used for verifying user identification in Intercom communication */
  intercomSha: Scalars['String'];
  isHomeowner?: Maybe<Scalars['Boolean']>;
  /** Indicates if the user account is a test account */
  isTestData?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  orgs: Array<Org>;
  /**
   * This field generates a URL which can be used to upload a user's profile picture. Only jpg files are supported.
   * The link expires 600 minutes after being created.
   */
  profilePictureUploadUrl?: Maybe<Scalars['String']>;
  profilePictureUrl?: Maybe<Scalars['String']>;
  /**
   * Returns true if the user is a HOVER prospect and jobs must be approved by an Org admin.
   *
   * Note: HOVER Now is an exception and this field will be ignored.
   */
  requireJobApproval?: Maybe<Scalars['Boolean']>;
  state?: Maybe<UserStates>;
  timeZone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  uploadSecret?: Maybe<Scalars['String']>;
};


export type UserAclAccessesArgs = {
  limit?: Maybe<Scalars['Int']>;
};


export type UserCaptureRequestsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
  states?: Maybe<Array<CaptureRequestStates>>;
};


export type UserOrgsArgs = {
  first?: Maybe<Scalars['Int']>;
  ids?: Maybe<Array<Scalars['Int']>>;
  last?: Maybe<Scalars['Int']>;
};

/** Arguments for creating a user */
export type UserArgs = {
  appLogin?: Maybe<Scalars['Boolean']>;
  branchMatchIdentifier?: Maybe<Scalars['String']>;
  captureRequestIdentifier?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  marketingCampaignIdentifier?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
  preferredIdentifier?: Maybe<Scalars['String']>;
  requireJobApproval?: Maybe<Scalars['Boolean']>;
  timeZone?: Maybe<Scalars['String']>;
  vip?: Maybe<Scalars['Boolean']>;
};

export type UserBasicInfo = ApplicationRecord & UserNames & {
  __typename?: 'UserBasicInfo';
  /**
   * Return the aclTemplate this user has for the given orgId. Return null if org not found or this user does not have
   * access to this org.
   */
  aclTemplateForOrgId?: Maybe<AclTemplateOptions>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  jobsCount: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  /** A list of orgs which this user has access to. Basic info only. */
  orgs: OrgBasicInfoPaginatedResults;
  /**
   * Returns true if the user is a HOVER prospect and jobs must be approved by an Org admin.
   *
   * Note: HOVER Now is an exception and this field will be ignored.
   */
  requireJobApproval?: Maybe<Scalars['Boolean']>;
  state?: Maybe<UserStates>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};


export type UserBasicInfoAclTemplateForOrgIdArgs = {
  orgId: Scalars['Int'];
};


export type UserBasicInfoOrgsArgs = {
  page?: Maybe<Scalars['Int']>;
  perPage?: Maybe<Scalars['Int']>;
};

/**
 * Paginated results for a given type. Total pages or count is not provided. Instead, an hasNextPage boolean is
 * provided.
 */
export type UserBasicInfoPaginatedResults = {
  __typename?: 'UserBasicInfoPaginatedResults';
  pagination: PaginationWithoutCount;
  results: Array<Maybe<UserBasicInfo>>;
};

export type UserNames = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export enum UserStates {
  Activated = 'ACTIVATED',
  Archived = 'ARCHIVED',
  Invited = 'INVITED',
  WaitingActivation = 'WAITING_ACTIVATION'
}

/** Arguments for updating a user. */
export type UserUpdateArgs = {
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  mobilePhone?: Maybe<Scalars['String']>;
  officePhone?: Maybe<Scalars['String']>;
  requireJobApproval?: Maybe<Scalars['Boolean']>;
};

export type Vector3 = {
  __typename?: 'Vector3';
  x: Scalars['Float'];
  y: Scalars['Float'];
  z: Scalars['Float'];
};

/** Vendor */
export type Vendor = ApplicationRecord & {
  __typename?: 'Vendor';
  /** the org's account ID with the vendor */
  accountId?: Maybe<Scalars['String']>;
  /** address of this vendor */
  address1?: Maybe<Scalars['String']>;
  branch?: Maybe<DistributionBranch>;
  branchId?: Maybe<Scalars['ID']>;
  /** name of the branch within the vendor */
  branchName: Scalars['String'];
  /** city of this vendor */
  city?: Maybe<Scalars['String']>;
  /** address of this vendor */
  country?: Maybe<Scalars['String']>;
  /** The datetime at which the record was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /**
   * An optional Distributor. If a vendor is associated with a Distributor then
   * ProjectManagementListItems associated with this Vendor will pull their product
   * information from that Distributor's catalog. Orders associated with the vendor
   * willbe placed with the associated Distributor as well.
   */
  distributor?: Maybe<ProductCatalogDistributor>;
  /** Foreign key to Distributor in the product-catalog service */
  distributorId?: Maybe<Scalars['ID']>;
  /** The unique id of the list item. A list item describes the details of an unique item in a production list. */
  id: Scalars['Int'];
  /** @deprecated Use the defaultJobAccount field on DistributionBranch instead. */
  jobAccount?: Maybe<DistributionJobAccount>;
  /** main contact email */
  mainContactEmail: Scalars['String'];
  /** main contact fax */
  mainContactFax?: Maybe<Scalars['String']>;
  /** person to contact at this vendor */
  mainContactName: Scalars['String'];
  /** main contact phone */
  mainContactPhone?: Maybe<Scalars['String']>;
  /** id of the org that this vendor belongs to */
  orgId: Scalars['Int'];
  /** state of this vendor */
  state?: Maybe<Scalars['String']>;
  /** The datetime at which the record was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** name of the vendor */
  vendorName: Scalars['String'];
  /** zip code of this vendor */
  zipCode?: Maybe<Scalars['String']>;
};

export type Vertex = {
  __typename?: 'Vertex';
  /** This id does not persist but is guaranteed to beconsistent as long as the geometry doesn't change. */
  id: Scalars['ID'];
  /** (Unit: inch) */
  x: Scalars['Float'];
  /** (Unit: inch) */
  y: Scalars['Float'];
  /** (Unit: inch) */
  z: Scalars['Float'];
};

/** Only Org admins are authorized to view this. Returns null for other users. */
export type Wallet = ApplicationRecord & {
  __typename?: 'Wallet';
  billingAddressCity?: Maybe<Scalars['String']>;
  billingAddressCountry?: Maybe<Scalars['String']>;
  billingAddressLine1?: Maybe<Scalars['String']>;
  billingAddressLine2?: Maybe<Scalars['String']>;
  billingAddressPostalCode?: Maybe<Scalars['String']>;
  billingAddressRegion?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  cardBrand?: Maybe<Scalars['String']>;
  cardExpiresOn?: Maybe<Scalars['ISO8601DateTime']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['Int'];
  /** Available wallet balance/HOVER credits. */
  totalBalance?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Arguments for creating or updating a wallet */
export type WalletArgs = {
  billingAddressCity?: Maybe<Scalars['String']>;
  billingAddressCountry?: Maybe<Scalars['String']>;
  billingAddressLine1?: Maybe<Scalars['String']>;
  billingAddressLine2?: Maybe<Scalars['String']>;
  billingAddressPostalCode?: Maybe<Scalars['String']>;
  billingAddressRegion?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  cardBrand?: Maybe<Scalars['String']>;
  cardExpiresOn?: Maybe<Scalars['String']>;
  cardLast4?: Maybe<Scalars['String']>;
  cardholderName?: Maybe<Scalars['String']>;
  stripeToken?: Maybe<Scalars['String']>;
};

export type WasteData = {
  __typename?: 'WasteData';
  /** Facade by facade breakdown of waste data. */
  facades: Array<WastePercentages>;
  /** Waste data for all facades of given type. */
  total: WastePercentages;
};

/** Properties related to calculating waste factor for a roof */
export type WasteFactorRoof = {
  __typename?: 'WasteFactorRoof';
  /** Predicted waste factor */
  predictedWasteFactor: Scalars['Float'];
};

/** Arguments for calculating a roof's recommended waste factor */
export type WasteFactorRoofInput = {
  hipsLinearFeet: Scalars['Float'];
  rakesLinearFeet: Scalars['Float'];
  roofSquareFeet: Scalars['Float'];
  stepFlashingLinearFeet: Scalars['Float'];
  valleysLinearFeet: Scalars['Float'];
};

export type WastePercentages = {
  __typename?: 'WastePercentages';
  /** label for given facade. */
  facade?: Maybe<Scalars['String']>;
  /** Area of facade with opeings plus 10% additional waste. */
  openingsPlus10Percent: Scalars['Int'];
  /** Area of facade with opeings plus 18% additional waste. */
  openingsPlus18Percent: Scalars['Int'];
  /** Area of facade plus 10% additional waste. */
  plus10Percent: Scalars['Int'];
  /** Area of facade plus 18% additional waste. */
  plus18Percent: Scalars['Int'];
  /** Area of facade with opeings. */
  withOpenings: Scalars['Int'];
  /** Area of facade without additional waste. */
  zero: Scalars['Int'];
};

export type WindowData = {
  __typename?: 'WindowData';
  /** Count of windows in model */
  count: Scalars['Int'];
  /** Count of windows in model */
  perWindow: Array<IndividualWindowData>;
  /** Returns true if there are any features longer than 20ft. */
  totalArea?: Maybe<Scalars['Int']>;
  /** Individual group data */
  totalUnitedInches: Scalars['Int'];
};

export type WindowTexture = {
  __typename?: 'WindowTexture';
  windowColor?: Maybe<Scalars['String']>;
  windowGrille?: Maybe<Scalars['String']>;
  windowProduct?: Maybe<Scalars['Int']>;
};

export type AuthenticateMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type AuthenticateMutation = (
  { __typename?: 'Mutation' }
  & { authenticate: (
    { __typename?: 'AuthenticationResponse' }
    & { jwt: (
      { __typename?: 'JWT' }
      & Pick<Jwt, 'accessToken' | 'refreshToken'>
    ), user: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email'>
    ) }
  ) }
);

export type AuthenticateWithCookieMutationVariables = Exact<{ [key: string]: never; }>;


export type AuthenticateWithCookieMutation = (
  { __typename?: 'Mutation' }
  & { authenticateWithCookie: (
    { __typename?: 'AuthenticationResponse' }
    & { jwt: (
      { __typename?: 'JWT' }
      & Pick<Jwt, 'accessToken' | 'refreshToken'>
    ), user: (
      { __typename?: 'User' }
      & Pick<User, 'createdAt' | 'email' | 'id' | 'firstName' | 'lastName' | 'mobilePhone'>
      & { orgs: Array<(
        { __typename?: 'Org' }
        & Pick<Org, 'id' | 'name'>
        & { ssoConfig?: Maybe<(
          { __typename?: 'SsoConfig' }
          & Pick<SsoConfig, 'ssoEnabled'>
        )> }
      )> }
    ) }
  ) }
);

export type CompleteUserProfileMutationVariables = Exact<{
  mobilePhone?: Maybe<Scalars['String']>;
}>;


export type CompleteUserProfileMutation = (
  { __typename?: 'Mutation' }
  & { updateUser: (
    { __typename?: 'User' }
    & Pick<User, 'id'>
  ) }
);

export type CreateFileStorageTokenMutationVariables = Exact<{
  storageScope: FileStorageScopes;
}>;


export type CreateFileStorageTokenMutation = (
  { __typename?: 'Mutation' }
  & { createFileStorageToken: (
    { __typename?: 'FileStorageToken' }
    & Pick<FileStorageToken, 'token'>
  ) }
);

export type CreateHomeownerMutationVariables = Exact<{
  distinctId?: Maybe<Scalars['String']>;
  orgCode?: Maybe<Scalars['String']>;
  user: UserArgs;
}>;


export type CreateHomeownerMutation = (
  { __typename?: 'Mutation' }
  & { createHomeowner: (
    { __typename?: 'AuthenticationResponse' }
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email'>
    ), jwt: (
      { __typename?: 'JWT' }
      & Pick<Jwt, 'accessToken' | 'refreshToken'>
    ) }
  ) }
);

export type CreateProUserMutationVariables = Exact<{
  org: OrgArgs;
  user: UserArgs;
}>;


export type CreateProUserMutation = (
  { __typename?: 'Mutation' }
  & { createProUser: (
    { __typename?: 'AuthenticationResponse' }
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email'>
    ), jwt: (
      { __typename?: 'JWT' }
      & Pick<Jwt, 'accessToken' | 'refreshToken'>
    ) }
  ) }
);

export type SendResetPasswordInstructionsMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type SendResetPasswordInstructionsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendResetPasswordInstructions'>
);

export type AuthenticationInfoQueryVariables = Exact<{
  email: Scalars['String'];
  redirectPath?: Maybe<Scalars['String']>;
}>;


export type AuthenticationInfoQuery = (
  { __typename?: 'Query' }
  & { authenticationInfo: (
    { __typename?: 'AuthenticationInfo' }
    & Pick<AuthenticationInfo, 'ssoEnabled' | 'ssoSpSigninUrl' | 'ssoStrictModeEnabled'>
  ) }
);

export type DetectUserSessionQueryVariables = Exact<{ [key: string]: never; }>;


export type DetectUserSessionQuery = (
  { __typename?: 'Query' }
  & { profile: (
    { __typename?: 'Profile' }
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'id' | 'email'>
    ) }
  ) }
);

export type GetJobQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type GetJobQuery = (
  { __typename?: 'Query' }
  & { jobs: (
    { __typename?: 'JobPaginatedResults' }
    & { results: Array<Maybe<(
      { __typename?: 'Job' }
      & Pick<Job, 'id' | 'name' | 'state'>
      & { threeDFiles?: Maybe<(
        { __typename?: 'JobThreeDFiles' }
        & Pick<JobThreeDFiles, 'geometryUrl' | 'metadataUrl'>
      )> }
    )>> }
  ) }
);

export type JobSharedThreeDFilesQueryVariables = Exact<{
  jobId: Scalars['Int'];
  shareToken: Scalars['String'];
}>;


export type JobSharedThreeDFilesQuery = (
  { __typename?: 'Query' }
  & { jobSharedThreeDFiles: (
    { __typename?: 'JobSharedThreeDFiles' }
    & Pick<JobSharedThreeDFiles, 'geometryUrl' | 'metadataUrl' | 'authToken'>
  ) }
);

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = (
  { __typename?: 'Query' }
  & { profile: (
    { __typename?: 'Profile' }
    & { user: (
      { __typename?: 'User' }
      & Pick<User, 'name'>
    ) }
  ) }
);


export const AuthenticateDocument = gql`
    mutation Authenticate($email: String!, $password: String!) {
  authenticate(email: $email, password: $password) {
    jwt {
      accessToken
      refreshToken
    }
    user {
      id
      email
    }
  }
}
    `;
export type AuthenticateMutationFn = Apollo.MutationFunction<AuthenticateMutation, AuthenticateMutationVariables>;

/**
 * __useAuthenticateMutation__
 *
 * To run a mutation, you first call `useAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateMutation, { data, loading, error }] = useAuthenticateMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useAuthenticateMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateMutation, AuthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateMutation, AuthenticateMutationVariables>(AuthenticateDocument, options);
      }
export type AuthenticateMutationHookResult = ReturnType<typeof useAuthenticateMutation>;
export type AuthenticateMutationResult = Apollo.MutationResult<AuthenticateMutation>;
export type AuthenticateMutationOptions = Apollo.BaseMutationOptions<AuthenticateMutation, AuthenticateMutationVariables>;
export const AuthenticateWithCookieDocument = gql`
    mutation AuthenticateWithCookie {
  authenticateWithCookie {
    jwt {
      accessToken
      refreshToken
    }
    user {
      createdAt
      email
      id
      firstName
      lastName
      mobilePhone
      orgs {
        id
        name
        ssoConfig {
          ssoEnabled
        }
      }
    }
  }
}
    `;
export type AuthenticateWithCookieMutationFn = Apollo.MutationFunction<AuthenticateWithCookieMutation, AuthenticateWithCookieMutationVariables>;

/**
 * __useAuthenticateWithCookieMutation__
 *
 * To run a mutation, you first call `useAuthenticateWithCookieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateWithCookieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateWithCookieMutation, { data, loading, error }] = useAuthenticateWithCookieMutation({
 *   variables: {
 *   },
 * });
 */
export function useAuthenticateWithCookieMutation(baseOptions?: Apollo.MutationHookOptions<AuthenticateWithCookieMutation, AuthenticateWithCookieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthenticateWithCookieMutation, AuthenticateWithCookieMutationVariables>(AuthenticateWithCookieDocument, options);
      }
export type AuthenticateWithCookieMutationHookResult = ReturnType<typeof useAuthenticateWithCookieMutation>;
export type AuthenticateWithCookieMutationResult = Apollo.MutationResult<AuthenticateWithCookieMutation>;
export type AuthenticateWithCookieMutationOptions = Apollo.BaseMutationOptions<AuthenticateWithCookieMutation, AuthenticateWithCookieMutationVariables>;
export const CompleteUserProfileDocument = gql`
    mutation CompleteUserProfile($mobilePhone: String) {
  updateUser(user: {mobilePhone: $mobilePhone}) {
    id
  }
}
    `;
export type CompleteUserProfileMutationFn = Apollo.MutationFunction<CompleteUserProfileMutation, CompleteUserProfileMutationVariables>;

/**
 * __useCompleteUserProfileMutation__
 *
 * To run a mutation, you first call `useCompleteUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeUserProfileMutation, { data, loading, error }] = useCompleteUserProfileMutation({
 *   variables: {
 *      mobilePhone: // value for 'mobilePhone'
 *   },
 * });
 */
export function useCompleteUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<CompleteUserProfileMutation, CompleteUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteUserProfileMutation, CompleteUserProfileMutationVariables>(CompleteUserProfileDocument, options);
      }
export type CompleteUserProfileMutationHookResult = ReturnType<typeof useCompleteUserProfileMutation>;
export type CompleteUserProfileMutationResult = Apollo.MutationResult<CompleteUserProfileMutation>;
export type CompleteUserProfileMutationOptions = Apollo.BaseMutationOptions<CompleteUserProfileMutation, CompleteUserProfileMutationVariables>;
export const CreateFileStorageTokenDocument = gql`
    mutation CreateFileStorageToken($storageScope: FileStorageScopes!) {
  createFileStorageToken(storageScope: $storageScope) {
    token
  }
}
    `;
export type CreateFileStorageTokenMutationFn = Apollo.MutationFunction<CreateFileStorageTokenMutation, CreateFileStorageTokenMutationVariables>;

/**
 * __useCreateFileStorageTokenMutation__
 *
 * To run a mutation, you first call `useCreateFileStorageTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileStorageTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileStorageTokenMutation, { data, loading, error }] = useCreateFileStorageTokenMutation({
 *   variables: {
 *      storageScope: // value for 'storageScope'
 *   },
 * });
 */
export function useCreateFileStorageTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateFileStorageTokenMutation, CreateFileStorageTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFileStorageTokenMutation, CreateFileStorageTokenMutationVariables>(CreateFileStorageTokenDocument, options);
      }
export type CreateFileStorageTokenMutationHookResult = ReturnType<typeof useCreateFileStorageTokenMutation>;
export type CreateFileStorageTokenMutationResult = Apollo.MutationResult<CreateFileStorageTokenMutation>;
export type CreateFileStorageTokenMutationOptions = Apollo.BaseMutationOptions<CreateFileStorageTokenMutation, CreateFileStorageTokenMutationVariables>;
export const CreateHomeownerDocument = gql`
    mutation CreateHomeowner($distinctId: String, $orgCode: String, $user: UserArgs!) {
  createHomeowner(distinctId: $distinctId, orgCode: $orgCode, user: $user) {
    user {
      id
      email
    }
    jwt {
      accessToken
      refreshToken
    }
  }
}
    `;
export type CreateHomeownerMutationFn = Apollo.MutationFunction<CreateHomeownerMutation, CreateHomeownerMutationVariables>;

/**
 * __useCreateHomeownerMutation__
 *
 * To run a mutation, you first call `useCreateHomeownerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHomeownerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHomeownerMutation, { data, loading, error }] = useCreateHomeownerMutation({
 *   variables: {
 *      distinctId: // value for 'distinctId'
 *      orgCode: // value for 'orgCode'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateHomeownerMutation(baseOptions?: Apollo.MutationHookOptions<CreateHomeownerMutation, CreateHomeownerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHomeownerMutation, CreateHomeownerMutationVariables>(CreateHomeownerDocument, options);
      }
export type CreateHomeownerMutationHookResult = ReturnType<typeof useCreateHomeownerMutation>;
export type CreateHomeownerMutationResult = Apollo.MutationResult<CreateHomeownerMutation>;
export type CreateHomeownerMutationOptions = Apollo.BaseMutationOptions<CreateHomeownerMutation, CreateHomeownerMutationVariables>;
export const CreateProUserDocument = gql`
    mutation CreateProUser($org: OrgArgs!, $user: UserArgs!) {
  createProUser(org: $org, user: $user) {
    user {
      id
      email
    }
    jwt {
      accessToken
      refreshToken
    }
  }
}
    `;
export type CreateProUserMutationFn = Apollo.MutationFunction<CreateProUserMutation, CreateProUserMutationVariables>;

/**
 * __useCreateProUserMutation__
 *
 * To run a mutation, you first call `useCreateProUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProUserMutation, { data, loading, error }] = useCreateProUserMutation({
 *   variables: {
 *      org: // value for 'org'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useCreateProUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateProUserMutation, CreateProUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProUserMutation, CreateProUserMutationVariables>(CreateProUserDocument, options);
      }
export type CreateProUserMutationHookResult = ReturnType<typeof useCreateProUserMutation>;
export type CreateProUserMutationResult = Apollo.MutationResult<CreateProUserMutation>;
export type CreateProUserMutationOptions = Apollo.BaseMutationOptions<CreateProUserMutation, CreateProUserMutationVariables>;
export const SendResetPasswordInstructionsDocument = gql`
    mutation SendResetPasswordInstructions($email: String!) {
  sendResetPasswordInstructions(email: $email)
}
    `;
export type SendResetPasswordInstructionsMutationFn = Apollo.MutationFunction<SendResetPasswordInstructionsMutation, SendResetPasswordInstructionsMutationVariables>;

/**
 * __useSendResetPasswordInstructionsMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordInstructionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordInstructionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordInstructionsMutation, { data, loading, error }] = useSendResetPasswordInstructionsMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendResetPasswordInstructionsMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordInstructionsMutation, SendResetPasswordInstructionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordInstructionsMutation, SendResetPasswordInstructionsMutationVariables>(SendResetPasswordInstructionsDocument, options);
      }
export type SendResetPasswordInstructionsMutationHookResult = ReturnType<typeof useSendResetPasswordInstructionsMutation>;
export type SendResetPasswordInstructionsMutationResult = Apollo.MutationResult<SendResetPasswordInstructionsMutation>;
export type SendResetPasswordInstructionsMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordInstructionsMutation, SendResetPasswordInstructionsMutationVariables>;
export const AuthenticationInfoDocument = gql`
    query AuthenticationInfo($email: String!, $redirectPath: String) {
  authenticationInfo(email: $email, redirectPath: $redirectPath) {
    ssoEnabled
    ssoSpSigninUrl
    ssoStrictModeEnabled
  }
}
    `;

/**
 * __useAuthenticationInfoQuery__
 *
 * To run a query within a React component, call `useAuthenticationInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthenticationInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthenticationInfoQuery({
 *   variables: {
 *      email: // value for 'email'
 *      redirectPath: // value for 'redirectPath'
 *   },
 * });
 */
export function useAuthenticationInfoQuery(baseOptions: Apollo.QueryHookOptions<AuthenticationInfoQuery, AuthenticationInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthenticationInfoQuery, AuthenticationInfoQueryVariables>(AuthenticationInfoDocument, options);
      }
export function useAuthenticationInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthenticationInfoQuery, AuthenticationInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthenticationInfoQuery, AuthenticationInfoQueryVariables>(AuthenticationInfoDocument, options);
        }
export type AuthenticationInfoQueryHookResult = ReturnType<typeof useAuthenticationInfoQuery>;
export type AuthenticationInfoLazyQueryHookResult = ReturnType<typeof useAuthenticationInfoLazyQuery>;
export type AuthenticationInfoQueryResult = Apollo.QueryResult<AuthenticationInfoQuery, AuthenticationInfoQueryVariables>;
export const DetectUserSessionDocument = gql`
    query DetectUserSession {
  profile {
    user {
      id
      email
    }
  }
}
    `;

/**
 * __useDetectUserSessionQuery__
 *
 * To run a query within a React component, call `useDetectUserSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetectUserSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetectUserSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useDetectUserSessionQuery(baseOptions?: Apollo.QueryHookOptions<DetectUserSessionQuery, DetectUserSessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DetectUserSessionQuery, DetectUserSessionQueryVariables>(DetectUserSessionDocument, options);
      }
export function useDetectUserSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetectUserSessionQuery, DetectUserSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DetectUserSessionQuery, DetectUserSessionQueryVariables>(DetectUserSessionDocument, options);
        }
export type DetectUserSessionQueryHookResult = ReturnType<typeof useDetectUserSessionQuery>;
export type DetectUserSessionLazyQueryHookResult = ReturnType<typeof useDetectUserSessionLazyQuery>;
export type DetectUserSessionQueryResult = Apollo.QueryResult<DetectUserSessionQuery, DetectUserSessionQueryVariables>;
export const GetJobDocument = gql`
    query GetJob($id: Int!) {
  jobs(ids: [$id]) {
    results {
      id
      name
      state
      threeDFiles {
        geometryUrl
        metadataUrl
      }
    }
  }
}
    `;

/**
 * __useGetJobQuery__
 *
 * To run a query within a React component, call `useGetJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetJobQuery(baseOptions: Apollo.QueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
      }
export function useGetJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobQuery, GetJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobQuery, GetJobQueryVariables>(GetJobDocument, options);
        }
export type GetJobQueryHookResult = ReturnType<typeof useGetJobQuery>;
export type GetJobLazyQueryHookResult = ReturnType<typeof useGetJobLazyQuery>;
export type GetJobQueryResult = Apollo.QueryResult<GetJobQuery, GetJobQueryVariables>;
export const JobSharedThreeDFilesDocument = gql`
    query JobSharedThreeDFiles($jobId: Int!, $shareToken: String!) {
  jobSharedThreeDFiles(jobId: $jobId, shareToken: $shareToken) {
    geometryUrl
    metadataUrl
    authToken
  }
}
    `;

/**
 * __useJobSharedThreeDFilesQuery__
 *
 * To run a query within a React component, call `useJobSharedThreeDFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobSharedThreeDFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobSharedThreeDFilesQuery({
 *   variables: {
 *      jobId: // value for 'jobId'
 *      shareToken: // value for 'shareToken'
 *   },
 * });
 */
export function useJobSharedThreeDFilesQuery(baseOptions: Apollo.QueryHookOptions<JobSharedThreeDFilesQuery, JobSharedThreeDFilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobSharedThreeDFilesQuery, JobSharedThreeDFilesQueryVariables>(JobSharedThreeDFilesDocument, options);
      }
export function useJobSharedThreeDFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobSharedThreeDFilesQuery, JobSharedThreeDFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobSharedThreeDFilesQuery, JobSharedThreeDFilesQueryVariables>(JobSharedThreeDFilesDocument, options);
        }
export type JobSharedThreeDFilesQueryHookResult = ReturnType<typeof useJobSharedThreeDFilesQuery>;
export type JobSharedThreeDFilesLazyQueryHookResult = ReturnType<typeof useJobSharedThreeDFilesLazyQuery>;
export type JobSharedThreeDFilesQueryResult = Apollo.QueryResult<JobSharedThreeDFilesQuery, JobSharedThreeDFilesQueryVariables>;
export const ProfileDocument = gql`
    query Profile {
  profile {
    user {
      name
    }
  }
}
    `;

/**
 * __useProfileQuery__
 *
 * To run a query within a React component, call `useProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileQuery(baseOptions?: Apollo.QueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
      }
export function useProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileQuery, ProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileQuery, ProfileQueryVariables>(ProfileDocument, options);
        }
export type ProfileQueryHookResult = ReturnType<typeof useProfileQuery>;
export type ProfileLazyQueryHookResult = ReturnType<typeof useProfileLazyQuery>;
export type ProfileQueryResult = Apollo.QueryResult<ProfileQuery, ProfileQueryVariables>;